(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["0-0-0-0-bogo-crea"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bgc');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bgcInit === '1') continue;
      el.dataset.bgcInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bgc]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bgc__plan-card');
    var qtyRows   = root.querySelectorAll('.bgc__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bgc-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bgc-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bgc__qty-row[data-qty="2"] .bgc__qty-extra');
    var ctaBtn    = root.querySelector('.bgc__cta');
    var fitRaf    = null;

    // ---- Variant selector (renders only when product has >1 variant) ----
    var idInput     = root.querySelector('input[name="id"]');
    var wasPrefix   = root.dataset.wasPrefix || 'was';
    var variantBtns = root.querySelectorAll('.bgc__variant');
    var vmap        = {};
    var vscript     = root.querySelector('[id^="bgc-vd-"]');
    if (vscript){ try { vmap = JSON.parse(vscript.textContent); } catch(e){ vmap = {}; } }
    var curAvail    = true;

    // Gift: the bar's copy is entirely static now, so the only thing JS needs
    // is (a) whether a gift exists at all and (b) the CTA subline suffix.
    // giftBar is read as a presence flag, never mutated.
    var giftBar            = root.querySelector('.bgc__gift-bar');
    var giftCtaSuffix      = root.dataset.giftCtaSuffix      || 'Includes 2 FREE Gifts';
    var giftCtaSuffixShort = root.dataset.giftCtaSuffixShort || '2 FREE Gifts included';

    // Mobile: size the CTA text as large as possible while staying on one line.
    // Text length varies per plan/qty, so this re-runs after every render and on resize.
    function fitCta(){
      if (!ctaBtn || !ctaText) return;
      if (!window.matchMedia || !window.matchMedia('(max-width: 720px)').matches){
        ctaBtn.style.removeProperty('font-size');
        return;
      }
      if (!ctaBtn.clientWidth) return; // not laid out yet — next render/resize retries
      var cs = window.getComputedStyle(ctaBtn);
      var icon = ctaBtn.querySelector('svg');
      var iconW = icon ? icon.getBoundingClientRect().width : 0;
      var gap = parseFloat(cs.columnGap) || 8;
      var avail = ctaBtn.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0) - (iconW ? iconW + gap : 0) - 2;
      if (avail <= 0) return;
      var base = 20;
      ctaBtn.style.setProperty('font-size', base + 'px', 'important');
      var w = ctaText.getBoundingClientRect().width;
      if (!w){ ctaBtn.style.removeProperty('font-size'); return; }
      var size = Math.min(29.6, Math.max(14, Math.floor(base * avail / w * 10) / 10));
      ctaBtn.style.setProperty('font-size', size + 'px', 'important');
      var w2 = ctaText.getBoundingClientRect().width;
      if (w2 > avail){
        size = Math.max(14, Math.floor(size * avail / w2 * 10) / 10);
        ctaBtn.style.setProperty('font-size', size + 'px', 'important');
      }
    }

    function getActiveQtyRow(){
      return root.querySelector('.bgc__qty-row.is-on') || qtyRows[0];
    }

    // Mobile: shrink each variant name until it fits its button on one line.
    // Runs after every render and on resize. Modeled on fitCta().
    function fitVariants(){
      if (!variantBtns.length) return;
      for (var i = 0; i < variantBtns.length; i++){
        var btn = variantBtns[i];
        var label = btn.querySelector('.bgc__variant-name');
        if (!label) continue;
        label.classList.remove('is-wrap');
        label.style.removeProperty('font-size');
        if (!btn.clientWidth) continue; // not laid out yet — next render/resize retries
        var cs = window.getComputedStyle(btn);
        var avail = btn.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0) - 1;
        if (avail <= 0) continue;
        var w = label.scrollWidth;
        if (!w || w <= avail) continue;
        var base = parseFloat(window.getComputedStyle(label).fontSize) || 15;
        var size = Math.max(10, Math.floor(base * avail / w * 10) / 10);
        label.style.setProperty('font-size', size + 'px');
        if (label.scrollWidth > avail){
          size = Math.max(10, Math.floor(size * avail / label.scrollWidth * 10) / 10);
          label.style.setProperty('font-size', size + 'px');
        }
        if (label.scrollWidth > avail + 1){
          label.classList.add('is-wrap'); // floor font still too wide — wrap instead of bleeding past the button
        }
      }
    }

    // Push a selected variant's numbers into the qty rows + hidden id + "was" prices + gallery.
    function applyVariant(id){
      var d = vmap[id];
      if (!d) return;
      if (idInput) idInput.value = id;
      curAvail = d.avail !== false;
      for (var r = 0; r < qtyRows.length; r++){
        var row = qtyRows[r];
        var n = parseInt(row.dataset.qty, 10);
        var k = n - 1;
        if (k < 0 || k > 2) continue;
        if (d.once)     row.dataset.oncePrice = d.once[k];
        if (d.oncedisc) row.dataset.onceDisc  = d.oncedisc[k];
        if (d.sub)      row.dataset.subPrice   = d.sub[k];
        if (d.subdisc)  row.dataset.subDisc    = d.subdisc[k];
        if (d.plan)     row.dataset.subPlan    = d.plan[k] || '';
        var wasEl = row.querySelector('.bgc__qty-was');
        if (wasEl && d.base){ wasEl.textContent = wasPrefix + ' ' + fmt(d.base); }
      }
      // Gallery: if this variant has a featured image matching a thumb, activate it.
      // No-ops safely when the product doesn't use per-variant images.
      if (d.img && typeof selectVariantSlide === 'function'){ selectVariantSlide(d.img); }
    }

    // The donor's renderGift() lived here. It swapped the bar between an
    // active and a grayed-out state as the plan changed. The gifts now apply
    // to every order, so there is nothing left to re-render — the bar and the
    // gallery badge are static markup.

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bgc__qty-now');
        var saveEl  = b.querySelector('.bgc__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        // Rebuild subline. The gift suffix appends on BOTH plans now — the
        // donor gated it on plan === 'sub', which would have told a one-time
        // shopper their gifts weren't coming. On narrow screens the gift
        // leads, so it can never be the truncated tail, and the plan
        // boilerplate is dropped to buy the room.
        var narrow = window.matchMedia && window.matchMedia('(max-width: 480px)').matches;
        var planLine = (plan === 'sub')
          ? days + '-day supply · Auto-Ship selected'
          : days + '-day supply · One-time purchase, no Auto-Ship';

        if (!giftBar){
          ctaSub.textContent = planLine;
        } else {
          // Assembled from DOM nodes rather than innerHTML so merchant-entered
          // copy can never be parsed as markup.
          while (ctaSub.firstChild) ctaSub.removeChild(ctaSub.firstChild);
          var giftSpan = document.createElement('span');
          giftSpan.className = 'bgc__cta-gift';
          if (narrow){
            giftSpan.textContent = giftCtaSuffixShort;
            ctaSub.appendChild(giftSpan);
            ctaSub.appendChild(document.createTextNode(' · ' + days + '-day supply'));
          } else {
            ctaSub.appendChild(document.createTextNode(planLine));
            giftSpan.textContent = ' · ' + giftCtaSuffix;
            ctaSub.appendChild(giftSpan);
          }
        }
      }

      // Sold-out variant wins over everything
      if (ctaBtn){
        if (curAvail === false){
          ctaBtn.disabled = true;
          ctaBtn.style.opacity = '0.55';
          ctaBtn.style.cursor = 'not-allowed';
          if (ctaText) ctaText.textContent = 'Sold Out';
          if (ctaSub)  ctaSub.textContent  = 'This option is currently out of stock';
        } else {
          ctaBtn.disabled = false;
          ctaBtn.style.opacity = '';
          ctaBtn.style.cursor = '';
        }
      }

      fitCta();
      fitVariants();
    }

    // Variant button bindings
    for (var vb2 = 0; vb2 < variantBtns.length; vb2++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          for (var x = 0; x < variantBtns.length; x++){
            var on = variantBtns[x] === btn;
            variantBtns[x].classList.toggle('is-on', on);
            variantBtns[x].setAttribute('aria-checked', on ? 'true' : 'false');
          }
          applyVariant(btn.dataset.variantId);
          render();
        });
      })(variantBtns[vb2]);
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // The donor bound click + keydown on the gift bar to switch a one-time
    // shopper onto a subscription to "claim" the gift. There is nothing to
    // claim here — both plans get both gifts — so the bar is inert and those
    // listeners are gone along with its role/tabindex.

    // Gallery
    var mainBox = root.querySelector('.bgc__main');
    var main = root.querySelector('.bgc__main img');
    var countEl = root.querySelector('[id^="bgc-count-"]');
    var thumbsContainer = root.querySelector('.bgc__thumbs');
    var thumbs = root.querySelectorAll('.bgc__thumb');
    var prev = root.querySelector('[id^="bgc-prev-"]');
    var next = root.querySelector('[id^="bgc-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Variant → gallery: activate the slide whose thumb matches this variant's
    // featured image (compared on the base src, query-string stripped). No-ops
    // safely when the product doesn't use per-variant images.
    function selectVariantSlide(imgUrl){
      if (!imgUrl || !thumbs.length) return;
      var target = String(imgUrl).split('?')[0];
      for (var s = 0; s < thumbs.length; s++){
        var tsrc = thumbs[s].dataset.src || '';
        if (tsrc.split('?')[0] === target){ setSlide(s); return; }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bgcDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bgcDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bgcDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bgcDragged = false; }, 100);
        } else {
          thumbsContainer._bgcDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bgcDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    // Sync qty rows to the initially-selected variant, then paint.
    if (idInput && vmap[idInput.value]) applyVariant(idInput.value);
    render();

    // Re-fit CTA once real fonts finish loading (metrics shift) and on any resize/rotation
    if (document.fonts && document.fonts.ready && document.fonts.ready.then){
      document.fonts.ready.then(function(){ fitCta(); fitVariants(); });
    }
    window.addEventListener('resize', function(){
      if (window.requestAnimationFrame){
        if (fitRaf) cancelAnimationFrame(fitRaf);
        fitRaf = requestAnimationFrame(function(){ render(); });
      } else {
        render();
      }
    });
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["0-0-26-premiumshirts"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    // ===== Variants data =====
    var variants = [];
    var variantsScript = document.querySelector('script[data-bbx-variants="' + (root.id || '').replace('bbx-', '') + '"]');
    if (!variantsScript){
      // Fallback: find first variants script (single-section pages)
      variantsScript = document.querySelector('script[data-bbx-variants]');
    }
    if (variantsScript){
      try { variants = JSON.parse(variantsScript.textContent); } catch(e){}
    }

    // ===== Refs =====
    var optionGroups = root.querySelectorAll('.bbx__variant-group');
    var variantIdInput = root.querySelector('input[name="id"]');
    var qtyHiddenInput = root.querySelector('input[name="quantity"]');
    var qtyDisplay = root.querySelector('[data-qty-input]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var priceNowEl = root.querySelector('[data-bbx-price-now]');
    var priceWasEl = root.querySelector('[data-bbx-price-was]');
    var priceSaveEl = root.querySelector('[data-bbx-price-save]');
    var ctaBtn = root.querySelector('[data-bbx-cta]');
    var ctaText = root.querySelector('[data-bbx-cta-text]');
    var main = root.querySelector('.bbx__main img');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var mainBox = root.querySelector('.bbx__main');

    // Main image is never cropped, so the frame height follows the image's own
    // ratio. Push the incoming intrinsic size BEFORE the src so the browser
    // reserves the right box and the gallery doesn't pop on swap.
    function setMainImage(src, w, h){
      if (!main || !src) return;
      if (w && h){
        main.setAttribute('width', w);
        main.setAttribute('height', h);
      }
      main.src = src;
    }

    // ===== Premium-shirts refs (quality / size chart) =====
    var qGroupEl = root.querySelector('[data-bbx-quality]');
    var qIdx = qGroupEl ? parseInt(qGroupEl.dataset.optionIdx, 10) : -1;
    var benefitSets = root.querySelectorAll('[data-bbx-benefit-set]');
    var qbenefitsWrap = root.querySelector('[data-bbx-qbenefits]');

    // ===== Size refs (dynamic "Sizes X-Y" range + per-combination availability) =====
    var sizeGroupEl = root.querySelector('[data-bbx-size]');
    var sizeIdx = sizeGroupEl ? parseInt(sizeGroupEl.dataset.optionIdx, 10) : -1;
    var subtitleEl = root.querySelector('[data-bbx-subtitle]') || root.querySelector('.bbx__subtitle');
    var chartImgs = root.querySelectorAll('[data-bbx-chart-img]');
    var lightbox = root.querySelector('[data-bbx-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-bbx-lightbox-img]') : null;
    var premChartUrl = root.getAttribute('data-bbx-premium-chart') || '';
    var stdChartUrl = root.getAttribute('data-bbx-standard-chart') || '';
    var premChartMobileUrl = root.getAttribute('data-bbx-premium-chart-mobile') || '';
    var stdChartMobileUrl = root.getAttribute('data-bbx-standard-chart-mobile') || '';
    var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    var qty = 1;
    var idx = 0;

    // ===== Initial selection state (from server-rendered .is-on classes) =====
    var selectedValues = [];
    for (var g = 0; g < optionGroups.length; g++){
      var group = optionGroups[g];
      var oIdx = parseInt(group.dataset.optionIdx, 10);
      var selectedBtn = group.querySelector('[data-value].is-on');
      selectedValues[oIdx] = selectedBtn ? selectedBtn.dataset.value : null;
    }

    function findVariant(sel){
      if (!variants.length) return null;
      // If no options at all (selectedValues empty), return first variant
      if (sel.length === 0) return variants[0];
      for (var i = 0; i < variants.length; i++){
        var v = variants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++){
          if (v.options[j] !== sel[j]){ match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    // ===== Quality + size-chart helpers =====
    function currentQuality(){
      if (qIdx < 0) return 'premium';
      var val = (selectedValues[qIdx] || '').toString().toLowerCase().replace(/^\s+|\s+$/g, '');
      return val === 'standard' ? 'standard' : 'premium';
    }
    function applyQuality(){
      var q = currentQuality();
      for (var bi = 0; bi < benefitSets.length; bi++){
        if (benefitSets[bi].getAttribute('data-bbx-benefit-set') === q) benefitSets[bi].classList.add('is-active');
        else benefitSets[bi].classList.remove('is-active');
      }
      if (qbenefitsWrap){
        if (q === 'premium') qbenefitsWrap.classList.add('is-premium');
        else qbenefitsWrap.classList.remove('is-premium');
      }
      var mob = !!(mqMobile && mqMobile.matches);
      var premU = (mob && premChartMobileUrl) ? premChartMobileUrl : premChartUrl;
      var stdU  = (mob && stdChartMobileUrl) ? stdChartMobileUrl : stdChartUrl;
      var url = (q === 'standard') ? (stdU || premU) : (premU || stdU);
      root._bbxChartUrl = url;
      for (var ci = 0; ci < chartImgs.length; ci++){
        if (url && chartImgs[ci].getAttribute('src') !== url) chartImgs[ci].setAttribute('src', url);
      }
    }

    // ===== Size helpers =====
    // Rank size labels so we can find the smallest/largest offered size for the range.
    function sizeRank(label){
      var s = String(label == null ? '' : label).toLowerCase().replace(/[\s._\/-]/g, '');
      var map = {
        'xxxs':-3,'3xs':-3,'xxs':-2,'2xs':-2,
        'xs':-1,'xsmall':-1,'extrasmall':-1,
        's':0,'small':0,'sm':0,
        'm':1,'medium':1,'med':1,'md':1,
        'l':2,'large':2,'lg':2,
        'xl':3,'xlarge':3,'extralarge':3,'1xl':3,'1x':3,
        'xxl':4,'2xl':4,'2x':4,'xxlarge':4,
        'xxxl':5,'3xl':5,'3x':5,
        'xxxxl':6,'4xl':6,'4x':6,
        'xxxxxl':7,'5xl':7,'5x':7,
        '6xl':8,'6x':8,'7xl':9,'7x':9
      };
      if (Object.prototype.hasOwnProperty.call(map, s)) return map[s];
      var m = s.match(/^(\d+)x?l?$/); // 2xl, 3xl, 10xl, ...
      if (m) return 3 + (parseInt(m[1], 10) - 1);
      return null; // unknown — sorts to the end, never breaks the range
    }
    // A size matches the current selection if every NON-size option equals what's picked.
    function nonSizeOptionsMatch(v){
      for (var j = 0; j < v.options.length; j++){
        if (j === sizeIdx) continue;
        if (selectedValues[j] != null && v.options[j] !== selectedValues[j]) return false;
      }
      return true;
    }
    function sizeState(sizeValue){
      var offered = false, available = false;
      for (var i = 0; i < variants.length; i++){
        var v = variants[i];
        if (v.options[sizeIdx] !== sizeValue) continue;
        if (!nonSizeOptionsMatch(v)) continue;
        offered = true;                       // a variant exists for this size in the current combo
        if (v.available){ available = true; break; } // ...and it's in stock
      }
      return { offered: offered, available: available };
    }
    // Inject the live range into the subtitle. Prefers a {sizes} token span; otherwise
    // rewrites an existing "Sizes …" run once, then keeps updating that span.
    function updateSubtitleRange(range){
      if (!subtitleEl || !range) return;
      var span = subtitleEl.querySelector('[data-bbx-size-range]');
      if (span){ span.textContent = range; return; }
      if (!subtitleEl._bbxSizeWrapped){
        subtitleEl._bbxSizeWrapped = true;
        var html = subtitleEl.innerHTML;
        var re = /(sizes?\s+)([0-9a-z]+(?:\s*(?:-|–|—|to)\s*[0-9a-z]+)?)/i;
        if (re.test(html)){
          subtitleEl.innerHTML = html.replace(re, '$1<span data-bbx-size-range></span>');
          var sp = subtitleEl.querySelector('[data-bbx-size-range]');
          if (sp) sp.textContent = range;
        }
      }
    }
    function updateSizeAvailability(){
      if (sizeIdx < 0 || !sizeGroupEl) return;
      var pills = sizeGroupEl.querySelectorAll('[data-value]');
      var offered = [];
      for (var p = 0; p < pills.length; p++){
        var pill = pills[p];
        var st = sizeState(pill.dataset.value);
        if (st.available){
          pill.classList.remove('is-unavailable');
          pill.removeAttribute('aria-disabled');
        } else {
          // Not offered OR sold out in this combo → grayed + crossed-out, not selectable
          pill.classList.add('is-unavailable');
          pill.setAttribute('aria-disabled', 'true');
        }
        if (st.offered) offered.push(pill.dataset.value);
      }
      // Range = the OFFERED sizes for this combo (in stock or not), smallest → largest
      var range = null;
      if (offered.length){
        var sorted = offered.slice().sort(function(a, b){
          var ra = sizeRank(a), rb = sizeRank(b);
          if (ra == null && rb == null) return 0;
          if (ra == null) return 1;
          if (rb == null) return -1;
          return ra - rb;
        });
        var lo = sorted[0], hi = sorted[sorted.length - 1];
        range = (lo === hi) ? lo : (lo + '-' + hi);
      }
      updateSubtitleRange(range);
    }

    function render(){
      var v = findVariant(selectedValues);

      // Update form variant ID
      if (v && variantIdInput) variantIdInput.value = String(v.id);

      // Update URL ?variant=ID
      if (v && window.history && window.history.replaceState){
        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(null, '', url);
        } catch(e){}
      }

      // Swap main image to variant's featured_image
      if (v && v.featured_image && main && main.src !== v.featured_image){
        setMainImage(v.featured_image, v.featured_image_width, v.featured_image_height);
        // Sync gallery idx to that image if it's in the thumb list
        for (var t = 0; t < thumbs.length; t++){
          if (thumbs[t].dataset.src === v.featured_image){
            idx = t;
            for (var tt = 0; tt < thumbs.length; tt++) thumbs[tt].classList.remove('is-on');
            thumbs[t].classList.add('is-on');
            if (countEl) countEl.textContent = (t+1) + ' / ' + thumbs.length;
            break;
          }
        }
      }

      // Update price + savings (multiply by qty)
      var price = v ? v.price : 0;
      var compare = v ? v.compare_at_price : 0;
      var total = price * qty;
      var totalCompare = compare * qty;

      if (priceNowEl) priceNowEl.textContent = fmt(total);

      if (priceWasEl){
        if (compare > price){
          priceWasEl.textContent = fmt(totalCompare);
          priceWasEl.style.display = '';
        } else {
          priceWasEl.textContent = '';
          priceWasEl.style.display = 'none';
        }
      }

      if (priceSaveEl){
        if (compare > price){
          var savings = Math.round((compare - price) / compare * 100 / 5) * 5;
          priceSaveEl.textContent = 'SAVE ' + savings + '%';
          priceSaveEl.style.display = '';
        } else {
          priceSaveEl.textContent = '';
          priceSaveEl.style.display = 'none';
        }
      }

      // Update CTA (state + label)
      var addLabel = root.dataset.ctaAdd || 'Add to Cart';
      var soldoutLabel = root.dataset.ctaSoldout || 'Sold Out';
      var unavailLabel = root.dataset.ctaUnavailable || 'Unavailable';

      var available = v && v.available;
      if (ctaBtn){
        if (!available){
          ctaBtn.classList.add('is-soldout');
          ctaBtn.disabled = true;
        } else {
          ctaBtn.classList.remove('is-soldout');
          ctaBtn.disabled = false;
        }
      }
      if (ctaText){
        if (!v){
          ctaText.textContent = unavailLabel;
        } else if (!v.available){
          ctaText.textContent = soldoutLabel;
        } else {
          ctaText.textContent = addLabel + ' · ' + fmt(window.AJVIP ? window.AJVIP.cta(root, total) : total);
        }
      }

      // Update inline "selected value" display in each variant group label
      for (var i = 0; i < optionGroups.length; i++){
        var group = optionGroups[i];
        var dispEl = group.querySelector('[data-option-value-display]');
        var oIdx = parseInt(group.dataset.optionIdx, 10);
        if (dispEl) dispEl.textContent = selectedValues[oIdx] || '';
      }

      // Premium-shirts: swap bullets + size chart to match selected Quality
      applyQuality();

      // Recompute Size availability for the current Color/Quality + refresh the "Sizes X-Y" line
      updateSizeAvailability();
    }

    // ===== Bind variant option clicks (swatches + pills) =====
    var optionBtns = root.querySelectorAll('[data-option-idx][data-value]');
    for (var k = 0; k < optionBtns.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (btn.classList.contains('is-unavailable')) return;
          var oIdx = parseInt(btn.dataset.optionIdx, 10);
          var value = btn.dataset.value;
          selectedValues[oIdx] = value;
          // Toggle is-on among siblings of the same option group
          var siblings = root.querySelectorAll('[data-option-idx="' + oIdx + '"][data-value]');
          for (var s = 0; s < siblings.length; s++) siblings[s].classList.remove('is-on');
          btn.classList.add('is-on');
          render();
        });
      })(optionBtns[k]);
    }

    // ===== Size chart lightbox =====
    function openChart(){
      if (!lightbox || (mqMobile && mqMobile.matches)) return;
      var url = root._bbxChartUrl || premChartUrl || stdChartUrl || premChartMobileUrl || stdChartMobileUrl;
      if (!url) return;
      // Portal to <body> so a transformed/overflow ancestor can't trap position:fixed (which kills the full-screen overlay)
      if (lightbox.parentNode !== document.body){
        var dupes = document.body.querySelectorAll('.bbx__lightbox');
        for (var dn = 0; dn < dupes.length; dn++){
          if (dupes[dn] !== lightbox && dupes[dn].id === lightbox.id && dupes[dn].parentNode){ dupes[dn].parentNode.removeChild(dupes[dn]); }
        }
        document.body.appendChild(lightbox);
      }
      if (lightboxImg) lightboxImg.setAttribute('src', url);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      void lightbox.offsetWidth; // reflow so the transition runs
      lightbox.classList.add('is-open');
      try { document.documentElement.style.overflow = 'hidden'; } catch(e){}
    }
    function closeChart(){
      if (!lightbox || lightbox.hidden) return;
      lightbox.classList.remove('is-open');
      try { document.documentElement.style.overflow = ''; } catch(e){}
      if (reduceMotion){
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
      } else {
        setTimeout(function(){
          if (!lightbox.classList.contains('is-open')){
            lightbox.hidden = true;
            lightbox.setAttribute('aria-hidden', 'true');
          }
        }, 300);
      }
    }
    function chartTrigger(){
      if (mqMobile && mqMobile.matches){
        // No lightbox on mobile — scroll to the inline chart (above the FAQ) instead
        var t = root.querySelector('.bbx__sizechart--mobile') || root.querySelector('[data-bbx-sizechart]');
        if (t && t.scrollIntoView){ try { t.scrollIntoView({behavior:'smooth', block:'center'}); } catch(e){ t.scrollIntoView(); } }
      } else {
        openChart();
      }
    }
    var openChartBtns = root.querySelectorAll('[data-bbx-open-chart]');
    for (var oc = 0; oc < openChartBtns.length; oc++){
      openChartBtns[oc].addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); chartTrigger(); });
    }
    if (lightbox){
      var lbClosers = lightbox.querySelectorAll('[data-bbx-lightbox-close]');
      for (var lc = 0; lc < lbClosers.length; lc++){
        lbClosers[lc].addEventListener('click', function(ev){ ev.preventDefault(); closeChart(); });
      }
    }

    // Re-pick chart art when crossing the mobile breakpoint (desktop <-> mobile PNG)
    if (mqMobile){
      var onViewport = function(){
        applyQuality();
        if (lightbox && !lightbox.hidden && lightboxImg && root._bbxChartUrl){ lightboxImg.setAttribute('src', root._bbxChartUrl); }
      };
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', onViewport);
      else if (mqMobile.addListener) mqMobile.addListener(onViewport);
    }

    // ===== Quality (i) tooltip (tap to toggle; hover handled by CSS) =====
    var qinfoBtn = root.querySelector('[data-bbx-qinfo]');
    var qinfoWrap = root.querySelector('.bbx__qinfo-wrap');
    if (qinfoBtn && qinfoWrap){
      qinfoBtn.addEventListener('click', function(ev){
        ev.preventDefault(); ev.stopPropagation();
        var open = qinfoWrap.classList.toggle('is-open');
        qinfoBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    // ===== Global close handlers (tooltip + lightbox) =====
    document.addEventListener('keydown', function(ev){
      if (ev.key === 'Escape' || ev.keyCode === 27){
        closeChart();
        if (qinfoWrap){ qinfoWrap.classList.remove('is-open'); if (qinfoBtn) qinfoBtn.setAttribute('aria-expanded', 'false'); }
      }
    });
    document.addEventListener('click', function(ev){
      if (qinfoWrap && qinfoWrap.classList.contains('is-open') && !qinfoWrap.contains(ev.target)){
        qinfoWrap.classList.remove('is-open');
        if (qinfoBtn) qinfoBtn.setAttribute('aria-expanded', 'false');
      }
    });

    // ===== Quantity stepper =====
    function setQty(n){
      n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      qty = n;
      if (qtyDisplay) qtyDisplay.value = String(n);
      if (qtyHiddenInput) qtyHiddenInput.value = String(n);
      if (qtyMinus) qtyMinus.disabled = n <= 1;
      render();
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty + 1); });
    if (qtyDisplay){
      qtyDisplay.addEventListener('change', function(){ setQty(qtyDisplay.value); });
      qtyDisplay.addEventListener('input', function(){
        var v = parseInt(qtyDisplay.value, 10);
        if (!isNaN(v)){ qty = Math.max(1, Math.min(99, v)); if (qtyHiddenInput) qtyHiddenInput.value = String(qty); render(); }
      });
    }

    // ===== Form submit guard =====
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form){
      form.addEventListener('submit', function(ev){
        if (ctaBtn && ctaBtn.disabled){ ev.preventDefault(); }
      });
    }

    // ===== Gallery =====
    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      setMainImage(src, thumbs[idx].dataset.w, thumbs[idx].dataset.h);
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try { active.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); } catch(e){
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    for (var k2 = 0; k2 < thumbs.length; k2++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k2);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // ===== Drag-to-scroll on thumb strip (desktop) =====
    if (thumbsContainer && thumbs.length > 1){
      var tDown=false, tStartX=0, tStartScroll=0, tMoved=false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true; tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){ tDown = false; thumbsContainer._bbxDragged = false; }
      });
    }

    // ===== Main image swipe (touch + mouse drag) =====
    if (mainBox && thumbs.length > 1){
      var sx=0, sy=0, swiping=false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, {passive:true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive:true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive:true});

      var mx=0, my=0, mdown=false, mmoved=false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true; mmoved = false; mx = e.clientX; my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    setQty(1);
    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["0-0-a76shirt"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    // ===== Variants data =====
    var variants = [];
    var variantsScript = document.querySelector('script[data-bbx-variants="' + (root.id || '').replace('bbx-', '') + '"]');
    if (!variantsScript){
      // Fallback: find first variants script (single-section pages)
      variantsScript = document.querySelector('script[data-bbx-variants]');
    }
    if (variantsScript){
      try { variants = JSON.parse(variantsScript.textContent); } catch(e){}
    }

    // ===== Refs =====
    var optionGroups = root.querySelectorAll('.bbx__variant-group');
    var variantIdInput = root.querySelector('input[name="id"]');
    var qtyHiddenInput = root.querySelector('input[name="quantity"]');
    var qtyDisplay = root.querySelector('[data-qty-input]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var priceNowEl = root.querySelector('[data-bbx-price-now]');
    var priceWasEl = root.querySelector('[data-bbx-price-was]');
    var priceSaveEl = root.querySelector('[data-bbx-price-save]');
    var ctaBtn = root.querySelector('[data-bbx-cta]');
    var ctaText = root.querySelector('[data-bbx-cta-text]');
    var main = root.querySelector('.bbx__main img');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var mainBox = root.querySelector('.bbx__main');

    // ===== Size-chart refs (premium-only: single chart, desktop lightbox) =====
    var chartImgs = root.querySelectorAll('[data-bbx-chart-img]');
    var lightbox = root.querySelector('[data-bbx-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-bbx-lightbox-img]') : null;
    var chartUrl = root.getAttribute('data-bbx-chart') || '';
    var chartMobileUrl = root.getAttribute('data-bbx-chart-mobile') || '';
    var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    var qty = 1;
    var idx = 0;

    // ===== Initial selection state (from server-rendered .is-on classes) =====
    var selectedValues = [];
    for (var g = 0; g < optionGroups.length; g++){
      var group = optionGroups[g];
      var oIdx = parseInt(group.dataset.optionIdx, 10);
      var selectedBtn = group.querySelector('[data-value].is-on');
      selectedValues[oIdx] = selectedBtn ? selectedBtn.dataset.value : null;
    }

    // ===== Size refs (dynamic "Sizes X-Y" range + per-combination availability) =====
    var sizeGroupEl = root.querySelector('[data-bbx-size]');
    var sizeIdx = sizeGroupEl ? parseInt(sizeGroupEl.dataset.optionIdx, 10) : -1;
    var subtitleEl = root.querySelector('[data-bbx-subtitle]') || root.querySelector('.bbx__subtitle');

    // ===== A76 color → image filter =====
    // Find the "Color" variant option group (if the product has one).
    var colorIdx = -1, hasColorOption = false;
    for (var cg = 0; cg < optionGroups.length; cg++){
      var oname = (optionGroups[cg].getAttribute('data-option-name') || '').toLowerCase();
      if (oname === 'color' || oname === 'colour'){
        colorIdx = parseInt(optionGroups[cg].dataset.optionIdx, 10);
        hasColorOption = true;
        break;
      }
    }
    // The set of thumbs currently visible (the color filter narrows this).
    var activeThumbs = Array.prototype.slice.call(thumbs);
    var lastColor = null;

    // A thumb is "color-specific" ONLY when its alt is exactly "navy" or "red"
    // (case-insensitive). Any other alt = shared image, always visible.
    function thumbColor(thumb){
      var a = (thumb.getAttribute('data-alt') || '').trim().toLowerCase();
      if (a === 'navy') return 'navy';
      if (a === 'red') return 'red';
      return null;
    }

    function applyColorFilter(selColor){
      if (!thumbs.length) return;
      selColor = (selColor || '').trim().toLowerCase();
      activeThumbs = [];
      for (var t = 0; t < thumbs.length; t++){
        var c = thumbColor(thumbs[t]);
        var show = (c === null) || (c === selColor); // shared always; color-specific only on match
        thumbs[t].style.display = show ? '' : 'none';
        if (show) activeThumbs.push(thumbs[t]);
      }
      // Safety: never hide the entire gallery.
      if (!activeThumbs.length){
        for (var u = 0; u < thumbs.length; u++){ thumbs[u].style.display = ''; activeThumbs.push(thumbs[u]); }
      }
      // Keep the current main image if it's still visible, else jump to first visible.
      var startPos = 0;
      if (main && main.src){
        for (var p = 0; p < activeThumbs.length; p++){
          if (activeThumbs[p].dataset.src === main.src){ startPos = p; break; }
        }
      }
      idx = startPos;
      for (var x = 0; x < thumbs.length; x++) thumbs[x].classList.remove('is-on');
      if (activeThumbs[idx]){
        activeThumbs[idx].classList.add('is-on');
        if (main && activeThumbs[idx].dataset.src) main.src = activeThumbs[idx].dataset.src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + activeThumbs.length;
    }

    function findVariant(sel){
      if (!variants.length) return null;
      // If no options at all (selectedValues empty), return first variant
      if (sel.length === 0) return variants[0];
      for (var i = 0; i < variants.length; i++){
        var v = variants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++){
          if (v.options[j] !== sel[j]){ match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    // ===== Size helpers =====
    // Rank size labels so we can find the smallest/largest offered size for the range.
    function sizeRank(label){
      var s = String(label == null ? '' : label).toLowerCase().replace(/[\s._\/-]/g, '');
      var map = {
        'xxxs':-3,'3xs':-3,'xxs':-2,'2xs':-2,
        'xs':-1,'xsmall':-1,'extrasmall':-1,
        's':0,'small':0,'sm':0,
        'm':1,'medium':1,'med':1,'md':1,
        'l':2,'large':2,'lg':2,
        'xl':3,'xlarge':3,'extralarge':3,'1xl':3,'1x':3,
        'xxl':4,'2xl':4,'2x':4,'xxlarge':4,
        'xxxl':5,'3xl':5,'3x':5,
        'xxxxl':6,'4xl':6,'4x':6,
        'xxxxxl':7,'5xl':7,'5x':7,
        '6xl':8,'6x':8,'7xl':9,'7x':9
      };
      if (Object.prototype.hasOwnProperty.call(map, s)) return map[s];
      var m = s.match(/^(\d+)x?l?$/); // 2xl, 3xl, 10xl, ...
      if (m) return 3 + (parseInt(m[1], 10) - 1);
      return null; // unknown — sorts to the end, never breaks the range
    }
    // A size matches the current selection if every NON-size option equals what's picked.
    function nonSizeOptionsMatch(v){
      for (var j = 0; j < v.options.length; j++){
        if (j === sizeIdx) continue;
        if (selectedValues[j] != null && v.options[j] !== selectedValues[j]) return false;
      }
      return true;
    }
    function sizeState(sizeValue){
      var offered = false, available = false;
      for (var i = 0; i < variants.length; i++){
        var v = variants[i];
        if (v.options[sizeIdx] !== sizeValue) continue;
        if (!nonSizeOptionsMatch(v)) continue;
        offered = true;                       // a variant exists for this size in the current combo
        if (v.available){ available = true; break; } // ...and it's in stock
      }
      return { offered: offered, available: available };
    }
    // Inject the live range into the subtitle. Prefers a {sizes} token span; otherwise
    // rewrites an existing "Sizes …" run once, then keeps updating that span.
    function updateSubtitleRange(range){
      if (!subtitleEl || !range) return;
      var span = subtitleEl.querySelector('[data-bbx-size-range]');
      if (span){ span.textContent = range; return; }
      if (!subtitleEl._bbxSizeWrapped){
        subtitleEl._bbxSizeWrapped = true;
        var html = subtitleEl.innerHTML;
        var re = /(sizes?\s+)([0-9a-z]+(?:\s*(?:-|–|—|to)\s*[0-9a-z]+)?)/i;
        if (re.test(html)){
          subtitleEl.innerHTML = html.replace(re, '$1<span data-bbx-size-range></span>');
          var sp = subtitleEl.querySelector('[data-bbx-size-range]');
          if (sp) sp.textContent = range;
        }
      }
    }
    function updateSizeAvailability(){
      if (sizeIdx < 0 || !sizeGroupEl) return;
      var pills = sizeGroupEl.querySelectorAll('[data-value]');
      var offered = [];
      for (var p = 0; p < pills.length; p++){
        var pill = pills[p];
        var st = sizeState(pill.dataset.value);
        if (st.available){
          pill.classList.remove('is-unavailable');
          pill.removeAttribute('aria-disabled');
        } else {
          // Not offered OR sold out in this combo → grayed + crossed-out, not selectable
          pill.classList.add('is-unavailable');
          pill.setAttribute('aria-disabled', 'true');
        }
        if (st.offered) offered.push(pill.dataset.value);
      }
      // Range = the OFFERED sizes for this combo (in stock or not), smallest → largest
      var range = null;
      if (offered.length){
        var sorted = offered.slice().sort(function(a, b){
          var ra = sizeRank(a), rb = sizeRank(b);
          if (ra == null && rb == null) return 0;
          if (ra == null) return 1;
          if (rb == null) return -1;
          return ra - rb;
        });
        var lo = sorted[0], hi = sorted[sorted.length - 1];
        range = (lo === hi) ? lo : (lo + '-' + hi);
      }
      updateSubtitleRange(range);
    }

    function render(){
      var v = findVariant(selectedValues);

      // Update form variant ID
      if (v && variantIdInput) variantIdInput.value = String(v.id);

      // Update URL ?variant=ID
      if (v && window.history && window.history.replaceState){
        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(null, '', url);
        } catch(e){}
      }

      // Swap main image to variant's featured_image
      if (v && v.featured_image && main && main.src !== v.featured_image){
        main.src = v.featured_image;
        // Sync gallery idx to that image if it's in the (currently visible) thumb list
        for (var t = 0; t < activeThumbs.length; t++){
          if (activeThumbs[t].dataset.src === v.featured_image){
            idx = t;
            for (var tt = 0; tt < thumbs.length; tt++) thumbs[tt].classList.remove('is-on');
            activeThumbs[t].classList.add('is-on');
            if (countEl) countEl.textContent = (t+1) + ' / ' + activeThumbs.length;
            break;
          }
        }
      }

      // Update price + savings (multiply by qty)
      var price = v ? v.price : 0;
      var compare = v ? v.compare_at_price : 0;
      var total = price * qty;
      var totalCompare = compare * qty;

      if (priceNowEl) priceNowEl.textContent = fmt(total);

      if (priceWasEl){
        if (compare > price){
          priceWasEl.textContent = fmt(totalCompare);
          priceWasEl.style.display = '';
        } else {
          priceWasEl.textContent = '';
          priceWasEl.style.display = 'none';
        }
      }

      if (priceSaveEl){
        if (compare > price){
          var savings = Math.round((compare - price) / compare * 100 / 5) * 5;
          priceSaveEl.textContent = 'SAVE ' + savings + '%';
          priceSaveEl.style.display = '';
        } else {
          priceSaveEl.textContent = '';
          priceSaveEl.style.display = 'none';
        }
      }

      // Update CTA (state + label)
      var addLabel = root.dataset.ctaAdd || 'Add to Cart';
      var soldoutLabel = root.dataset.ctaSoldout || 'Sold Out';
      var unavailLabel = root.dataset.ctaUnavailable || 'Unavailable';

      var available = v && v.available;
      if (ctaBtn){
        if (!available){
          ctaBtn.classList.add('is-soldout');
          ctaBtn.disabled = true;
        } else {
          ctaBtn.classList.remove('is-soldout');
          ctaBtn.disabled = false;
        }
      }
      if (ctaText){
        if (!v){
          ctaText.textContent = unavailLabel;
        } else if (!v.available){
          ctaText.textContent = soldoutLabel;
        } else {
          ctaText.textContent = addLabel + ' · ' + fmt(window.AJVIP ? window.AJVIP.cta(root, total) : total);
        }
      }

      // Update inline "selected value" display in each variant group label
      for (var i = 0; i < optionGroups.length; i++){
        var group = optionGroups[i];
        var dispEl = group.querySelector('[data-option-value-display]');
        var oIdx = parseInt(group.dataset.optionIdx, 10);
        if (dispEl) dispEl.textContent = selectedValues[oIdx] || '';
      }

      // A76: re-filter the gallery only when the selected color actually changes
      // (so quantity/size changes don't reset the gallery).
      if (hasColorOption){
        var curColor = (selectedValues[colorIdx] || '').trim().toLowerCase();
        if (curColor !== lastColor){
          lastColor = curColor;
          applyColorFilter(curColor);
        }
      }

      // Recompute Size availability for the current Color + refresh the "Sizes X-Y" line
      updateSizeAvailability();
    }

    // ===== Bind variant option clicks (swatches + pills) =====
    var optionBtns = root.querySelectorAll('[data-option-idx][data-value]');
    for (var k = 0; k < optionBtns.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (btn.classList.contains('is-unavailable')) return;
          var oIdx = parseInt(btn.dataset.optionIdx, 10);
          var value = btn.dataset.value;
          selectedValues[oIdx] = value;
          // Toggle is-on among siblings of the same option group
          var siblings = root.querySelectorAll('[data-option-idx="' + oIdx + '"][data-value]');
          for (var s = 0; s < siblings.length; s++) siblings[s].classList.remove('is-on');
          btn.classList.add('is-on');
          render();
        });
      })(optionBtns[k]);
    }

    // ===== Size chart (premium-only): pick desktop/mobile art + lightbox =====
    function applyChart(){
      var mob = !!(mqMobile && mqMobile.matches);
      var url = (mob && chartMobileUrl) ? chartMobileUrl : (chartUrl || chartMobileUrl);
      root._bbxChartUrl = url;
      for (var ci = 0; ci < chartImgs.length; ci++){
        if (url && chartImgs[ci].getAttribute('src') !== url) chartImgs[ci].setAttribute('src', url);
      }
    }
    function openChart(){
      if (!lightbox || (mqMobile && mqMobile.matches)) return;
      var url = root._bbxChartUrl || chartUrl || chartMobileUrl;
      if (!url) return;
      // Portal to <body> so a transformed/overflow ancestor can't trap position:fixed
      if (lightbox.parentNode !== document.body){
        var dupes = document.body.querySelectorAll('.bbx__lightbox');
        for (var dn = 0; dn < dupes.length; dn++){
          if (dupes[dn] !== lightbox && dupes[dn].id === lightbox.id && dupes[dn].parentNode){ dupes[dn].parentNode.removeChild(dupes[dn]); }
        }
        document.body.appendChild(lightbox);
      }
      if (lightboxImg) lightboxImg.setAttribute('src', url);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      void lightbox.offsetWidth; // reflow so the transition runs
      lightbox.classList.add('is-open');
      try { document.documentElement.style.overflow = 'hidden'; } catch(e){}
    }
    function closeChart(){
      if (!lightbox || lightbox.hidden) return;
      lightbox.classList.remove('is-open');
      try { document.documentElement.style.overflow = ''; } catch(e){}
      if (reduceMotion){
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
      } else {
        setTimeout(function(){
          if (!lightbox.classList.contains('is-open')){
            lightbox.hidden = true;
            lightbox.setAttribute('aria-hidden', 'true');
          }
        }, 300);
      }
    }
    function chartTrigger(){
      if (mqMobile && mqMobile.matches){
        // No lightbox on mobile — scroll to the inline chart (above the FAQ) instead
        var t = root.querySelector('.bbx__sizechart--mobile') || root.querySelector('[data-bbx-sizechart]');
        if (t && t.scrollIntoView){ try { t.scrollIntoView({behavior:'smooth', block:'center'}); } catch(e){ t.scrollIntoView(); } }
      } else {
        openChart();
      }
    }
    var openChartBtns = root.querySelectorAll('[data-bbx-open-chart]');
    for (var oc = 0; oc < openChartBtns.length; oc++){
      openChartBtns[oc].addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); chartTrigger(); });
    }
    if (lightbox){
      var lbClosers = lightbox.querySelectorAll('[data-bbx-lightbox-close]');
      for (var lc = 0; lc < lbClosers.length; lc++){
        lbClosers[lc].addEventListener('click', function(ev){ ev.preventDefault(); closeChart(); });
      }
    }
    // Re-pick chart art (and refresh an open lightbox) when crossing the mobile breakpoint
    if (mqMobile){
      var onViewport = function(){
        applyChart();
        if (lightbox && !lightbox.hidden && lightboxImg && root._bbxChartUrl){ lightboxImg.setAttribute('src', root._bbxChartUrl); }
      };
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', onViewport);
      else if (mqMobile.addListener) mqMobile.addListener(onViewport);
    }
    // Esc closes the lightbox
    document.addEventListener('keydown', function(ev){
      if (ev.key === 'Escape' || ev.keyCode === 27){ closeChart(); }
    });

    // ===== Quantity stepper =====
    function setQty(n){
      n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      qty = n;
      if (qtyDisplay) qtyDisplay.value = String(n);
      if (qtyHiddenInput) qtyHiddenInput.value = String(n);
      if (qtyMinus) qtyMinus.disabled = n <= 1;
      render();
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty + 1); });
    if (qtyDisplay){
      qtyDisplay.addEventListener('change', function(){ setQty(qtyDisplay.value); });
      qtyDisplay.addEventListener('input', function(){
        var v = parseInt(qtyDisplay.value, 10);
        if (!isNaN(v)){ qty = Math.max(1, Math.min(99, v)); if (qtyHiddenInput) qtyHiddenInput.value = String(qty); render(); }
      });
    }

    // ===== Form submit guard =====
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form){
      form.addEventListener('submit', function(ev){
        if (ctaBtn && ctaBtn.disabled){ ev.preventDefault(); }
      });
    }

    // ===== Gallery =====
    function setSlide(n){
      if (!activeThumbs.length) return;
      var len = activeThumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      activeThumbs[idx].classList.add('is-on');
      var src = activeThumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + activeThumbs.length;
      var active = activeThumbs[idx];
      if (active && active.scrollIntoView){
        try { active.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); } catch(e){
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    for (var k2 = 0; k2 < thumbs.length; k2++){
      (function(el){
        el.addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          var pos = activeThumbs.indexOf(el);
          if (pos >= 0) setSlide(pos);
        });
      })(thumbs[k2]);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // ===== Drag-to-scroll on thumb strip (desktop) =====
    if (thumbsContainer && thumbs.length > 1){
      var tDown=false, tStartX=0, tStartScroll=0, tMoved=false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true; tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){ tDown = false; thumbsContainer._bbxDragged = false; }
      });
    }

    // ===== Main image swipe (touch + mouse drag) =====
    if (mainBox && thumbs.length > 1){
      var sx=0, sy=0, swiping=false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, {passive:true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive:true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive:true});

      var mx=0, my=0, mdown=false, mmoved=false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true; mmoved = false; mx = e.clientX; my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    setQty(1);
    render();
    applyChart();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["0-0-vintage"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    // ===== Variants data =====
    var variants = [];
    var variantsScript = document.querySelector('script[data-bbx-variants="' + (root.id || '').replace('bbx-', '') + '"]');
    if (!variantsScript){
      // Fallback: find first variants script (single-section pages)
      variantsScript = document.querySelector('script[data-bbx-variants]');
    }
    if (variantsScript){
      try { variants = JSON.parse(variantsScript.textContent); } catch(e){}
    }

    // ===== Refs =====
    var optionGroups = root.querySelectorAll('.bbx__variant-group');
    var variantIdInput = root.querySelector('input[name="id"]');
    var qtyHiddenInput = root.querySelector('input[name="quantity"]');
    var qtyDisplay = root.querySelector('[data-qty-input]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var priceNowEl = root.querySelector('[data-bbx-price-now]');
    var priceWasEl = root.querySelector('[data-bbx-price-was]');
    var priceSaveEl = root.querySelector('[data-bbx-price-save]');
    var ctaBtn = root.querySelector('[data-bbx-cta]');
    var ctaText = root.querySelector('[data-bbx-cta-text]');
    var main = root.querySelector('.bbx__main img');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var mainBox = root.querySelector('.bbx__main');
    var chip = root.querySelector('.bbx__chip');

    // ===== Size-chart refs (premium-only: single chart, desktop lightbox) =====
    var chartImgs = root.querySelectorAll('[data-bbx-chart-img]');
    var lightbox = root.querySelector('[data-bbx-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-bbx-lightbox-img]') : null;
    var chartUrl = root.getAttribute('data-bbx-chart') || '';
    var chartMobileUrl = root.getAttribute('data-bbx-chart-mobile') || '';
    var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    var qty = 1;
    var idx = 0;

    // ===== Initial selection state (from server-rendered .is-on classes) =====
    var selectedValues = [];
    for (var g = 0; g < optionGroups.length; g++){
      var group = optionGroups[g];
      var oIdx = parseInt(group.dataset.optionIdx, 10);
      var selectedBtn = group.querySelector('[data-value].is-on');
      selectedValues[oIdx] = selectedBtn ? selectedBtn.dataset.value : null;
    }

    // ===== Size refs (dynamic "Sizes X-Y" range + per-combination availability) =====
    var sizeGroupEl = root.querySelector('[data-bbx-size]');
    var sizeIdx = sizeGroupEl ? parseInt(sizeGroupEl.dataset.optionIdx, 10) : -1;
    var subtitleEl = root.querySelector('[data-bbx-subtitle]') || root.querySelector('.bbx__subtitle');

    // ===== Color → image filter (exact-alt match) =====
    // Find the "Color" variant option group (if the product has one).
    var colorIdx = -1, hasColorOption = false;
    for (var cg = 0; cg < optionGroups.length; cg++){
      var oname = (optionGroups[cg].getAttribute('data-option-name') || '').toLowerCase();
      if (oname === 'color' || oname === 'colour'){
        colorIdx = parseInt(optionGroups[cg].dataset.optionIdx, 10);
        hasColorOption = true;
        break;
      }
    }
    // The set of thumbs currently visible (the color filter narrows this).
    var activeThumbs = Array.prototype.slice.call(thumbs);
    var lastColor = null;

    // A thumb is "color-specific" ONLY when its alt is exactly "navy" or "red"
    // (case-insensitive). Any other alt = shared image, always visible.
    function thumbColor(thumb){
      var a = (thumb.getAttribute('data-alt') || '').trim().toLowerCase();
      if (a === 'navy') return 'navy';
      if (a === 'red') return 'red';
      return null;
    }

    function applyColorFilter(selColor){
      if (!thumbs.length) return;
      selColor = (selColor || '').trim().toLowerCase();
      activeThumbs = [];
      for (var t = 0; t < thumbs.length; t++){
        var c = thumbColor(thumbs[t]);
        var show = (c === null) || (c === selColor); // shared always; color-specific only on match
        thumbs[t].style.display = show ? '' : 'none';
        if (show) activeThumbs.push(thumbs[t]);
      }
      // Safety: never hide the entire gallery.
      if (!activeThumbs.length){
        for (var u = 0; u < thumbs.length; u++){ thumbs[u].style.display = ''; activeThumbs.push(thumbs[u]); }
      }
      // Keep the current main image if it's still visible, else jump to first visible.
      var startPos = 0;
      if (main && main.src){
        for (var p = 0; p < activeThumbs.length; p++){
          if (activeThumbs[p].dataset.src === main.src){ startPos = p; break; }
        }
      }
      idx = startPos;
      for (var x = 0; x < thumbs.length; x++) thumbs[x].classList.remove('is-on');
      if (activeThumbs[idx]){
        activeThumbs[idx].classList.add('is-on');
        if (main && activeThumbs[idx].dataset.src) main.src = activeThumbs[idx].dataset.src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + activeThumbs.length;
      if (chip) chip.style.display = (idx === 0) ? '' : 'none';
    }

    function findVariant(sel){
      if (!variants.length) return null;
      // If no options at all (selectedValues empty), return first variant
      if (sel.length === 0) return variants[0];
      for (var i = 0; i < variants.length; i++){
        var v = variants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++){
          if (v.options[j] !== sel[j]){ match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    // ===== Size helpers =====
    // Rank size labels so we can find the smallest/largest offered size for the range.
    function sizeRank(label){
      var s = String(label == null ? '' : label).toLowerCase().replace(/[\s._\/-]/g, '');
      var map = {
        'xxxs':-3,'3xs':-3,'xxs':-2,'2xs':-2,
        'xs':-1,'xsmall':-1,'extrasmall':-1,
        's':0,'small':0,'sm':0,
        'm':1,'medium':1,'med':1,'md':1,
        'l':2,'large':2,'lg':2,
        'xl':3,'xlarge':3,'extralarge':3,'1xl':3,'1x':3,
        'xxl':4,'2xl':4,'2x':4,'xxlarge':4,
        'xxxl':5,'3xl':5,'3x':5,
        'xxxxl':6,'4xl':6,'4x':6,
        'xxxxxl':7,'5xl':7,'5x':7,
        '6xl':8,'6x':8,'7xl':9,'7x':9
      };
      if (Object.prototype.hasOwnProperty.call(map, s)) return map[s];
      var m = s.match(/^(\d+)x?l?$/); // 2xl, 3xl, 10xl, ...
      if (m) return 3 + (parseInt(m[1], 10) - 1);
      return null; // unknown — sorts to the end, never breaks the range
    }
    // A size matches the current selection if every NON-size option equals what's picked.
    function nonSizeOptionsMatch(v){
      for (var j = 0; j < v.options.length; j++){
        if (j === sizeIdx) continue;
        if (selectedValues[j] != null && v.options[j] !== selectedValues[j]) return false;
      }
      return true;
    }
    function sizeState(sizeValue){
      var offered = false, available = false;
      for (var i = 0; i < variants.length; i++){
        var v = variants[i];
        if (v.options[sizeIdx] !== sizeValue) continue;
        if (!nonSizeOptionsMatch(v)) continue;
        offered = true;                       // a variant exists for this size in the current combo
        if (v.available){ available = true; break; } // ...and it's in stock
      }
      return { offered: offered, available: available };
    }
    // Inject the live range into the subtitle. Prefers a {sizes} token span; otherwise
    // rewrites an existing "Sizes …" run once, then keeps updating that span.
    function updateSubtitleRange(range){
      if (!subtitleEl || !range) return;
      var span = subtitleEl.querySelector('[data-bbx-size-range]');
      if (span){ span.textContent = range; return; }
      if (!subtitleEl._bbxSizeWrapped){
        subtitleEl._bbxSizeWrapped = true;
        var html = subtitleEl.innerHTML;
        var re = /(sizes?\s+)([0-9a-z]+(?:\s*(?:-|–|—|to)\s*[0-9a-z]+)?)/i;
        if (re.test(html)){
          subtitleEl.innerHTML = html.replace(re, '$1<span data-bbx-size-range></span>');
          var sp = subtitleEl.querySelector('[data-bbx-size-range]');
          if (sp) sp.textContent = range;
        }
      }
    }
    function updateSizeAvailability(){
      if (sizeIdx < 0 || !sizeGroupEl) return;
      var pills = sizeGroupEl.querySelectorAll('[data-value]');
      var offered = [];
      for (var p = 0; p < pills.length; p++){
        var pill = pills[p];
        var st = sizeState(pill.dataset.value);
        if (st.available){
          pill.classList.remove('is-unavailable');
          pill.removeAttribute('aria-disabled');
        } else {
          // Not offered OR sold out in this combo → grayed + crossed-out, not selectable
          pill.classList.add('is-unavailable');
          pill.setAttribute('aria-disabled', 'true');
        }
        if (st.offered) offered.push(pill.dataset.value);
      }
      // Range = the OFFERED sizes for this combo (in stock or not), smallest → largest
      var range = null;
      if (offered.length){
        var sorted = offered.slice().sort(function(a, b){
          var ra = sizeRank(a), rb = sizeRank(b);
          if (ra == null && rb == null) return 0;
          if (ra == null) return 1;
          if (rb == null) return -1;
          return ra - rb;
        });
        var lo = sorted[0], hi = sorted[sorted.length - 1];
        range = (lo === hi) ? lo : (lo + '-' + hi);
      }
      updateSubtitleRange(range);
    }

    function render(){
      var v = findVariant(selectedValues);

      // Update form variant ID
      if (v && variantIdInput) variantIdInput.value = String(v.id);

      // Update URL ?variant=ID
      if (v && window.history && window.history.replaceState){
        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(null, '', url);
        } catch(e){}
      }

      // Swap main image to variant's featured_image
      if (v && v.featured_image && main && main.src !== v.featured_image){
        main.src = v.featured_image;
        // Sync gallery idx to that image if it's in the (currently visible) thumb list
        for (var t = 0; t < activeThumbs.length; t++){
          if (activeThumbs[t].dataset.src === v.featured_image){
            idx = t;
            for (var tt = 0; tt < thumbs.length; tt++) thumbs[tt].classList.remove('is-on');
            activeThumbs[t].classList.add('is-on');
            if (countEl) countEl.textContent = (t+1) + ' / ' + activeThumbs.length;
            if (chip) chip.style.display = (t === 0) ? '' : 'none';
            break;
          }
        }
      }

      // Update price + savings (multiply by qty)
      var price = v ? v.price : 0;
      var compare = v ? v.compare_at_price : 0;
      var total = price * qty;
      var totalCompare = compare * qty;

      if (priceNowEl) priceNowEl.textContent = fmt(total);

      if (priceWasEl){
        if (compare > price){
          priceWasEl.textContent = fmt(totalCompare);
          priceWasEl.style.display = '';
        } else {
          priceWasEl.textContent = '';
          priceWasEl.style.display = 'none';
        }
      }

      if (priceSaveEl){
        if (compare > price){
          var savings = Math.round((compare - price) / compare * 100 / 5) * 5;
          priceSaveEl.textContent = 'SAVE ' + savings + '%';
          priceSaveEl.style.display = '';
        } else {
          priceSaveEl.textContent = '';
          priceSaveEl.style.display = 'none';
        }
      }

      // Update CTA (state + label)
      var addLabel = root.dataset.ctaAdd || 'Add to Cart';
      var soldoutLabel = root.dataset.ctaSoldout || 'Sold Out';
      var unavailLabel = root.dataset.ctaUnavailable || 'Unavailable';

      var available = v && v.available;
      if (ctaBtn){
        if (!available){
          ctaBtn.classList.add('is-soldout');
          ctaBtn.disabled = true;
        } else {
          ctaBtn.classList.remove('is-soldout');
          ctaBtn.disabled = false;
        }
      }
      if (ctaText){
        if (!v){
          ctaText.textContent = unavailLabel;
        } else if (!v.available){
          ctaText.textContent = soldoutLabel;
        } else {
          ctaText.textContent = addLabel + ' · ' + fmt(window.AJVIP ? window.AJVIP.cta(root, total) : total);
        }
      }

      // Update inline "selected value" display in each variant group label
      for (var i = 0; i < optionGroups.length; i++){
        var group = optionGroups[i];
        var dispEl = group.querySelector('[data-option-value-display]');
        var oIdx = parseInt(group.dataset.optionIdx, 10);
        if (dispEl) dispEl.textContent = selectedValues[oIdx] || '';
      }

      // Re-filter the gallery only when the selected color actually changes
      // (so quantity/size changes don't reset the gallery).
      if (hasColorOption){
        var curColor = (selectedValues[colorIdx] || '').trim().toLowerCase();
        if (curColor !== lastColor){
          lastColor = curColor;
          applyColorFilter(curColor);
        }
      }

      // Recompute Size availability for the current Color + refresh the "Sizes X-Y" line
      updateSizeAvailability();
    }

    // ===== Bind variant option clicks (swatches + pills) =====
    var optionBtns = root.querySelectorAll('[data-option-idx][data-value]');
    for (var k = 0; k < optionBtns.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (btn.classList.contains('is-unavailable')) return;
          var oIdx = parseInt(btn.dataset.optionIdx, 10);
          var value = btn.dataset.value;
          selectedValues[oIdx] = value;
          // Toggle is-on among siblings of the same option group
          var siblings = root.querySelectorAll('[data-option-idx="' + oIdx + '"][data-value]');
          for (var s = 0; s < siblings.length; s++) siblings[s].classList.remove('is-on');
          btn.classList.add('is-on');
          render();
        });
      })(optionBtns[k]);
    }

    // ===== Size chart (premium-only): pick desktop/mobile art + lightbox =====
    function applyChart(){
      var mob = !!(mqMobile && mqMobile.matches);
      var url = (mob && chartMobileUrl) ? chartMobileUrl : (chartUrl || chartMobileUrl);
      root._bbxChartUrl = url;
      for (var ci = 0; ci < chartImgs.length; ci++){
        if (url && chartImgs[ci].getAttribute('src') !== url) chartImgs[ci].setAttribute('src', url);
      }
    }
    function openChart(){
      if (!lightbox || (mqMobile && mqMobile.matches)) return;
      var url = root._bbxChartUrl || chartUrl || chartMobileUrl;
      if (!url) return;
      // Portal to <body> so a transformed/overflow ancestor can't trap position:fixed
      if (lightbox.parentNode !== document.body){
        var dupes = document.body.querySelectorAll('.bbx__lightbox');
        for (var dn = 0; dn < dupes.length; dn++){
          if (dupes[dn] !== lightbox && dupes[dn].id === lightbox.id && dupes[dn].parentNode){ dupes[dn].parentNode.removeChild(dupes[dn]); }
        }
        document.body.appendChild(lightbox);
      }
      if (lightboxImg) lightboxImg.setAttribute('src', url);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      void lightbox.offsetWidth; // reflow so the transition runs
      lightbox.classList.add('is-open');
      try { document.documentElement.style.overflow = 'hidden'; } catch(e){}
    }
    function closeChart(){
      if (!lightbox || lightbox.hidden) return;
      lightbox.classList.remove('is-open');
      try { document.documentElement.style.overflow = ''; } catch(e){}
      if (reduceMotion){
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
      } else {
        setTimeout(function(){
          if (!lightbox.classList.contains('is-open')){
            lightbox.hidden = true;
            lightbox.setAttribute('aria-hidden', 'true');
          }
        }, 300);
      }
    }
    function chartTrigger(){
      if (mqMobile && mqMobile.matches){
        // No lightbox on mobile — scroll to the inline chart (above the FAQ) instead
        var t = root.querySelector('.bbx__sizechart--mobile') || root.querySelector('[data-bbx-sizechart]');
        if (t && t.scrollIntoView){ try { t.scrollIntoView({behavior:'smooth', block:'center'}); } catch(e){ t.scrollIntoView(); } }
      } else {
        openChart();
      }
    }
    var openChartBtns = root.querySelectorAll('[data-bbx-open-chart]');
    for (var oc = 0; oc < openChartBtns.length; oc++){
      openChartBtns[oc].addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); chartTrigger(); });
    }
    if (lightbox){
      var lbClosers = lightbox.querySelectorAll('[data-bbx-lightbox-close]');
      for (var lc = 0; lc < lbClosers.length; lc++){
        lbClosers[lc].addEventListener('click', function(ev){ ev.preventDefault(); closeChart(); });
      }
    }
    // Re-pick chart art (and refresh an open lightbox) when crossing the mobile breakpoint
    if (mqMobile){
      var onViewport = function(){
        applyChart();
        if (lightbox && !lightbox.hidden && lightboxImg && root._bbxChartUrl){ lightboxImg.setAttribute('src', root._bbxChartUrl); }
      };
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', onViewport);
      else if (mqMobile.addListener) mqMobile.addListener(onViewport);
    }
    // Esc closes the lightbox
    document.addEventListener('keydown', function(ev){
      if (ev.key === 'Escape' || ev.keyCode === 27){ closeChart(); }
    });

    // ===== Quantity stepper =====
    function setQty(n){
      n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      qty = n;
      if (qtyDisplay) qtyDisplay.value = String(n);
      if (qtyHiddenInput) qtyHiddenInput.value = String(n);
      if (qtyMinus) qtyMinus.disabled = n <= 1;
      render();
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty + 1); });
    if (qtyDisplay){
      qtyDisplay.addEventListener('change', function(){ setQty(qtyDisplay.value); });
      qtyDisplay.addEventListener('input', function(){
        var v = parseInt(qtyDisplay.value, 10);
        if (!isNaN(v)){ qty = Math.max(1, Math.min(99, v)); if (qtyHiddenInput) qtyHiddenInput.value = String(qty); render(); }
      });
    }

    // ===== Form submit guard =====
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form){
      form.addEventListener('submit', function(ev){
        if (ctaBtn && ctaBtn.disabled){ ev.preventDefault(); }
      });
    }

    // ===== Gallery =====
    function setSlide(n){
      if (!activeThumbs.length) return;
      var len = activeThumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      activeThumbs[idx].classList.add('is-on');
      var src = activeThumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (chip) chip.style.display = (idx === 0) ? '' : 'none';
      if (countEl) countEl.textContent = (idx+1) + ' / ' + activeThumbs.length;
      var active = activeThumbs[idx];
      if (active && active.scrollIntoView){
        try { active.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); } catch(e){
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    for (var k2 = 0; k2 < thumbs.length; k2++){
      (function(el){
        el.addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          var pos = activeThumbs.indexOf(el);
          if (pos >= 0) setSlide(pos);
        });
      })(thumbs[k2]);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // ===== Drag-to-scroll on thumb strip (desktop) =====
    if (thumbsContainer && thumbs.length > 1){
      var tDown=false, tStartX=0, tStartScroll=0, tMoved=false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true; tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){ tDown = false; thumbsContainer._bbxDragged = false; }
      });
    }

    // ===== Main image swipe (touch + mouse drag) =====
    if (mainBox && thumbs.length > 1){
      var sx=0, sy=0, swiping=false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, {passive:true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive:true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive:true});

      var mx=0, my=0, mdown=false, mmoved=false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true; mmoved = false; mx = e.clientX; my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    setQty(1);
    render();
    applyChart();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["0-26-belt-section"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };
    var sid = (root.id || '').replace('bbx-', '');

    // ===== Styles data =====
    var styles = [];
    var dataScript = document.querySelector('script[data-bbx-styles="' + sid + '"]');
    if (!dataScript) dataScript = document.querySelector('script[data-bbx-styles]');
    if (dataScript){ try { styles = JSON.parse(dataScript.textContent); } catch(e){} }
    if (!styles.length) return;

    // ===== Refs =====
    var variantIdInput = root.querySelector('input[name="id"]');
    var qtyHiddenInput = root.querySelector('input[name="quantity"]');
    var qtyDisplay = root.querySelector('[data-qty-input]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');

    var titleEl = root.querySelector('[data-bbx-title]');
    var subtitleEl = root.querySelector('[data-bbx-subtitle]');
    var leadEl = root.querySelector('[data-bbx-lead]');
    var benefitsEl = root.querySelector('[data-bbx-benefits]');
    var styleValueEl = root.querySelector('[data-bbx-style-value]');
    var cards = root.querySelectorAll('[data-bbx-style-index]');

    var priceNowEl = root.querySelector('[data-bbx-price-now]');
    var priceWasEl = root.querySelector('[data-bbx-price-was]');
    var priceSaveEl = root.querySelector('[data-bbx-price-save]');

    var ctaSingle = root.querySelector('[data-bbx-cta-single]');
    var ctaSingleMain = root.querySelector('[data-bbx-cta-single-main]');
    var ctaSingleSub = root.querySelector('[data-bbx-cta-single-sub]');
    var ctaDot = root.querySelector('[data-bbx-cta-dot]');

    var main = root.querySelector('.bbx__main img');
    var mainBox = root.querySelector('.bbx__main');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var thumbs = thumbsContainer ? thumbsContainer.querySelectorAll('.bbx__thumb') : [];

    var sel = 0, qty = 1, idx = 0;

    var BENCHK = '<span class="bbx__check"><svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M5 12l4 4 10-10" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
    var addLabel = root.dataset.ctaAdd || 'Add to Cart';
    var soldoutLabel = root.dataset.ctaSoldout || 'Sold Out';

    function esc(s){ return String(s == null ? '' : s).replace(/"/g, '&quot;'); }

    // ===== Gallery =====
    function bindThumbs(){
      for (var t = 0; t < thumbs.length; t++){
        (function(i){
          thumbs[i].addEventListener('click', function(ev){
            ev.preventDefault(); ev.stopPropagation();
            if (thumbsContainer && thumbsContainer._bbxDragged) return;
            setSlide(i);
          });
        })(t);
      }
    }

    function buildGallery(images){
      images = images || [];
      idx = 0;
      if (main && images[0]){ main.src = images[0].full; main.alt = images[0].alt || ''; }
      if (thumbsContainer){
        var html = '';
        for (var i = 0; i < images.length; i++){
          html += '<button type="button" class="bbx__thumb' + (i === 0 ? ' is-on' : '') + '" data-src="' + esc(images[i].full) + '" aria-label="View image ' + (i+1) + ' of ' + images.length + '">' +
                  '<img src="' + esc(images[i].thumb) + '" alt="' + esc(images[i].alt) + '" loading="lazy" draggable="false" width="200" height="231"></button>';
        }
        thumbsContainer.innerHTML = html;
        thumbs = thumbsContainer.querySelectorAll('.bbx__thumb');
        bindThumbs();
      }
      var multi = images.length > 1;
      if (thumbsContainer) thumbsContainer.style.display = multi ? '' : 'none';
      if (prev) prev.style.display = multi ? '' : 'none';
      if (next) next.style.display = multi ? '' : 'none';
      if (countEl){ countEl.style.display = multi ? '' : 'none'; countEl.textContent = '1 / ' + images.length; }
    }

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try { active.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); } catch(e){
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }

    // ===== Price + single CTA (depends on selected style + qty) =====
    function renderPrice(){
      var s = styles[sel];
      var total = s.price * qty;
      var totalCompare = s.compare_at_price * qty;

      if (priceNowEl) priceNowEl.textContent = fmt(total);
      if (priceWasEl){
        if (s.compare_at_price > s.price){ priceWasEl.textContent = fmt(totalCompare); priceWasEl.style.display = ''; }
        else { priceWasEl.textContent = ''; priceWasEl.style.display = 'none'; }
      }
      if (priceSaveEl){
        if (s.compare_at_price > s.price){
          var sv = Math.round((s.compare_at_price - s.price) / s.compare_at_price * 100);
          priceSaveEl.textContent = 'SAVE ' + sv + '%'; priceSaveEl.style.display = '';
        } else { priceSaveEl.textContent = ''; priceSaveEl.style.display = 'none'; }
      }
      if (ctaSingle){
        if (s.available){ ctaSingle.classList.remove('is-soldout'); ctaSingle.disabled = false; }
        else { ctaSingle.classList.add('is-soldout'); ctaSingle.disabled = true; }
        ctaSingle.classList.remove('is-added');
      }
      if (ctaSingleMain) ctaSingleMain.textContent = s.available ? addLabel : soldoutLabel;
      if (ctaSingleSub) ctaSingleSub.textContent = s.available ? fmt(window.AJVIP ? window.AJVIP.cta(root, total) : total) : '';
      /* No price on a sold-out style, so the " · " separator has to go with it. */
      if (ctaDot) ctaDot.style.display = s.available ? '' : 'none';
    }

    // ===== Full style render (content + cards + variant id + gallery) =====
    function renderStyle(){
      var s = styles[sel];
      if (variantIdInput) variantIdInput.value = String(s.id);
      if (titleEl) titleEl.textContent = s.title;
      if (styleValueEl) styleValueEl.textContent = s.title;
      if (subtitleEl){
        if (s.subtitle){ subtitleEl.innerHTML = s.subtitle; subtitleEl.style.display = ''; }
        else { subtitleEl.innerHTML = ''; subtitleEl.style.display = 'none'; }
      }
      if (leadEl){
        if (s.lead){ leadEl.innerHTML = s.lead; leadEl.style.display = ''; }
        else { leadEl.innerHTML = ''; leadEl.style.display = 'none'; }
      }
      if (benefitsEl){
        var bs = (s.benefits || []).filter(function(b){ return b && String(b).length; });
        if (bs.length){
          benefitsEl.innerHTML = bs.map(function(b){ return '<li>' + BENCHK + ' <span class="bbx__benefit-text">' + b + '</span></li>'; }).join('');
          benefitsEl.style.display = '';
        } else { benefitsEl.innerHTML = ''; benefitsEl.style.display = 'none'; }
      }
      for (var c = 0; c < cards.length; c++){
        var on = parseInt(cards[c].dataset.bbxStyleIndex, 10) === sel;
        cards[c].classList.toggle('is-on', on);
        cards[c].setAttribute('aria-checked', on ? 'true' : 'false');
      }
      buildGallery(s.images);
      renderPrice();
    }

    // ===== Quantity =====
    function setQty(n){
      n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      qty = n;
      if (qtyDisplay) qtyDisplay.value = String(n);
      if (qtyHiddenInput) qtyHiddenInput.value = String(n);
      if (qtyMinus) qtyMinus.disabled = n <= 1;
      renderPrice();
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty + 1); });
    if (qtyDisplay){
      qtyDisplay.addEventListener('change', function(){ setQty(qtyDisplay.value); });
      qtyDisplay.addEventListener('input', function(){
        var v = parseInt(qtyDisplay.value, 10);
        if (!isNaN(v)){ qty = Math.max(1, Math.min(99, v)); if (qtyHiddenInput) qtyHiddenInput.value = String(qty); renderPrice(); }
      });
    }

    // ===== Style card clicks =====
    for (var c2 = 0; c2 < cards.length; c2++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          var i = parseInt(btn.dataset.bbxStyleIndex, 10);
          if (isNaN(i) || i === sel) return;
          sel = i;
          renderStyle();
        });
      })(cards[c2]);
    }

    // ===== Cart =====
    function openCart(){
      // UpCart V2 auto-opens on the /cart/add.js fetch (it patches fetch/XHR).
      // Fire common refresh events for the theme + other cart apps as a courtesy.
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch(e){}
      try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true })); } catch(e){}
      try { if (window.Shopify && Shopify.designMode) return; } catch(e){}
      // Fallback: nudge the cart drawer open if it didn't auto-open.
      setTimeout(function(){
        try {
          if (document.body.classList.contains('upcartPopupShow')) return;
          var t = document.querySelector('[data-upcart-toggle], #upcart-cart-icon, .upcart-cart-icon');
          if (t) t.click();
        } catch(e){}
      }, 500);
    }

    function setLoading(btn, on, soldout){
      if (!btn) return;
      if (on){ btn.classList.add('is-loading'); btn.disabled = true; }
      else { btn.classList.remove('is-loading'); btn.disabled = !!soldout; }
    }

    function addToCart(items, btn, onOk){
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r){ return r.json().then(function(d){ return { ok: r.ok, data: d }; }); })
      .then(function(res){
        setLoading(btn, false, false);
        if (res.ok){ if (onOk) onOk(); openCart(); }
        else { console && console.warn && console.warn('[bbx] add failed', res.data); }
      })
      .catch(function(err){ setLoading(btn, false, false); console && console.warn && console.warn('[bbx]', err); });
    }

    // Single add (form submit — progressive enhancement)
    var form = root.querySelector('form[action*="/cart/add"]') || root.querySelector('form');
    if (form){
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        var s = styles[sel];
        if (!s || !s.available) return;
        setLoading(ctaSingle, true);
        addToCart([{ id: s.id, quantity: qty }], ctaSingle, function(){ renderPrice(); });
      });
    }

    // ===== Gallery nav (bound once on stable elements) =====
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx - 1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx + 1); });

    if (thumbsContainer){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0 || thumbs.length <= 1) return;
        tDown = true; tMoved = false; tStartX = e.pageX; tStartScroll = thumbsContainer.scrollLeft; thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){ tMoved = true; thumbsContainer._bbxDragged = true; thumbsContainer.classList.add('is-dragging'); }
        if (tMoved){ e.preventDefault(); thumbsContainer.scrollLeft = tStartScroll - dx; }
      });
      var endDrag = function(){
        if (!tDown) return;
        tDown = false; var wasDrag = tMoved; tMoved = false; thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){ setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100); } else { thumbsContainer._bbxDragged = false; }
      };
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){ if (tDown && !tMoved){ tDown = false; thumbsContainer._bbxDragged = false; } });
    }

    if (mainBox){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0] || thumbs.length <= 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, {passive:true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return; swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) setSlide(idx + (dx < 0 ? 1 : -1));
      }, {passive:true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive:true});

      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){ if (thumbs.length <= 1) return; mdown = true; mmoved = false; mx = e.clientX; my = e.clientY; });
      mainBox.addEventListener('mousemove', function(e){ if (!mdown) return; if (Math.abs(e.clientX - mx) > 5) mmoved = true; });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return; mdown = false; if (!mmoved) return;
        var dx = e.clientX - mx; var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) setSlide(idx + (dx < 0 ? 1 : -1));
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    setQty(1);
    renderStyle();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["00-ultpower-buybox"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Auto-Ship selected';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no Auto-Ship';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    function getThumbs(){ return root.querySelectorAll('.bbx__thumb'); }
    var thumbs = getThumbs();
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      var thumbs = getThumbs();
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — delegated so it survives gallery rebuilds (flavor swap); guarded against drag-clicks
    if (thumbsContainer){
      thumbsContainer.addEventListener('click', function(ev){
        var btn = ev.target && ev.target.closest ? ev.target.closest('.bbx__thumb') : null;
        if (!btn) return;
        ev.preventDefault();
        ev.stopPropagation();
        if (thumbsContainer._bbxDragged) return;
        var list = getThumbs();
        for (var i = 0; i < list.length; i++){ if (list[i] === btn){ setSlide(i); break; } }
      });
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    // ===== FLAVOR SWAP (in-place across separate products) =====
    var flavorData = {};
    try {
      var fdEl = root.querySelector('[id^="bbx-flavor-data-"]');
      if (fdEl) flavorData = JSON.parse(fdEl.textContent || '{}');
    } catch (e) { flavorData = {}; }
    var flavorCards = root.querySelectorAll('.bbx__flavor-card');
    var idInput = root.querySelector('input[name="id"]');

    function rebuildGallery(images){
      if (!images || !images.length) return;
      // Swap the hero image first — works even when there is no thumb strip (single-image product)
      if (main) main.src = images[0].full;
      idx = 0;
      if (!thumbsContainer) return;
      var html = '';
      for (var i = 0; i < images.length; i++){
        var on = i === 0 ? ' is-on' : '';
        html += '<button type="button" class="bbx__thumb' + on + '" data-src="' + images[i].full + '" aria-label="View image ' + (i + 1) + ' of ' + images.length + '">' +
                '<img src="' + images[i].thumb + '" alt="" loading="lazy" draggable="false" width="200" height="200"></button>';
      }
      thumbsContainer.innerHTML = html;
      if (countEl) countEl.textContent = '1 / ' + images.length;
    }

    function swapFlavor(id){
      var d = flavorData[id];
      if (!d) return;
      if (idInput && d.variantId) idInput.value = d.variantId;
      if (d.rows){
        for (var j = 0; j < qtyRows.length; j++){
          var b = qtyRows[j];
          var qn = parseInt(b.dataset.qty, 10);
          var row = d.rows[qn - 1];
          if (!row) continue;
          b.dataset.oncePrice = row.oncePrice;
          b.dataset.onceDisc  = row.onceDisc;
          b.dataset.subPrice  = row.subPrice;
          b.dataset.subDisc   = row.subDisc;
          b.dataset.subPlan   = row.subPlan;
          var wasEl = b.querySelector('.bbx__qty-was');
          if (wasEl && d.wasText) wasEl.textContent = d.wasText;
        }
      }
      if (d.images) rebuildGallery(d.images);
      render();
    }

    for (var f = 0; f < flavorCards.length; f++){
      (function(card){
        card.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (card.classList.contains('is-on')) return;
          for (var g = 0; g < flavorCards.length; g++){
            var on = flavorCards[g] === card;
            flavorCards[g].classList.toggle('is-on', on);
            flavorCards[g].setAttribute('aria-checked', on ? 'true' : 'false');
          }
          swapFlavor(card.dataset.flavorId);
        });
      })(flavorCards[f]);
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["26-buybox-silver-coin"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    // ===== Variants data =====
    var variants = [];
    var variantsScript = document.querySelector('script[data-bbx-variants="' + (root.id || '').replace('bbx-', '') + '"]');
    if (!variantsScript){
      // Fallback: find first variants script (single-section pages)
      variantsScript = document.querySelector('script[data-bbx-variants]');
    }
    if (variantsScript){
      try { variants = JSON.parse(variantsScript.textContent); } catch(e){}
    }

    // ===== Refs =====
    var optionGroups = root.querySelectorAll('.bbx__variant-group');
    var variantIdInput = root.querySelector('input[name="id"]');
    var qtyHiddenInput = root.querySelector('input[name="quantity"]');
    var qtyDisplay = root.querySelector('[data-qty-input]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var priceNowEl = root.querySelector('[data-bbx-price-now]');
    var priceWasEl = root.querySelector('[data-bbx-price-was]');
    var priceSaveEl = root.querySelector('[data-bbx-price-save]');
    var ctaBtn = root.querySelector('[data-bbx-cta]');
    var ctaText = root.querySelector('[data-bbx-cta-text]');
    var main = root.querySelector('.bbx__main img');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var mainBox = root.querySelector('.bbx__main');

    var qty = 1;
    var idx = 0;

    // ===== Initial selection state (from server-rendered .is-on classes) =====
    var selectedValues = [];
    for (var g = 0; g < optionGroups.length; g++){
      var group = optionGroups[g];
      var oIdx = parseInt(group.dataset.optionIdx, 10);
      var selectedBtn = group.querySelector('[data-value].is-on');
      selectedValues[oIdx] = selectedBtn ? selectedBtn.dataset.value : null;
    }

    function findVariant(sel){
      if (!variants.length) return null;
      // If no options at all (selectedValues empty), return first variant
      if (sel.length === 0) return variants[0];
      for (var i = 0; i < variants.length; i++){
        var v = variants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++){
          if (v.options[j] !== sel[j]){ match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function render(){
      var v = findVariant(selectedValues);

      // Update form variant ID
      if (v && variantIdInput) variantIdInput.value = String(v.id);

      // Update URL ?variant=ID
      if (v && window.history && window.history.replaceState){
        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(null, '', url);
        } catch(e){}
      }

      // Swap main image to variant's featured_image
      if (v && v.featured_image && main && main.src !== v.featured_image){
        main.src = v.featured_image;
        // Sync gallery idx to that image if it's in the thumb list
        for (var t = 0; t < thumbs.length; t++){
          if (thumbs[t].dataset.src === v.featured_image){
            idx = t;
            for (var tt = 0; tt < thumbs.length; tt++) thumbs[tt].classList.remove('is-on');
            thumbs[t].classList.add('is-on');
            if (countEl) countEl.textContent = (t+1) + ' / ' + thumbs.length;
            break;
          }
        }
      }

      // Update price + savings (multiply by qty)
      var price = v ? v.price : 0;
      var compare = v ? v.compare_at_price : 0;
      var total = price * qty;
      var totalCompare = compare * qty;

      if (priceNowEl) priceNowEl.textContent = fmt(total);

      if (priceWasEl){
        if (compare > price){
          priceWasEl.textContent = fmt(totalCompare);
          priceWasEl.style.display = '';
        } else {
          priceWasEl.textContent = '';
          priceWasEl.style.display = 'none';
        }
      }

      if (priceSaveEl){
        if (compare > price){
          var savings = Math.round((compare - price) / compare * 100);
          priceSaveEl.textContent = 'SAVE ' + savings + '%';
          priceSaveEl.style.display = '';
        } else {
          priceSaveEl.textContent = '';
          priceSaveEl.style.display = 'none';
        }
      }

      // Update CTA (state + label)
      var addLabel = root.dataset.ctaAdd || 'Add to Cart';
      var soldoutLabel = root.dataset.ctaSoldout || 'Sold Out';
      var unavailLabel = root.dataset.ctaUnavailable || 'Unavailable';

      var available = v && v.available;
      if (ctaBtn){
        if (!available){
          ctaBtn.classList.add('is-soldout');
          ctaBtn.disabled = true;
        } else {
          ctaBtn.classList.remove('is-soldout');
          ctaBtn.disabled = false;
        }
      }
      if (ctaText){
        if (!v){
          ctaText.textContent = unavailLabel;
        } else if (!v.available){
          ctaText.textContent = soldoutLabel;
        } else {
          ctaText.textContent = addLabel + ' · ' + fmt(total);
        }
      }

      // Update inline "selected value" display in each variant group label
      for (var i = 0; i < optionGroups.length; i++){
        var group = optionGroups[i];
        var dispEl = group.querySelector('[data-option-value-display]');
        var oIdx = parseInt(group.dataset.optionIdx, 10);
        if (dispEl) dispEl.textContent = selectedValues[oIdx] || '';
      }
    }

    // ===== Bind variant option clicks (swatches + pills) =====
    var optionBtns = root.querySelectorAll('[data-option-idx][data-value]');
    for (var k = 0; k < optionBtns.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (btn.classList.contains('is-unavailable')) return;
          var oIdx = parseInt(btn.dataset.optionIdx, 10);
          var value = btn.dataset.value;
          selectedValues[oIdx] = value;
          // Toggle is-on among siblings of the same option group
          var siblings = root.querySelectorAll('[data-option-idx="' + oIdx + '"][data-value]');
          for (var s = 0; s < siblings.length; s++) siblings[s].classList.remove('is-on');
          btn.classList.add('is-on');
          render();
        });
      })(optionBtns[k]);
    }

    // ===== Quantity stepper =====
    function setQty(n){
      n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      qty = n;
      if (qtyDisplay) qtyDisplay.value = String(n);
      if (qtyHiddenInput) qtyHiddenInput.value = String(n);
      if (qtyMinus) qtyMinus.disabled = n <= 1;
      render();
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty + 1); });
    if (qtyDisplay){
      qtyDisplay.addEventListener('change', function(){ setQty(qtyDisplay.value); });
      qtyDisplay.addEventListener('input', function(){
        var v = parseInt(qtyDisplay.value, 10);
        if (!isNaN(v)){ qty = Math.max(1, Math.min(99, v)); if (qtyHiddenInput) qtyHiddenInput.value = String(qty); render(); }
      });
    }

    // ===== Form submit guard =====
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form){
      form.addEventListener('submit', function(ev){
        if (ctaBtn && ctaBtn.disabled){ ev.preventDefault(); }
      });
    }

    // ===== Gallery =====
    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try { active.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); } catch(e){
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    for (var k2 = 0; k2 < thumbs.length; k2++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k2);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // ===== Drag-to-scroll on thumb strip (desktop) =====
    if (thumbsContainer && thumbs.length > 1){
      var tDown=false, tStartX=0, tStartScroll=0, tMoved=false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true; tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){ tDown = false; thumbsContainer._bbxDragged = false; }
      });
    }

    // ===== Main image swipe (touch + mouse drag) =====
    if (mainBox && thumbs.length > 1){
      var sx=0, sy=0, swiping=false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, {passive:true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive:true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive:true});

      var mx=0, my=0, mdown=false, mmoved=false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true; mmoved = false; mx = e.clientX; my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    setQty(1);
    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["26-buybox-universal-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    // ===== Variants data =====
    var variants = [];
    var variantsScript = document.querySelector('script[data-bbx-variants="' + (root.id || '').replace('bbx-', '') + '"]');
    if (!variantsScript){
      // Fallback: find first variants script (single-section pages)
      variantsScript = document.querySelector('script[data-bbx-variants]');
    }
    if (variantsScript){
      try { variants = JSON.parse(variantsScript.textContent); } catch(e){}
    }

    // ===== Refs =====
    var optionGroups = root.querySelectorAll('.bbx__variant-group');
    var variantIdInput = root.querySelector('input[name="id"]');
    var qtyHiddenInput = root.querySelector('input[name="quantity"]');
    var qtyDisplay = root.querySelector('[data-qty-input]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var priceNowEl = root.querySelector('[data-bbx-price-now]');
    var priceWasEl = root.querySelector('[data-bbx-price-was]');
    var priceSaveEl = root.querySelector('[data-bbx-price-save]');
    var ctaBtn = root.querySelector('[data-bbx-cta]');
    var ctaText = root.querySelector('[data-bbx-cta-text]');
    var main = root.querySelector('.bbx__main img');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var mainBox = root.querySelector('.bbx__main');

    var qty = 1;
    var idx = 0;

    // ===== Initial selection state (from server-rendered .is-on classes) =====
    var selectedValues = [];
    for (var g = 0; g < optionGroups.length; g++){
      var group = optionGroups[g];
      var oIdx = parseInt(group.dataset.optionIdx, 10);
      var selectedBtn = group.querySelector('[data-value].is-on');
      selectedValues[oIdx] = selectedBtn ? selectedBtn.dataset.value : null;
    }

    function findVariant(sel){
      if (!variants.length) return null;
      // If no options at all (selectedValues empty), return first variant
      if (sel.length === 0) return variants[0];
      for (var i = 0; i < variants.length; i++){
        var v = variants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++){
          if (v.options[j] !== sel[j]){ match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function render(){
      var v = findVariant(selectedValues);

      // Update form variant ID
      if (v && variantIdInput) variantIdInput.value = String(v.id);

      // Update URL ?variant=ID
      if (v && window.history && window.history.replaceState){
        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(null, '', url);
        } catch(e){}
      }

      // Swap main image to variant's featured_image
      if (v && v.featured_image && main && main.src !== v.featured_image){
        // Same ratio re-point as setSlide(), sourced from the matching thumb.
        // Must run BEFORE main.src is reassigned, or the box holds the old
        // image's height until the new one decodes.
        for (var t0 = 0; t0 < thumbs.length; t0++){
          if (thumbs[t0].dataset.src === v.featured_image){
            var vw = thumbs[t0].dataset.w, vh = thumbs[t0].dataset.h;
            if (vw && vh){ main.setAttribute('width', vw); main.setAttribute('height', vh); }
            break;
          }
        }
        main.src = v.featured_image;
        // Sync gallery idx to that image if it's in the thumb list
        for (var t = 0; t < thumbs.length; t++){
          if (thumbs[t].dataset.src === v.featured_image){
            idx = t;
            for (var tt = 0; tt < thumbs.length; tt++) thumbs[tt].classList.remove('is-on');
            thumbs[t].classList.add('is-on');
            if (countEl) countEl.textContent = (t+1) + ' / ' + thumbs.length;
            break;
          }
        }
      }

      // Update price + savings (multiply by qty)
      var price = v ? v.price : 0;
      var compare = v ? v.compare_at_price : 0;
      var total = price * qty;
      var totalCompare = compare * qty;

      if (priceNowEl) priceNowEl.textContent = fmt(total);

      if (priceWasEl){
        if (compare > price){
          priceWasEl.textContent = fmt(totalCompare);
          priceWasEl.style.display = '';
        } else {
          priceWasEl.textContent = '';
          priceWasEl.style.display = 'none';
        }
      }

      if (priceSaveEl){
        if (compare > price){
          var bbxOvr = parseInt(priceSaveEl.getAttribute('data-bbx-save-override') || '0', 10);
          var savings = (bbxOvr > 0) ? bbxOvr : Math.round((compare - price) / compare * 100);
          priceSaveEl.textContent = 'SAVE ' + savings + '%';
          priceSaveEl.style.display = '';
        } else {
          priceSaveEl.textContent = '';
          priceSaveEl.style.display = 'none';
        }
      }

      // Update CTA (state + label)
      var addLabel = root.dataset.ctaAdd || 'Add to Cart';
      var soldoutLabel = root.dataset.ctaSoldout || 'Sold Out';
      var unavailLabel = root.dataset.ctaUnavailable || 'Unavailable';

      var available = v && v.available;
      if (ctaBtn){
        if (!available){
          ctaBtn.classList.add('is-soldout');
          ctaBtn.disabled = true;
        } else {
          ctaBtn.classList.remove('is-soldout');
          ctaBtn.disabled = false;
        }
      }
      if (ctaText){
        if (!v){
          ctaText.textContent = unavailLabel;
        } else if (!v.available){
          ctaText.textContent = soldoutLabel;
        } else {
          ctaText.textContent = addLabel + ' · ' + fmt(window.AJVIP ? window.AJVIP.cta(root, total) : total);
        }
      }

      // Update inline "selected value" display in each variant group label
      for (var i = 0; i < optionGroups.length; i++){
        var group = optionGroups[i];
        var dispEl = group.querySelector('[data-option-value-display]');
        var oIdx = parseInt(group.dataset.optionIdx, 10);
        if (dispEl) dispEl.textContent = selectedValues[oIdx] || '';
      }
    }

    // ===== Bind variant option clicks (swatches + pills) =====
    var optionBtns = root.querySelectorAll('[data-option-idx][data-value]');
    for (var k = 0; k < optionBtns.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (btn.classList.contains('is-unavailable')) return;
          var oIdx = parseInt(btn.dataset.optionIdx, 10);
          var value = btn.dataset.value;
          selectedValues[oIdx] = value;
          // Toggle is-on among siblings of the same option group
          var siblings = root.querySelectorAll('[data-option-idx="' + oIdx + '"][data-value]');
          for (var s = 0; s < siblings.length; s++) siblings[s].classList.remove('is-on');
          btn.classList.add('is-on');
          render();
        });
      })(optionBtns[k]);
    }

    // ===== Quantity stepper =====
    function setQty(n){
      n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      qty = n;
      if (qtyDisplay) qtyDisplay.value = String(n);
      if (qtyHiddenInput) qtyHiddenInput.value = String(n);
      if (qtyMinus) qtyMinus.disabled = n <= 1;
      render();
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty + 1); });
    if (qtyDisplay){
      qtyDisplay.addEventListener('change', function(){ setQty(qtyDisplay.value); });
      qtyDisplay.addEventListener('input', function(){
        var v = parseInt(qtyDisplay.value, 10);
        if (!isNaN(v)){ qty = Math.max(1, Math.min(99, v)); if (qtyHiddenInput) qtyHiddenInput.value = String(qty); render(); }
      });
    }

    // ===== Form submit guard =====
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form){
      form.addEventListener('submit', function(ev){
        if (ctaBtn && ctaBtn.disabled){ ev.preventDefault(); }
      });
    }

    // ===== Gallery =====
    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try { active.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); } catch(e){
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    for (var k2 = 0; k2 < thumbs.length; k2++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k2);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // ===== Drag-to-scroll on thumb strip (desktop) =====
    if (thumbsContainer && thumbs.length > 1){
      var tDown=false, tStartX=0, tStartScroll=0, tMoved=false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true; tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){ tDown = false; thumbsContainer._bbxDragged = false; }
      });
    }

    // ===== Main image swipe (touch + mouse drag) =====
    if (mainBox && thumbs.length > 1){
      var sx=0, sy=0, swiping=false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, {passive:true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive:true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive:true});

      var mx=0, my=0, mdown=false, mmoved=false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true; mmoved = false; mx = e.clientX; my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    setQty(1);
    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["26-buybox-universal-v3"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    // ===== Variants data =====
    var variants = [];
    var variantsScript = document.querySelector('script[data-bbx-variants="' + (root.id || '').replace('bbx-', '') + '"]');
    if (!variantsScript){
      // Fallback: find first variants script (single-section pages)
      variantsScript = document.querySelector('script[data-bbx-variants]');
    }
    if (variantsScript){
      try { variants = JSON.parse(variantsScript.textContent); } catch(e){}
    }

    // ===== Refs =====
    var optionGroups = root.querySelectorAll('.bbx__variant-group');
    var variantIdInput = root.querySelector('input[name="id"]');
    var qtyHiddenInput = root.querySelector('input[name="quantity"]');
    var qtyDisplay = root.querySelector('[data-qty-input]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var priceNowEl = root.querySelector('[data-bbx-price-now]');
    var priceWasEl = root.querySelector('[data-bbx-price-was]');
    var priceSaveEl = root.querySelector('[data-bbx-price-save]');
    var ctaBtn = root.querySelector('[data-bbx-cta]');
    var ctaText = root.querySelector('[data-bbx-cta-text]');
    var main = root.querySelector('.bbx__main img');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var mainBox = root.querySelector('.bbx__main');

    var qty = 1;
    var idx = 0;

    // ===== Initial selection state (from server-rendered .is-on classes) =====
    var selectedValues = [];
    for (var g = 0; g < optionGroups.length; g++){
      var group = optionGroups[g];
      var oIdx = parseInt(group.dataset.optionIdx, 10);
      var selectedBtn = group.querySelector('[data-value].is-on');
      selectedValues[oIdx] = selectedBtn ? selectedBtn.dataset.value : null;
    }

    function findVariant(sel){
      if (!variants.length) return null;
      // If no options at all (selectedValues empty), return first variant
      if (sel.length === 0) return variants[0];
      for (var i = 0; i < variants.length; i++){
        var v = variants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++){
          if (v.options[j] !== sel[j]){ match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function render(){
      var v = findVariant(selectedValues);

      // Update form variant ID
      if (v && variantIdInput) variantIdInput.value = String(v.id);

      // Update URL ?variant=ID
      if (v && window.history && window.history.replaceState){
        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(null, '', url);
        } catch(e){}
      }

      // Swap main image to variant's featured_image
      if (v && v.featured_image && main && main.src !== v.featured_image){
        main.src = v.featured_image;
        // Sync gallery idx to that image if it's in the thumb list
        for (var t = 0; t < thumbs.length; t++){
          if (thumbs[t].dataset.src === v.featured_image){
            idx = t;
            for (var tt = 0; tt < thumbs.length; tt++) thumbs[tt].classList.remove('is-on');
            thumbs[t].classList.add('is-on');
            if (countEl) countEl.textContent = (t+1) + ' / ' + thumbs.length;
            break;
          }
        }
      }

      // Update price + savings (multiply by qty)
      var price = v ? v.price : 0;
      var compare = v ? v.compare_at_price : 0;
      var total = price * qty;
      var totalCompare = compare * qty;

      if (priceNowEl) priceNowEl.textContent = fmt(total);

      if (priceWasEl){
        if (compare > price){
          priceWasEl.textContent = fmt(totalCompare);
          priceWasEl.style.display = '';
        } else {
          priceWasEl.textContent = '';
          priceWasEl.style.display = 'none';
        }
      }

      if (priceSaveEl){
        if (compare > price){
          var savings = Math.round((compare - price) / compare * 100);
          priceSaveEl.textContent = 'SAVE ' + savings + '%';
          priceSaveEl.style.display = '';
        } else {
          priceSaveEl.textContent = '';
          priceSaveEl.style.display = 'none';
        }
      }

      // Update CTA (state + label)
      var addLabel = root.dataset.ctaAdd || 'Add to Cart';
      var soldoutLabel = root.dataset.ctaSoldout || 'Sold Out';
      var unavailLabel = root.dataset.ctaUnavailable || 'Unavailable';

      var available = v && v.available;
      if (ctaBtn){
        if (!available){
          ctaBtn.classList.add('is-soldout');
          ctaBtn.disabled = true;
        } else {
          ctaBtn.classList.remove('is-soldout');
          ctaBtn.disabled = false;
        }
      }
      if (ctaText){
        if (!v){
          ctaText.textContent = unavailLabel;
        } else if (!v.available){
          ctaText.textContent = soldoutLabel;
        } else {
          ctaText.textContent = addLabel + ' · ' + fmt(total);
        }
      }

      // Update inline "selected value" display in each variant group label
      for (var i = 0; i < optionGroups.length; i++){
        var group = optionGroups[i];
        var dispEl = group.querySelector('[data-option-value-display]');
        var oIdx = parseInt(group.dataset.optionIdx, 10);
        if (dispEl) dispEl.textContent = selectedValues[oIdx] || '';
      }
    }

    // ===== Bind variant option clicks (swatches + pills) =====
    var optionBtns = root.querySelectorAll('[data-option-idx][data-value]');
    for (var k = 0; k < optionBtns.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (btn.classList.contains('is-unavailable')) return;
          var oIdx = parseInt(btn.dataset.optionIdx, 10);
          var value = btn.dataset.value;
          selectedValues[oIdx] = value;
          // Toggle is-on among siblings of the same option group
          var siblings = root.querySelectorAll('[data-option-idx="' + oIdx + '"][data-value]');
          for (var s = 0; s < siblings.length; s++) siblings[s].classList.remove('is-on');
          btn.classList.add('is-on');
          render();
        });
      })(optionBtns[k]);
    }

    // ===== Quantity stepper =====
    function setQty(n){
      n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      qty = n;
      if (qtyDisplay) qtyDisplay.value = String(n);
      if (qtyHiddenInput) qtyHiddenInput.value = String(n);
      if (qtyMinus) qtyMinus.disabled = n <= 1;
      render();
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty + 1); });
    if (qtyDisplay){
      qtyDisplay.addEventListener('change', function(){ setQty(qtyDisplay.value); });
      qtyDisplay.addEventListener('input', function(){
        var v = parseInt(qtyDisplay.value, 10);
        if (!isNaN(v)){ qty = Math.max(1, Math.min(99, v)); if (qtyHiddenInput) qtyHiddenInput.value = String(qty); render(); }
      });
    }

    // ===== Form submit guard =====
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form){
      form.addEventListener('submit', function(ev){
        if (ctaBtn && ctaBtn.disabled){ ev.preventDefault(); }
      });
    }

    // ===== Gallery =====
    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try { active.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); } catch(e){
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    for (var k2 = 0; k2 < thumbs.length; k2++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k2);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // ===== Drag-to-scroll on thumb strip (desktop) =====
    if (thumbsContainer && thumbs.length > 1){
      var tDown=false, tStartX=0, tStartScroll=0, tMoved=false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true; tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){ tDown = false; thumbsContainer._bbxDragged = false; }
      });
    }

    // ===== Main image swipe (touch + mouse drag) =====
    if (mainBox && thumbs.length > 1){
      var sx=0, sy=0, swiping=false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, {passive:true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive:true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive:true});

      var mx=0, my=0, mdown=false, mmoved=false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true; mmoved = false; mx = e.clientX; my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    setQty(1);
    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["26-buybox-universal-v4"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    // ===== Variants data =====
    var variants = [];
    var variantsScript = document.querySelector('script[data-bbx-variants="' + (root.id || '').replace('bbx-', '') + '"]');
    if (!variantsScript){
      // Fallback: find first variants script (single-section pages)
      variantsScript = document.querySelector('script[data-bbx-variants]');
    }
    if (variantsScript){
      try { variants = JSON.parse(variantsScript.textContent); } catch(e){}
    }

    // ===== Refs =====
    var optionGroups = root.querySelectorAll('.bbx__variant-group');
    var variantIdInput = root.querySelector('input[name="id"]');
    var qtyHiddenInput = root.querySelector('input[name="quantity"]');
    var qtyDisplay = root.querySelector('[data-qty-input]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var priceNowEl = root.querySelector('[data-bbx-price-now]');
    var priceWasEl = root.querySelector('[data-bbx-price-was]');
    var priceSaveEl = root.querySelector('[data-bbx-price-save]');
    var ctaBtn = root.querySelector('[data-bbx-cta]');
    var ctaText = root.querySelector('[data-bbx-cta-text]');
    var main = root.querySelector('.bbx__main img');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var mainBox = root.querySelector('.bbx__main');

    var qty = 1;
    var idx = 0;

    // ===== Initial selection state (from server-rendered .is-on classes) =====
    var selectedValues = [];
    for (var g = 0; g < optionGroups.length; g++){
      var group = optionGroups[g];
      var oIdx = parseInt(group.dataset.optionIdx, 10);
      var selectedBtn = group.querySelector('[data-value].is-on');
      selectedValues[oIdx] = selectedBtn ? selectedBtn.dataset.value : null;
    }

    function findVariant(sel){
      if (!variants.length) return null;
      // If no options at all (selectedValues empty), return first variant
      if (sel.length === 0) return variants[0];
      for (var i = 0; i < variants.length; i++){
        var v = variants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++){
          if (v.options[j] !== sel[j]){ match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function render(){
      var v = findVariant(selectedValues);

      // Update form variant ID
      if (v && variantIdInput) variantIdInput.value = String(v.id);

      // Update URL ?variant=ID
      if (v && window.history && window.history.replaceState){
        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(null, '', url);
        } catch(e){}
      }

      // Swap main image to variant's featured_image
      if (v && v.featured_image && main && main.src !== v.featured_image){
        main.src = v.featured_image;
        // Sync gallery idx to that image if it's in the thumb list
        for (var t = 0; t < thumbs.length; t++){
          if (thumbs[t].dataset.src === v.featured_image){
            idx = t;
            for (var tt = 0; tt < thumbs.length; tt++) thumbs[tt].classList.remove('is-on');
            thumbs[t].classList.add('is-on');
            if (countEl) countEl.textContent = (t+1) + ' / ' + thumbs.length;
            break;
          }
        }
      }

      // Update price + savings (multiply by qty)
      var price = v ? v.price : 0;
      var compare = v ? v.compare_at_price : 0;
      var total = price * qty;
      var totalCompare = compare * qty;

      if (priceNowEl) priceNowEl.textContent = fmt(total);

      if (priceWasEl){
        if (compare > price){
          priceWasEl.textContent = fmt(totalCompare);
          priceWasEl.style.display = '';
        } else {
          priceWasEl.textContent = '';
          priceWasEl.style.display = 'none';
        }
      }

      if (priceSaveEl){
        if (compare > price){
          var savings = Math.round((compare - price) / compare * 100);
          priceSaveEl.textContent = 'SAVE ' + savings + '%';
          priceSaveEl.style.display = '';
        } else {
          priceSaveEl.textContent = '';
          priceSaveEl.style.display = 'none';
        }
      }

      // Update CTA (state + label)
      var addLabel = root.dataset.ctaAdd || 'Add to Cart';
      var soldoutLabel = root.dataset.ctaSoldout || 'Sold Out';
      var unavailLabel = root.dataset.ctaUnavailable || 'Unavailable';

      var available = v && v.available;
      if (ctaBtn){
        if (!available){
          ctaBtn.classList.add('is-soldout');
          ctaBtn.disabled = true;
        } else {
          ctaBtn.classList.remove('is-soldout');
          ctaBtn.disabled = false;
        }
      }
      if (ctaText){
        if (!v){
          ctaText.textContent = unavailLabel;
        } else if (!v.available){
          ctaText.textContent = soldoutLabel;
        } else {
          ctaText.textContent = addLabel + ' · ' + fmt(total);
        }
      }

      // Update inline "selected value" display in each variant group label
      for (var i = 0; i < optionGroups.length; i++){
        var group = optionGroups[i];
        var dispEl = group.querySelector('[data-option-value-display]');
        var oIdx = parseInt(group.dataset.optionIdx, 10);
        if (dispEl) dispEl.textContent = selectedValues[oIdx] || '';
      }
    }

    // ===== Bind variant option clicks (swatches + pills) =====
    var optionBtns = root.querySelectorAll('[data-option-idx][data-value]');
    for (var k = 0; k < optionBtns.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (btn.classList.contains('is-unavailable')) return;
          var oIdx = parseInt(btn.dataset.optionIdx, 10);
          var value = btn.dataset.value;
          selectedValues[oIdx] = value;
          // Toggle is-on among siblings of the same option group
          var siblings = root.querySelectorAll('[data-option-idx="' + oIdx + '"][data-value]');
          for (var s = 0; s < siblings.length; s++) siblings[s].classList.remove('is-on');
          btn.classList.add('is-on');
          render();
        });
      })(optionBtns[k]);
    }

    // ===== Quantity stepper =====
    function setQty(n){
      n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      qty = n;
      if (qtyDisplay) qtyDisplay.value = String(n);
      if (qtyHiddenInput) qtyHiddenInput.value = String(n);
      if (qtyMinus) qtyMinus.disabled = n <= 1;
      render();
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty + 1); });
    if (qtyDisplay){
      qtyDisplay.addEventListener('change', function(){ setQty(qtyDisplay.value); });
      qtyDisplay.addEventListener('input', function(){
        var v = parseInt(qtyDisplay.value, 10);
        if (!isNaN(v)){ qty = Math.max(1, Math.min(99, v)); if (qtyHiddenInput) qtyHiddenInput.value = String(qty); render(); }
      });
    }

    // ===== Form submit guard =====
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form){
      form.addEventListener('submit', function(ev){
        if (ctaBtn && ctaBtn.disabled){ ev.preventDefault(); }
      });
    }

    // ===== Gallery =====
    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try { active.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); } catch(e){
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    for (var k2 = 0; k2 < thumbs.length; k2++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k2);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // ===== Drag-to-scroll on thumb strip (desktop) =====
    if (thumbsContainer && thumbs.length > 1){
      var tDown=false, tStartX=0, tStartScroll=0, tMoved=false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true; tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){ tDown = false; thumbsContainer._bbxDragged = false; }
      });
    }

    // ===== Main image swipe (touch + mouse drag) =====
    if (mainBox && thumbs.length > 1){
      var sx=0, sy=0, swiping=false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, {passive:true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive:true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive:true});

      var mx=0, my=0, mdown=false, mmoved=false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true; mmoved = false; mx = e.clientX; my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    setQty(1);
    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["26-buybox-universal"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    // ===== Variants data =====
    var variants = [];
    var variantsScript = document.querySelector('script[data-bbx-variants="' + (root.id || '').replace('bbx-', '') + '"]');
    if (!variantsScript){
      // Fallback: find first variants script (single-section pages)
      variantsScript = document.querySelector('script[data-bbx-variants]');
    }
    if (variantsScript){
      try { variants = JSON.parse(variantsScript.textContent); } catch(e){}
    }

    // ===== Refs =====
    var optionGroups = root.querySelectorAll('.bbx__variant-group');
    var variantIdInput = root.querySelector('input[name="id"]');
    var qtyHiddenInput = root.querySelector('input[name="quantity"]');
    var qtyDisplay = root.querySelector('[data-qty-input]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var priceNowEl = root.querySelector('[data-bbx-price-now]');
    var priceWasEl = root.querySelector('[data-bbx-price-was]');
    var priceSaveEl = root.querySelector('[data-bbx-price-save]');
    var ctaBtn = root.querySelector('[data-bbx-cta]');
    var ctaText = root.querySelector('[data-bbx-cta-text]');
    var main = root.querySelector('.bbx__main img');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var mainBox = root.querySelector('.bbx__main');
    var chip = root.querySelector('.bbx__chip');

    // ===== Colour-filtered gallery (opt-in; no-op when not configured) =====
    var cfOptIdx = thumbsContainer && thumbsContainer.dataset.bbxColorOpt !== undefined
      ? parseInt(thumbsContainer.dataset.bbxColorOpt, 10) : -1;
    function visThumbs(){
      var out = [];
      for (var i = 0; i < thumbs.length; i++){
        if (!thumbs[i].classList.contains('bbx-hide')) out.push(thumbs[i]);
      }
      return out;
    }
    function applyColorFilter(){
      if (cfOptIdx < 0 || isNaN(cfOptIdx)) return false;
      var want = selectedValues[cfOptIdx];
      if (!want) return false;
      var changed = false;
      for (var i = 0; i < thumbs.length; i++){
        var c = thumbs[i].dataset.bbxColor;       // undefined = shared, always shown
        var hide = (c !== undefined && c !== want);
        if (thumbs[i].classList.contains('bbx-hide') !== hide){
          thumbs[i].classList.toggle('bbx-hide', hide);
          changed = true;
        }
      }
      return changed;
    }

    var qty = 1;
    var idx = 0;

    // ===== Initial selection state (from server-rendered .is-on classes) =====
    var selectedValues = [];
    for (var g = 0; g < optionGroups.length; g++){
      var group = optionGroups[g];
      var oIdx = parseInt(group.dataset.optionIdx, 10);
      var selectedBtn = group.querySelector('[data-value].is-on');
      selectedValues[oIdx] = selectedBtn ? selectedBtn.dataset.value : null;
    }

    function findVariant(sel){
      if (!variants.length) return null;
      // If no options at all (selectedValues empty), return first variant
      if (sel.length === 0) return variants[0];
      for (var i = 0; i < variants.length; i++){
        var v = variants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++){
          if (v.options[j] !== sel[j]){ match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function render(){
      var v = findVariant(selectedValues);

      // Update form variant ID
      if (v && variantIdInput) variantIdInput.value = String(v.id);

      // Update URL ?variant=ID
      if (v && window.history && window.history.replaceState){
        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(null, '', url);
        } catch(e){}
      }

      // Colour filter first, so the gallery below counts only visible thumbs
      var cfChanged = applyColorFilter();

      // Swap main image to variant's featured_image
      if (v && v.featured_image && main && main.src !== v.featured_image){
        main.src = v.featured_image;
        // Sync gallery idx to that image if it's in the visible thumb list
        var vlist = visThumbs();
        for (var t = 0; t < vlist.length; t++){
          if (vlist[t].dataset.src === v.featured_image){
            idx = t;
            for (var tt = 0; tt < thumbs.length; tt++) thumbs[tt].classList.remove('is-on');
            vlist[t].classList.add('is-on');
            if (countEl) countEl.textContent = (t+1) + ' / ' + vlist.length;
            if (chip) chip.style.display = (t === 0) ? '' : 'none';
            break;
          }
        }
      } else if (cfChanged){
        // Colour changed but the hero image did not: reset to that colour's first image
        setSlide(0);
      }

      // Update price + savings (multiply by qty)
      var price = v ? v.price : 0;
      var compare = v ? v.compare_at_price : 0;
      var total = price * qty;
      var totalCompare = compare * qty;

      if (priceNowEl) priceNowEl.textContent = fmt(total);

      if (priceWasEl){
        if (compare > price){
          priceWasEl.textContent = fmt(totalCompare);
          priceWasEl.style.display = '';
        } else {
          priceWasEl.textContent = '';
          priceWasEl.style.display = 'none';
        }
      }

      if (priceSaveEl){
        if (compare > price){
          var savings = Math.round((compare - price) / compare * 100 / 5) * 5;
          priceSaveEl.textContent = 'SAVE ' + savings + '%';
          priceSaveEl.style.display = '';
        } else {
          priceSaveEl.textContent = '';
          priceSaveEl.style.display = 'none';
        }
      }

      // Update CTA (state + label)
      var addLabel = root.dataset.ctaAdd || 'Add to Cart';
      var soldoutLabel = root.dataset.ctaSoldout || 'Sold Out';
      var unavailLabel = root.dataset.ctaUnavailable || 'Unavailable';

      var available = v && v.available;
      if (ctaBtn){
        if (!available){
          ctaBtn.classList.add('is-soldout');
          ctaBtn.disabled = true;
        } else {
          ctaBtn.classList.remove('is-soldout');
          ctaBtn.disabled = false;
        }
      }
      if (ctaText){
        if (!v){
          ctaText.textContent = unavailLabel;
        } else if (!v.available){
          ctaText.textContent = soldoutLabel;
        } else {
          ctaText.textContent = addLabel + ' · ' + fmt(window.AJVIP ? window.AJVIP.cta(root, total) : total);
        }
      }

      // Update inline "selected value" display in each variant group label
      for (var i = 0; i < optionGroups.length; i++){
        var group = optionGroups[i];
        var dispEl = group.querySelector('[data-option-value-display]');
        var oIdx = parseInt(group.dataset.optionIdx, 10);
        if (dispEl) dispEl.textContent = selectedValues[oIdx] || '';
      }
    }

    // ===== Bind variant option clicks (swatches + pills) =====
    var optionBtns = root.querySelectorAll('[data-option-idx][data-value]');
    for (var k = 0; k < optionBtns.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (btn.classList.contains('is-unavailable')) return;
          var oIdx = parseInt(btn.dataset.optionIdx, 10);
          var value = btn.dataset.value;
          selectedValues[oIdx] = value;
          // Toggle is-on among siblings of the same option group
          var siblings = root.querySelectorAll('[data-option-idx="' + oIdx + '"][data-value]');
          for (var s = 0; s < siblings.length; s++) siblings[s].classList.remove('is-on');
          btn.classList.add('is-on');
          render();
        });
      })(optionBtns[k]);
    }

    // ===== Quantity stepper =====
    function setQty(n){
      n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      qty = n;
      if (qtyDisplay) qtyDisplay.value = String(n);
      if (qtyHiddenInput) qtyHiddenInput.value = String(n);
      if (qtyMinus) qtyMinus.disabled = n <= 1;
      render();
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty + 1); });
    if (qtyDisplay){
      qtyDisplay.addEventListener('change', function(){ setQty(qtyDisplay.value); });
      qtyDisplay.addEventListener('input', function(){
        var v = parseInt(qtyDisplay.value, 10);
        if (!isNaN(v)){ qty = Math.max(1, Math.min(99, v)); if (qtyHiddenInput) qtyHiddenInput.value = String(qty); render(); }
      });
    }

    // ===== Form submit guard =====
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form){
      form.addEventListener('submit', function(ev){
        if (ctaBtn && ctaBtn.disabled){ ev.preventDefault(); }
      });
    }

    // ===== Gallery =====
    function setSlide(n){
      var list = visThumbs();
      if (!list.length) return;
      var len = list.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      list[idx].classList.add('is-on');
      var src = list[idx].dataset.src;
      if (main && src) main.src = src;
      if (chip) chip.style.display = (idx === 0) ? '' : 'none';
      if (countEl) countEl.textContent = (idx+1) + ' / ' + len;
      var active = list[idx];
      if (active && active.scrollIntoView){
        try { active.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); } catch(e){
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    for (var k2 = 0; k2 < thumbs.length; k2++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          var pos = visThumbs().indexOf(thumbs[i]);
          setSlide(pos < 0 ? 0 : pos);
        });
      })(k2);
    }
    if (applyColorFilter()){ setSlide(0); }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // ===== Drag-to-scroll on thumb strip (desktop) =====
    if (thumbsContainer && thumbs.length > 1){
      var tDown=false, tStartX=0, tStartScroll=0, tMoved=false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true; tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){ tDown = false; thumbsContainer._bbxDragged = false; }
      });
    }

    // ===== Main image swipe (touch + mouse drag) =====
    if (mainBox && thumbs.length > 1){
      var sx=0, sy=0, swiping=false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, {passive:true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive:true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive:true});

      var mx=0, my=0, mdown=false, mmoved=false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true; mmoved = false; mx = e.clientX; my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    setQty(1);
    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["26-greens-kids"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;
    var wasPrefix = root.dataset.wasPrefix || 'was';

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var idInput   = root.querySelector('input[name="id"]');
    var ctaBtn    = root.querySelector('.bbx__cta');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    // ---- Variant data island ----
    var vmap = {};
    var vscript = root.querySelector('[id^="bbx-vdata-"]');
    if (vscript){ try { vmap = JSON.parse(vscript.textContent); } catch(e){ vmap = {}; } }
    var variantBtns = root.querySelectorAll('.bbx__variant');
    var curAvail = true;

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    // Push a variant's numbers into the qty rows + hidden id + gallery + "was" prices
    function applyVariant(id){
      var d = vmap[id];
      if (!d) return;
      if (idInput) idInput.value = id;
      curAvail = d.avail !== false;
      for (var r = 0; r < qtyRows.length; r++){
        var row = qtyRows[r];
        var n = parseInt(row.dataset.qty, 10);
        var k = n - 1;
        if (k < 0 || k > 2) continue;
        row.dataset.oncePrice = d.once[k];
        row.dataset.onceDisc  = d.oncedisc[k];
        row.dataset.subPrice  = d.sub[k];
        row.dataset.subDisc   = d.subdisc[k];
        row.dataset.subPlan   = d.plan[k] || '';
        var wasEl = row.querySelector('.bbx__qty-was');
        if (wasEl && d.base){ wasEl.textContent = wasPrefix + ' ' + fmt(d.base); }
      }
      // Kids section: d.alt is always '' (see the Liquid island), so this shows
      // every thumb. Kept as-is so the code stays diffable against 26-greens-v2.
      filterGallery(d.alt || '', d.img || '');
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        var wasEl2  = b.querySelector('.bbx__qty-was');
        if (priceEl) priceEl.textContent = fmt(price);
        // 0% off -> no badge, no strikethrough, just the full price.
        if (saveEl){
          if (disc > 0){
            saveEl.hidden = false;
            saveEl.textContent = disc + '% OFF';
          } else {
            saveEl.hidden = true;
            saveEl.textContent = '';
          }
        }
        if (wasEl2) wasEl2.hidden = !(disc > 0);
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (activeRow){
        var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
        var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
        var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
        var totalCents = unit * qty;
        var days = qty * 30;
        var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
        var subLabel  = root.dataset.ctaSub  || 'Start Now';
        if (ctaText){
          ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
        }
        if (ctaSub){
          if (plan === 'sub'){
            ctaSub.textContent = days + '-day supply · Auto-Ship selected';
          } else {
            ctaSub.textContent = days + '-day supply · One-time purchase, no Auto-Ship';
          }
        }
      }

      // Sold-out state wins over everything
      if (ctaBtn){
        if (curAvail === false){
          ctaBtn.disabled = true;
          ctaBtn.style.opacity = '0.55';
          ctaBtn.style.cursor = 'not-allowed';
          if (ctaText) ctaText.textContent = 'Sold Out';
          if (ctaSub)  ctaSub.textContent  = 'This option is currently out of stock';
        } else {
          ctaBtn.disabled = false;
          ctaBtn.style.opacity = '';
          ctaBtn.style.cursor = '';
        }
      }
    }

    // Variant button bindings
    for (var vb2 = 0; vb2 < variantBtns.length; vb2++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          for (var x = 0; x < variantBtns.length; x++){
            var on = variantBtns[x] === btn;
            variantBtns[x].classList.toggle('is-on', on);
            variantBtns[x].setAttribute('aria-checked', on ? 'true' : 'false');
          }
          applyVariant(btn.dataset.variantId);
          render();
        });
      })(variantBtns[vb2]);
    }

    // Plan card bindings
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    // Qty row bindings
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var allThumbs = Array.prototype.slice.call(thumbs);
    var activeThumbs = allThumbs;   // current visible subset (after alt-text filter)
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!activeThumbs.length) return;
      var len = activeThumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < allThumbs.length; t++) allThumbs[t].classList.remove('is-on');
      var cur = activeThumbs[idx];
      cur.classList.add('is-on');
      var src = cur.dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + activeThumbs.length;
      if (cur && cur.scrollIntoView){
        try {
          cur.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          if (thumbsContainer){
            var offset = cur.offsetLeft - (thumbsContainer.clientWidth - cur.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }

    // Show only thumbs whose data-alt matches `alt`. Blank alt (or no match) = show all.
    function filterGallery(alt, fallbackImg){
      var subset = allThumbs;
      if (alt){
        var target = String(alt).trim();
        var matched = allThumbs.filter(function(t){ return (t.dataset.alt || '').trim() === target; });
        if (matched.length) subset = matched;
      }
      activeThumbs = subset;
      for (var i = 0; i < allThumbs.length; i++){
        allThumbs[i].style.display = (subset.indexOf(allThumbs[i]) === -1) ? 'none' : '';
      }
      idx = 0;
      if (activeThumbs.length){
        setSlide(0);
      } else if (fallbackImg && main){
        main.src = fallbackImg;
      }
    }

    for (var k = 0; k < allThumbs.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          var pos = activeThumbs.indexOf(btn);
          if (pos !== -1) setSlide(pos);
        });
      })(allThumbs[k]);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    // Sync qty rows to the initially-selected variant, then paint.
    if (idInput && vmap[idInput.value]) applyVariant(idInput.value);
    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["26-greens-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;
    var wasPrefix = root.dataset.wasPrefix || 'was';

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var idInput   = root.querySelector('input[name="id"]');
    var ctaBtn    = root.querySelector('.bbx__cta');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    // ---- Variant data island ----
    var vmap = {};
    var vscript = root.querySelector('[id^="bbx-vdata-"]');
    if (vscript){ try { vmap = JSON.parse(vscript.textContent); } catch(e){ vmap = {}; } }
    var variantBtns = root.querySelectorAll('.bbx__variant');
    var curAvail = true;

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    // Push a variant's numbers into the qty rows + hidden id + gallery + "was" prices
    function applyVariant(id){
      var d = vmap[id];
      if (!d) return;
      if (idInput) idInput.value = id;
      curAvail = d.avail !== false;
      for (var r = 0; r < qtyRows.length; r++){
        var row = qtyRows[r];
        var n = parseInt(row.dataset.qty, 10);
        var k = n - 1;
        if (k < 0 || k > 2) continue;
        row.dataset.oncePrice = d.once[k];
        row.dataset.onceDisc  = d.oncedisc[k];
        row.dataset.subPrice  = d.sub[k];
        row.dataset.subDisc   = d.subdisc[k];
        row.dataset.subPlan   = d.plan[k] || '';
        var wasEl = row.querySelector('.bbx__qty-was');
        if (wasEl && d.base){ wasEl.textContent = wasPrefix + ' ' + fmt(d.base); }
      }
      // Filter the gallery to this variant's images by alt text
      // (Adults -> alt "1", Kids -> alt "2"); falls back to the variant image.
      filterGallery(d.alt || '', d.img || '');
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        var wasEl2  = b.querySelector('.bbx__qty-was');
        if (priceEl) priceEl.textContent = fmt(price);
        // 0% off -> no badge, no strikethrough, just the full price.
        if (saveEl){
          if (disc > 0){
            saveEl.hidden = false;
            saveEl.textContent = disc + '% OFF';
          } else {
            saveEl.hidden = true;
            saveEl.textContent = '';
          }
        }
        if (wasEl2) wasEl2.hidden = !(disc > 0);
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (activeRow){
        var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
        var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
        var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
        var totalCents = unit * qty;
        var days = qty * 30;
        var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
        var subLabel  = root.dataset.ctaSub  || 'Start Now';
        if (ctaText){
          ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
        }
        if (ctaSub){
          if (plan === 'sub'){
            ctaSub.textContent = days + '-day supply · Auto-Ship selected';
          } else {
            ctaSub.textContent = days + '-day supply · One-time purchase, no Auto-Ship';
          }
        }
      }

      // Sold-out state wins over everything
      if (ctaBtn){
        if (curAvail === false){
          ctaBtn.disabled = true;
          ctaBtn.style.opacity = '0.55';
          ctaBtn.style.cursor = 'not-allowed';
          if (ctaText) ctaText.textContent = 'Sold Out';
          if (ctaSub)  ctaSub.textContent  = 'This option is currently out of stock';
        } else {
          ctaBtn.disabled = false;
          ctaBtn.style.opacity = '';
          ctaBtn.style.cursor = '';
        }
      }
    }

    // Variant button bindings
    for (var vb2 = 0; vb2 < variantBtns.length; vb2++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          for (var x = 0; x < variantBtns.length; x++){
            var on = variantBtns[x] === btn;
            variantBtns[x].classList.toggle('is-on', on);
            variantBtns[x].setAttribute('aria-checked', on ? 'true' : 'false');
          }
          applyVariant(btn.dataset.variantId);
          render();
        });
      })(variantBtns[vb2]);
    }

    // Plan card bindings
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    // Qty row bindings
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var allThumbs = Array.prototype.slice.call(thumbs);
    var activeThumbs = allThumbs;   // current visible subset (after alt-text filter)
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!activeThumbs.length) return;
      var len = activeThumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < allThumbs.length; t++) allThumbs[t].classList.remove('is-on');
      var cur = activeThumbs[idx];
      cur.classList.add('is-on');
      var src = cur.dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + activeThumbs.length;
      if (cur && cur.scrollIntoView){
        try {
          cur.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          if (thumbsContainer){
            var offset = cur.offsetLeft - (thumbsContainer.clientWidth - cur.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }

    // Show only thumbs whose data-alt matches `alt`. Blank alt (or no match) = show all.
    function filterGallery(alt, fallbackImg){
      var subset = allThumbs;
      if (alt){
        var target = String(alt).trim();
        var matched = allThumbs.filter(function(t){ return (t.dataset.alt || '').trim() === target; });
        if (matched.length) subset = matched;
      }
      activeThumbs = subset;
      for (var i = 0; i < allThumbs.length; i++){
        allThumbs[i].style.display = (subset.indexOf(allThumbs[i]) === -1) ? 'none' : '';
      }
      idx = 0;
      if (activeThumbs.length){
        setSlide(0);
      } else if (fallbackImg && main){
        main.src = fallbackImg;
      }
    }

    for (var k = 0; k < allThumbs.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          var pos = activeThumbs.indexOf(btn);
          if (pos !== -1) setSlide(pos);
        });
      })(allThumbs[k]);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    // Sync qty rows to the initially-selected variant, then paint.
    if (idInput && vmap[idInput.value]) applyVariant(idInput.value);
    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buy-box-free-shaker"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbxg');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxgInit === '1') continue;
      el.dataset.bbxgInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbxg]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbxg__plan-card');
    var qtyRows   = root.querySelectorAll('.bbxg__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbxg-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbxg-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbxg__qty-row[data-qty="2"] .bbxg__qty-extra');
    var ctaBtn    = root.querySelector('.bbxg__cta');
    var fitRaf    = null;

    // ---- Variant selector (renders only when product has >1 variant) ----
    var idInput     = root.querySelector('input[name="id"]');
    var wasPrefix   = root.dataset.wasPrefix || 'was';
    var variantBtns = root.querySelectorAll('.bbxg__variant');
    var vmap        = {};
    var vscript     = root.querySelector('[id^="bbxg-vd-"]');
    if (vscript){ try { vmap = JSON.parse(vscript.textContent); } catch(e){ vmap = {}; } }
    var curAvail    = true;

    // Gift elements + settings-driven copy (data-attributes on the section root)
    var giftBar     = root.querySelector('.bbxg__gift-bar');
    var giftEyebrow = root.querySelector('[id^="bbxg-gift-eyebrow-"]');
    var giftSub     = root.querySelector('[id^="bbxg-gift-sub-"]');
    var giftNote    = root.querySelector('[id^="bbxg-gift-note-"]');
    var mainBoxGift = root.querySelector('.bbxg__main');
    var giftEyebrowOn  = root.dataset.giftEyebrowOn  || 'Free Gift Included';
    var giftEyebrowOff = root.dataset.giftEyebrowOff || 'Not Included';
    var giftSubOn      = root.dataset.giftSubOn      || 'Included with every Sign Up & Save order — yours to keep.';
    var giftSubOff     = root.dataset.giftSubOff     || 'Not included with one-time purchases — choose Sign Up & Save to claim yours.';
    var giftCtaSuffix      = root.dataset.giftCtaSuffix      || 'Includes FREE Shaker Bottle';
    var giftCtaSuffixShort = root.dataset.giftCtaSuffixShort || 'FREE Shaker included';

    // Mobile: size the CTA text as large as possible while staying on one line.
    // Text length varies per plan/qty, so this re-runs after every render and on resize.
    function fitCta(){
      if (!ctaBtn || !ctaText) return;
      if (!window.matchMedia || !window.matchMedia('(max-width: 720px)').matches){
        ctaBtn.style.removeProperty('font-size');
        return;
      }
      if (!ctaBtn.clientWidth) return; // not laid out yet — next render/resize retries
      var cs = window.getComputedStyle(ctaBtn);
      var icon = ctaBtn.querySelector('svg');
      var iconW = icon ? icon.getBoundingClientRect().width : 0;
      var gap = parseFloat(cs.columnGap) || 8;
      var avail = ctaBtn.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0) - (iconW ? iconW + gap : 0) - 2;
      if (avail <= 0) return;
      var base = 20;
      ctaBtn.style.setProperty('font-size', base + 'px', 'important');
      var w = ctaText.getBoundingClientRect().width;
      if (!w){ ctaBtn.style.removeProperty('font-size'); return; }
      var size = Math.min(29.6, Math.max(14, Math.floor(base * avail / w * 10) / 10));
      ctaBtn.style.setProperty('font-size', size + 'px', 'important');
      var w2 = ctaText.getBoundingClientRect().width;
      if (w2 > avail){
        size = Math.max(14, Math.floor(size * avail / w2 * 10) / 10);
        ctaBtn.style.setProperty('font-size', size + 'px', 'important');
      }
    }

    function getActiveQtyRow(){
      return root.querySelector('.bbxg__qty-row.is-on') || qtyRows[0];
    }

    // Mobile: shrink each variant name until it fits its button on one line.
    // Runs after every render and on resize. Modeled on fitCta().
    function fitVariants(){
      if (!variantBtns.length) return;
      for (var i = 0; i < variantBtns.length; i++){
        var btn = variantBtns[i];
        var label = btn.querySelector('.bbxg__variant-name');
        if (!label) continue;
        label.classList.remove('is-wrap');
        label.style.removeProperty('font-size');
        if (!btn.clientWidth) continue; // not laid out yet — next render/resize retries
        var cs = window.getComputedStyle(btn);
        var avail = btn.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0) - 1;
        if (avail <= 0) continue;
        var w = label.scrollWidth;
        if (!w || w <= avail) continue;
        var base = parseFloat(window.getComputedStyle(label).fontSize) || 15;
        var size = Math.max(10, Math.floor(base * avail / w * 10) / 10);
        label.style.setProperty('font-size', size + 'px');
        if (label.scrollWidth > avail){
          size = Math.max(10, Math.floor(size * avail / label.scrollWidth * 10) / 10);
          label.style.setProperty('font-size', size + 'px');
        }
        if (label.scrollWidth > avail + 1){
          label.classList.add('is-wrap'); // floor font still too wide — wrap instead of bleeding past the button
        }
      }
    }

    // Push a selected variant's numbers into the qty rows + hidden id + "was" prices + gallery.
    function applyVariant(id){
      var d = vmap[id];
      if (!d) return;
      if (idInput) idInput.value = id;
      curAvail = d.avail !== false;
      for (var r = 0; r < qtyRows.length; r++){
        var row = qtyRows[r];
        var n = parseInt(row.dataset.qty, 10);
        var k = n - 1;
        if (k < 0 || k > 2) continue;
        if (d.once)     row.dataset.oncePrice = d.once[k];
        if (d.oncedisc) row.dataset.onceDisc  = d.oncedisc[k];
        if (d.sub)      row.dataset.subPrice   = d.sub[k];
        if (d.subdisc)  row.dataset.subDisc    = d.subdisc[k];
        if (d.plan)     row.dataset.subPlan    = d.plan[k] || '';
        var wasEl = row.querySelector('.bbxg__qty-was');
        if (wasEl && d.base){ wasEl.textContent = wasPrefix + ' ' + fmt(d.base); }
      }
      // Gallery: if this variant has a featured image matching a thumb, activate it.
      // No-ops safely when the product doesn't use per-variant images.
      if (d.img && typeof selectVariantSlide === 'function'){ selectVariantSlide(d.img); }
    }

    function renderGift(){
      if (!giftBar) return;
      var off = (plan !== 'sub');
      giftBar.classList.toggle('is-off', off);
      giftBar.setAttribute('aria-disabled', off ? 'true' : 'false');
      if (mainBoxGift) mainBoxGift.classList.toggle('gift-hidden', off);
      if (off){
        if (giftEyebrow) giftEyebrow.lastChild.textContent = ' ' + giftEyebrowOff;
        if (giftSub) giftSub.textContent = giftSubOff;
        if (giftNote) giftNote.style.display = 'none';
      } else {
        if (giftEyebrow) giftEyebrow.lastChild.textContent = ' ' + giftEyebrowOn;
        if (giftSub) giftSub.textContent = giftSubOn;
        if (giftNote) giftNote.style.display = '';
      }
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbxg__qty-now');
        var saveEl  = b.querySelector('.bbxg__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      renderGift();

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        // Rebuild subline; append gift suffix when subscription is selected AND a gift exists.
        // On narrow screens, shorten the gift suffix so the line still fits.
        var narrow = window.matchMedia && window.matchMedia('(max-width: 480px)').matches;
        if (plan === 'sub'){
          if (giftBar){
            if (narrow){
              // Lead with the gift so it can never be the truncated tail; drop
              // the "Subscription selected" boilerplate on small screens.
              ctaSub.innerHTML = '<span class="bbxg__cta-gift">' + giftCtaSuffixShort + '</span>'
                + ' · ' + days + '-day supply';
            } else {
              ctaSub.innerHTML = days + '-day supply · Auto-Ship selected'
                + '<span class="bbxg__cta-gift"> · ' + giftCtaSuffix + '</span>';
            }
          } else {
            ctaSub.textContent = days + '-day supply · Auto-Ship selected';
          }
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no Auto-Ship';
        }
      }

      // Sold-out variant wins over everything
      if (ctaBtn){
        if (curAvail === false){
          ctaBtn.disabled = true;
          ctaBtn.style.opacity = '0.55';
          ctaBtn.style.cursor = 'not-allowed';
          if (ctaText) ctaText.textContent = 'Sold Out';
          if (ctaSub)  ctaSub.textContent  = 'This option is currently out of stock';
        } else {
          ctaBtn.disabled = false;
          ctaBtn.style.opacity = '';
          ctaBtn.style.cursor = '';
        }
      }

      fitCta();
      fitVariants();
    }

    // Variant button bindings
    for (var vb2 = 0; vb2 < variantBtns.length; vb2++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          for (var x = 0; x < variantBtns.length; x++){
            var on = variantBtns[x] === btn;
            variantBtns[x].classList.toggle('is-on', on);
            variantBtns[x].setAttribute('aria-checked', on ? 'true' : 'false');
          }
          applyVariant(btn.dataset.variantId);
          render();
        });
      })(variantBtns[vb2]);
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gift bar: when deactivated (once selected), clicking switches to sub.
    if (giftBar){
      var claimSub = function(ev){
        if (plan === 'sub') return; // active bar is non-interactive
        ev.preventDefault();
        plan = 'sub';
        render();
      };
      giftBar.addEventListener('click', claimSub);
      giftBar.addEventListener('keydown', function(ev){
        if (plan === 'sub') return;
        if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar'){
          claimSub(ev);
        }
      });
    }

    // Gallery
    var mainBox = root.querySelector('.bbxg__main');
    var main = root.querySelector('.bbxg__main img');
    var countEl = root.querySelector('[id^="bbxg-count-"]');
    var thumbsContainer = root.querySelector('.bbxg__thumbs');
    var thumbs = root.querySelectorAll('.bbxg__thumb');
    var prev = root.querySelector('[id^="bbxg-prev-"]');
    var next = root.querySelector('[id^="bbxg-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src){
        // Re-point the intrinsic ratio BEFORE swapping src, so the box resizes
        // in one step instead of holding the previous image's height until the
        // new one decodes. Keeps every image at its true shape, uncropped.
        var tw = thumbs[idx].dataset.w, th = thumbs[idx].dataset.h;
        if (tw && th){ main.setAttribute('width', tw); main.setAttribute('height', th); }
        main.src = src;
      }
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Variant → gallery: activate the slide whose thumb matches this variant's
    // featured image (compared on the base src, query-string stripped). No-ops
    // safely when the product doesn't use per-variant images.
    function selectVariantSlide(imgUrl){
      if (!imgUrl || !thumbs.length) return;
      var target = String(imgUrl).split('?')[0];
      for (var s = 0; s < thumbs.length; s++){
        var tsrc = thumbs[s].dataset.src || '';
        if (tsrc.split('?')[0] === target){ setSlide(s); return; }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxgDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxgDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxgDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxgDragged = false; }, 100);
        } else {
          thumbsContainer._bbxgDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxgDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    // Sync qty rows to the initially-selected variant, then paint.
    if (idInput && vmap[idInput.value]) applyVariant(idInput.value);
    render();

    // Re-fit CTA once real fonts finish loading (metrics shift) and on any resize/rotation
    if (document.fonts && document.fonts.ready && document.fonts.ready.then){
      document.fonts.ready.then(function(){ fitCta(); fitVariants(); });
    }
    window.addEventListener('resize', function(){
      if (window.requestAnimationFrame){
        if (fitRaf) cancelAnimationFrame(fitRaf);
        fitRaf = requestAnimationFrame(function(){ render(); });
      } else {
        render();
      }
    });
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buybox-v10"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');
    var ctaBtn    = root.querySelector('.bbx__cta');
    var fitRaf    = null;

    // VIP join bar (non-member) / thin status bar (member)
    var vipMini    = root.querySelector('[data-vip-mini]');
    var vipToggle  = root.querySelector('[data-vip-toggle]');
    var vipTotalEl = root.querySelector('[data-vip-total]');
    var vipCtaNote = root.querySelector('[data-vip-cta-note]');
    var vipOff     = parseInt(root.dataset.vipOff, 10) || 0;
    var variantInput = root.querySelector('input[name="id"]');

    // Mobile: size the CTA text as large as possible while staying on one line.
    // Text length varies per plan/qty, so this re-runs after every render and on resize.
    function fitCta(){
      if (!ctaBtn || !ctaText) return;
      if (!window.matchMedia || !window.matchMedia('(max-width: 720px)').matches){
        ctaBtn.style.removeProperty('font-size');
        return;
      }
      if (!ctaBtn.clientWidth) return; // not laid out yet — next render/resize retries
      var cs = window.getComputedStyle(ctaBtn);
      var icon = ctaBtn.querySelector('svg');
      var iconW = icon ? icon.getBoundingClientRect().width : 0;
      var gap = parseFloat(cs.columnGap) || 8;
      var avail = ctaBtn.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0) - (iconW ? iconW + gap : 0) - 2;
      if (avail <= 0) return;
      var base = 20;
      ctaBtn.style.setProperty('font-size', base + 'px', 'important');
      var w = ctaText.getBoundingClientRect().width;
      if (!w){ ctaBtn.style.removeProperty('font-size'); return; }
      var size = Math.min(29.6, Math.max(14, Math.floor(base * avail / w * 10) / 10));
      ctaBtn.style.setProperty('font-size', size + 'px', 'important');
      var w2 = ctaText.getBoundingClientRect().width;
      if (w2 > avail){
        size = Math.max(14, Math.floor(size * avail / w2 * 10) / 10);
        ctaBtn.style.setProperty('font-size', size + 'px', 'important');
      }
    }

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
        if (saveEl)  saveEl.classList.toggle('is-zero', disc <= 0);
        var wasEl = b.querySelector('.bbx__qty-was');
        if (wasEl)   wasEl.classList.toggle('is-zero', disc <= 0);
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * (parseInt(root.dataset.supplyDays, 10) || 30);
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';

      // VIP pricing is one-time only, so everything VIP switches off whenever a
      // real subscription price is the active selection.
      var subActive = (plan === 'sub' && aSub > 0);

      // Member-only: VIP total, and everything VIP is one-time only.
      var vipTotalCents = Math.round(totalCents * (100 - vipOff) / 100);
      if (vipMini)    vipMini.classList.toggle('is-hidden', subActive);
      if (vipCtaNote) vipCtaNote.classList.toggle('is-hidden', subActive);
      if (vipTotalEl && !subActive) vipTotalEl.textContent = fmt(vipTotalCents);

      // A confirmed VIP sees the price they will actually pay on the button.
      // The VIP subscription itself is never folded into this number.
      var ctaCents = (vipMini && !subActive) ? vipTotalCents : totalCents;
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(ctaCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Auto-Ship selected';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no Auto-Ship';
        }
      }

      fitCta();
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var chip = root.querySelector('.bbx__chip');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (chip) chip.style.display = (idx === 0) ? '' : 'none';
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }


    // ---- Add to cart -------------------------------------------------------
    // UpCart hooks the product form's SUBMIT event and does its own single-item
    // add, which would silently drop the VIP line. So the CTA is type="button"
    // — no submit event ever fires — and we own the add outright, then hand the
    // drawer back to UpCart. Verified against the live cart: with type="button"
    // UpCart issues zero add requests of its own.
    var form = root.querySelector('form[action*="/cart/add"]');

    function bbxAddToCart(){
      if (!form || form.dataset.bbxBusy === '1') return;
      var variantId = variantInput && variantInput.value;
      if (!variantId) return;

      var items = [{ id: Number(variantId), quantity: qty }];
      if (planInput && planInput.value) items[0].selling_plan = Number(planInput.value);

      if (vipToggle && vipToggle.checked){
        var vId   = Number(vipToggle.dataset.vipVariant || 0);
        var vPlan = Number(vipToggle.dataset.vipPlan || 0);
        if (vId){
          var vipItem = { id: vId, quantity: 1 };
          if (vPlan) vipItem.selling_plan = vPlan;
          // Attribution for the PDP upsell report: records WHICH product page
          // produced this VIP signup. Leading underscore keeps it hidden from
          // the cart and checkout UI. Shopify Flow reads it to tag the order;
          // the report groups on it. The value is set in Liquid and passed via
          // a data attribute because {% javascript %} is a theme-wide bundle
          // and cannot interpolate Liquid.
          var vSrc = vipToggle.dataset.vipSource;
          if (vSrc) vipItem.properties = { '_upsell_source': vSrc };
          items.push(vipItem);
        }
      }

      form.dataset.bbxBusy = '1';
      if (ctaBtn) ctaBtn.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r){
        if (!r.ok) return r.json().then(function(e){ throw new Error(e.description || e.message || 'add failed'); });
        return r.json();
      })
      .then(function(){
        if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
        if (typeof window.upcartOpenCart === 'function'){
          window.upcartOpenCart();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function(err){
        console && console.warn && console.warn('[bbx] add to cart', err);
        window.location.href = '/cart';
      })
      .then(function(){
        form.dataset.bbxBusy = '0';
        if (ctaBtn) ctaBtn.removeAttribute('aria-busy');
      });
    }

    if (ctaBtn) ctaBtn.addEventListener('click', function(ev){ ev.preventDefault(); bbxAddToCart(); });
    // Belt and braces: nothing should be able to submit this form natively.
    if (form) form.addEventListener('submit', function(ev){ ev.preventDefault(); });

    render();

    // Re-fit CTA once real fonts finish loading (metrics shift) and on any resize/rotation
    if (document.fonts && document.fonts.ready && document.fonts.ready.then){
      document.fonts.ready.then(function(){ fitCta(); });
    }
    window.addEventListener('resize', function(){
      if (window.requestAnimationFrame){
        if (fitRaf) cancelAnimationFrame(fitRaf);
        fitRaf = requestAnimationFrame(fitCta);
      } else {
        fitCta();
      }
    });
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buybox-v11"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 3;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');
    var ctaBtn    = root.querySelector('.bbx__cta');
    var fitRaf    = null;

    // VIP join bar (non-member) / thin status bar (member)
    var vipMini    = root.querySelector('[data-vip-mini]');
    var vipToggle  = root.querySelector('[data-vip-toggle]');
    var vipTotalEl = root.querySelector('[data-vip-total]');
    var vipCtaNote = root.querySelector('[data-vip-cta-note]');
    var vipOff     = parseInt(root.dataset.vipOff, 10) || 0;
    var variantInput = root.querySelector('input[name="id"]');

    // Mobile: size the CTA text as large as possible while staying on one line.
    // Text length varies per plan/qty, so this re-runs after every render and on resize.
    function fitCta(){
      if (!ctaBtn || !ctaText) return;
      if (!window.matchMedia || !window.matchMedia('(max-width: 720px)').matches){
        ctaBtn.style.removeProperty('font-size');
        return;
      }
      if (!ctaBtn.clientWidth) return; // not laid out yet — next render/resize retries
      var cs = window.getComputedStyle(ctaBtn);
      var icon = ctaBtn.querySelector('svg');
      var iconW = icon ? icon.getBoundingClientRect().width : 0;
      var gap = parseFloat(cs.columnGap) || 8;
      var avail = ctaBtn.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0) - (iconW ? iconW + gap : 0) - 2;
      if (avail <= 0) return;
      var base = 20;
      ctaBtn.style.setProperty('font-size', base + 'px', 'important');
      var w = ctaText.getBoundingClientRect().width;
      if (!w){ ctaBtn.style.removeProperty('font-size'); return; }
      var size = Math.min(29.6, Math.max(14, Math.floor(base * avail / w * 10) / 10));
      ctaBtn.style.setProperty('font-size', size + 'px', 'important');
      var w2 = ctaText.getBoundingClientRect().width;
      if (w2 > avail){
        size = Math.max(14, Math.floor(size * avail / w2 * 10) / 10);
        ctaBtn.style.setProperty('font-size', size + 'px', 'important');
      }
    }

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
        if (saveEl)  saveEl.classList.toggle('is-zero', disc <= 0);
        var wasEl = b.querySelector('.bbx__qty-was');
        if (wasEl)   wasEl.classList.toggle('is-zero', disc <= 0);
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';

      // VIP pricing is one-time only, so everything VIP switches off whenever a
      // real subscription price is the active selection.
      var subActive = (plan === 'sub' && aSub > 0);

      // Member-only: VIP total, and everything VIP is one-time only.
      var vipTotalCents = Math.round(totalCents * (100 - vipOff) / 100);
      if (vipMini)    vipMini.classList.toggle('is-hidden', subActive);
      if (vipCtaNote) vipCtaNote.classList.toggle('is-hidden', subActive);
      if (vipTotalEl && !subActive) vipTotalEl.textContent = fmt(vipTotalCents);

      // A confirmed VIP sees the price they will actually pay on the button.
      // The VIP subscription itself is never folded into this number.
      var ctaCents = (vipMini && !subActive) ? vipTotalCents : totalCents;
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(ctaCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Auto-Ship selected';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no Auto-Ship';
        }
      }

      fitCta();
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var chip = root.querySelector('.bbx__chip');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (chip) chip.style.display = (idx === 0) ? '' : 'none';
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }


    // ---- Add to cart -------------------------------------------------------
    // UpCart hooks the product form's SUBMIT event and does its own single-item
    // add, which would silently drop the VIP line. So the CTA is type="button"
    // — no submit event ever fires — and we own the add outright, then hand the
    // drawer back to UpCart. Verified against the live cart: with type="button"
    // UpCart issues zero add requests of its own.
    var form = root.querySelector('form[action*="/cart/add"]');

    function bbxAddToCart(){
      if (!form || form.dataset.bbxBusy === '1') return;
      var variantId = variantInput && variantInput.value;
      if (!variantId) return;

      var items = [{ id: Number(variantId), quantity: qty }];
      if (planInput && planInput.value) items[0].selling_plan = Number(planInput.value);

      if (vipToggle && vipToggle.checked){
        var vId   = Number(vipToggle.dataset.vipVariant || 0);
        var vPlan = Number(vipToggle.dataset.vipPlan || 0);
        if (vId){
          var vipItem = { id: vId, quantity: 1 };
          if (vPlan) vipItem.selling_plan = vPlan;
          // Attribution for the PDP upsell report: records WHICH product page
          // produced this VIP signup. Leading underscore keeps it hidden from
          // the cart and checkout UI. Shopify Flow reads it to tag the order;
          // the report groups on it. The value is set in Liquid and passed via
          // a data attribute because the section javascript block is a theme-wide bundle
          // and cannot interpolate Liquid.
          var vSrc = vipToggle.dataset.vipSource;
          if (vSrc) vipItem.properties = { '_upsell_source': vSrc };
          items.push(vipItem);
        }
      }

      form.dataset.bbxBusy = '1';
      if (ctaBtn) ctaBtn.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r){
        if (!r.ok) return r.json().then(function(e){ throw new Error(e.description || e.message || 'add failed'); });
        return r.json();
      })
      .then(function(){
        if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
        if (typeof window.upcartOpenCart === 'function'){
          window.upcartOpenCart();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function(err){
        console && console.warn && console.warn('[bbx] add to cart', err);
        window.location.href = '/cart';
      })
      .then(function(){
        form.dataset.bbxBusy = '0';
        if (ctaBtn) ctaBtn.removeAttribute('aria-busy');
      });
    }

    if (ctaBtn) ctaBtn.addEventListener('click', function(ev){ ev.preventDefault(); bbxAddToCart(); });
    // Belt and braces: nothing should be able to submit this form natively.
    if (form) form.addEventListener('submit', function(ev){ ev.preventDefault(); });

    render();

    // Re-fit CTA once real fonts finish loading (metrics shift) and on any resize/rotation
    if (document.fonts && document.fonts.ready && document.fonts.ready.then){
      document.fonts.ready.then(function(){ fitCta(); });
    }
    window.addEventListener('resize', function(){
      if (window.requestAnimationFrame){
        if (fitRaf) cancelAnimationFrame(fitRaf);
        fitRaf = requestAnimationFrame(fitCta);
      } else {
        fitCta();
      }
    });
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buybox-v4"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Auto-Ship selected';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no Auto-Ship';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buybox-v5"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Auto-Ship selected';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no Auto-Ship';
        }
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buybox-v6"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');
    var ctaBtn    = root.querySelector('.bbx__cta');
    var available = root.dataset.available !== '0';
    var fitRaf    = null;

    // Mobile: size the CTA text as large as possible while staying on one line.
    // Text length varies per plan/qty, so this re-runs after every render and on resize.
    function fitCta(){
      if (!ctaBtn || !ctaText) return;
      if (!window.matchMedia || !window.matchMedia('(max-width: 720px)').matches){
        ctaBtn.style.removeProperty('font-size');
        return;
      }
      if (!ctaBtn.clientWidth) return; // not laid out yet — next render/resize retries
      var cs = window.getComputedStyle(ctaBtn);
      var icon = ctaBtn.querySelector('svg');
      var iconW = icon ? icon.getBoundingClientRect().width : 0;
      var gap = parseFloat(cs.columnGap) || 8;
      var avail = ctaBtn.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0) - (iconW ? iconW + gap : 0) - 2;
      if (avail <= 0) return;
      var base = 20;
      ctaBtn.style.setProperty('font-size', base + 'px', 'important');
      var w = ctaText.getBoundingClientRect().width;
      if (!w){ ctaBtn.style.removeProperty('font-size'); return; }
      var size = Math.min(29.6, Math.max(14, Math.floor(base * avail / w * 10) / 10));
      ctaBtn.style.setProperty('font-size', size + 'px', 'important');
      var w2 = ctaText.getBoundingClientRect().width;
      if (w2 > avail){
        size = Math.max(14, Math.floor(size * avail / w2 * 10) / 10);
        ctaBtn.style.setProperty('font-size', size + 'px', 'important');
      }
    }

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      var soldoutLabel = root.dataset.ctaSoldout || 'Sold Out';
      if (ctaBtn){
        ctaBtn.classList.toggle('is-soldout', !available);
        ctaBtn.disabled = !available;
        if (!available) ctaBtn.setAttribute('aria-disabled', 'true'); else ctaBtn.removeAttribute('aria-disabled');
      }
      if (ctaText){
        ctaText.textContent = !available ? soldoutLabel : (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(window.AJVIP ? window.AJVIP.cta(root, totalCents, plan === 'sub' && aSub > 0) : totalCents);
      }
      if (ctaSub){
        if (!available){
          ctaSub.textContent = root.dataset.ctaSoldoutSub || 'Currently out of stock';
        } else if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Auto-Ship selected';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no Auto-Ship';
        }
      }
      fitCta();
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var chip = root.querySelector('.bbx__chip');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (chip) chip.style.display = (idx === 0) ? '' : 'none';
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();

    // Sold out: never let the form submit (disabled button already blocks clicks; this covers any programmatic submit)
    var bbxForm = root.querySelector('form[action*="/cart/add"]');
    if (bbxForm && !available){
      bbxForm.addEventListener('submit', function(ev){ ev.preventDefault(); ev.stopImmediatePropagation(); }, true);
    }

    // Re-fit CTA once real fonts finish loading (metrics shift) and on any resize/rotation
    if (document.fonts && document.fonts.ready && document.fonts.ready.then){
      document.fonts.ready.then(function(){ fitCta(); });
    }
    window.addEventListener('resize', function(){
      if (window.requestAnimationFrame){
        if (fitRaf) cancelAnimationFrame(fitRaf);
        fitRaf = requestAnimationFrame(fitCta);
      } else {
        fitCta();
      }
    });
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buybox-v8"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');
    var ctaBtn    = root.querySelector('.bbx__cta');
    var fitRaf    = null;

    // VIP pricing bar — mirrors the live selection at an extra N% off
    var vipBar        = root.querySelector('.bbx__vip');
    var vipOff        = vipBar ? (parseInt(vipBar.dataset.vipOff, 10) || 0) : 0;
    var vipUnitEl     = root.querySelector('[data-vip-unit]');
    var vipWasEl      = root.querySelector('[data-vip-unit-was]');
    var vipTotalEl    = root.querySelector('[data-vip-total]');
    var vipSaveEl     = root.querySelector('[data-vip-save]');
    var vipCtaNote    = root.querySelector('[data-vip-cta-note]');
    var vipSavePrefix = (vipSaveEl && vipSaveEl.dataset.savePrefix) || 'You save';
    var vipCompare    = vipBar ? (parseInt(vipBar.dataset.vipCompare, 10) || 0) : 0;
    var vipIsMember   = !!(vipBar && vipBar.dataset.vipMember === '1');

    // Mobile: size the CTA text as large as possible while staying on one line.
    // Text length varies per plan/qty, so this re-runs after every render and on resize.
    function fitCta(){
      if (!ctaBtn || !ctaText) return;
      if (!window.matchMedia || !window.matchMedia('(max-width: 720px)').matches){
        ctaBtn.style.removeProperty('font-size');
        return;
      }
      if (!ctaBtn.clientWidth) return; // not laid out yet — next render/resize retries
      var cs = window.getComputedStyle(ctaBtn);
      var icon = ctaBtn.querySelector('svg');
      var iconW = icon ? icon.getBoundingClientRect().width : 0;
      var gap = parseFloat(cs.columnGap) || 8;
      var avail = ctaBtn.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0) - (iconW ? iconW + gap : 0) - 2;
      if (avail <= 0) return;
      var base = 20;
      ctaBtn.style.setProperty('font-size', base + 'px', 'important');
      var w = ctaText.getBoundingClientRect().width;
      if (!w){ ctaBtn.style.removeProperty('font-size'); return; }
      var size = Math.min(29.6, Math.max(14, Math.floor(base * avail / w * 10) / 10));
      ctaBtn.style.setProperty('font-size', size + 'px', 'important');
      var w2 = ctaText.getBoundingClientRect().width;
      if (w2 > avail){
        size = Math.max(14, Math.floor(size * avail / w2 * 10) / 10);
        ctaBtn.style.setProperty('font-size', size + 'px', 'important');
      }
    }

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';

      // VIP pricing is one-time only, so everything VIP switches off whenever a
      // real subscription price is the active selection.
      var subActive = (plan === 'sub' && aSub > 0);
      var vipLive   = !!vipBar && vipOff > 0 && qty > 0 && !subActive;

      // Total is the authoritative number — that is what the checkout discount
      // computes off the order subtotal.
      var vipTotalCents = vipLive ? Math.round(totalCents * (100 - vipOff) / 100) : totalCents;
      var vipUnitCents  = vipLive ? Math.round(vipTotalCents / qty) : unit;

      if (vipBar)     vipBar.classList.toggle('is-hidden', subActive);
      if (vipCtaNote) vipCtaNote.classList.toggle('is-hidden', subActive);

      // A confirmed VIP sees the price they will actually pay on the button.
      var ctaCents = (vipIsMember && vipLive) ? vipTotalCents : totalCents;
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(ctaCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Auto-Ship selected';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no Auto-Ship';
        }
      }

      if (vipLive){
        // Savings = the whole stack, compare-at price down to the VIP price —
        // not just the VIP slice. Falls back to the selected price if the
        // product carries no compare-at value.
        var baseCents = (vipCompare > 0 ? vipCompare : unit) * qty;
        if (baseCents < totalCents) baseCents = totalCents;
        if (vipUnitEl)  vipUnitEl.textContent  = fmt(vipUnitCents);
        if (vipWasEl)   vipWasEl.textContent   = fmt(unit);
        if (vipTotalEl) vipTotalEl.textContent = fmt(vipTotalCents);
        if (vipSaveEl)  vipSaveEl.textContent  = vipSavePrefix + ' ' + fmt(baseCents - vipTotalCents);
      }

      fitCta();
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var chip = root.querySelector('.bbx__chip');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (chip) chip.style.display = (idx === 0) ? '' : 'none';
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();

    // Re-fit CTA once real fonts finish loading (metrics shift) and on any resize/rotation
    if (document.fonts && document.fonts.ready && document.fonts.ready.then){
      document.fonts.ready.then(function(){ fitCta(); });
    }
    window.addEventListener('resize', function(){
      if (window.requestAnimationFrame){
        if (fitRaf) cancelAnimationFrame(fitRaf);
        fitRaf = requestAnimationFrame(fitCta);
      } else {
        fitCta();
      }
    });
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buybox-v9"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');
    var ctaBtn    = root.querySelector('.bbx__cta');
    var fitRaf    = null;

    // VIP pricing bar — mirrors the live selection at an extra N% off
    var vipBar        = root.querySelector('.bbx__vip');
    var vipOff        = vipBar ? (parseInt(vipBar.dataset.vipOff, 10) || 0) : 0;
    var vipUnitEl     = root.querySelector('[data-vip-unit]');
    var vipWasEl      = root.querySelector('[data-vip-unit-was]');
    var vipTotalEl    = root.querySelector('[data-vip-total]');
    var vipSaveEl     = root.querySelector('[data-vip-save]');
    var vipCtaNote    = root.querySelector('[data-vip-cta-note]');
    var vipSavePrefix = (vipSaveEl && vipSaveEl.dataset.savePrefix) || 'You save';
    var vipCompare    = vipBar ? (parseInt(vipBar.dataset.vipCompare, 10) || 0) : 0;
    var vipFlat       = vipBar ? (parseInt(vipBar.dataset.vipFlat, 10) || 0) : 0;
    var vipIsMember   = !!(vipBar && vipBar.dataset.vipMember === '1');

    // Mobile: size the CTA text as large as possible while staying on one line.
    // Text length varies per plan/qty, so this re-runs after every render and on resize.
    function fitCta(){
      if (!ctaBtn || !ctaText) return;
      if (!window.matchMedia || !window.matchMedia('(max-width: 720px)').matches){
        ctaBtn.style.removeProperty('font-size');
        return;
      }
      if (!ctaBtn.clientWidth) return; // not laid out yet — next render/resize retries
      var cs = window.getComputedStyle(ctaBtn);
      var icon = ctaBtn.querySelector('svg');
      var iconW = icon ? icon.getBoundingClientRect().width : 0;
      var gap = parseFloat(cs.columnGap) || 8;
      var avail = ctaBtn.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0) - (iconW ? iconW + gap : 0) - 2;
      if (avail <= 0) return;
      var base = 20;
      ctaBtn.style.setProperty('font-size', base + 'px', 'important');
      var w = ctaText.getBoundingClientRect().width;
      if (!w){ ctaBtn.style.removeProperty('font-size'); return; }
      var size = Math.min(29.6, Math.max(14, Math.floor(base * avail / w * 10) / 10));
      ctaBtn.style.setProperty('font-size', size + 'px', 'important');
      var w2 = ctaText.getBoundingClientRect().width;
      if (w2 > avail){
        size = Math.max(14, Math.floor(size * avail / w2 * 10) / 10);
        ctaBtn.style.setProperty('font-size', size + 'px', 'important');
      }
    }

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var days = qty * 30;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';

      // VIP pricing is one-time only, so everything VIP switches off whenever a
      // real subscription price is the active selection.
      var subActive = (plan === 'sub' && aSub > 0);
      var vipLive   = !!vipBar && vipOff > 0 && qty > 0 && !subActive;

      // A flat per-unit VIP price wins outright; otherwise fall back to a
      // percentage off the current selection (v8 behaviour).
      var vipUnitCents, vipTotalCents;
      if (!vipLive){
        vipUnitCents = unit; vipTotalCents = totalCents;
      } else if (vipFlat > 0){
        vipUnitCents = vipFlat; vipTotalCents = vipFlat * qty;
      } else {
        vipTotalCents = Math.round(totalCents * (100 - vipOff) / 100);
        vipUnitCents  = Math.round(vipTotalCents / qty);
      }

      if (vipBar)     vipBar.classList.toggle('is-hidden', subActive);
      if (vipCtaNote) vipCtaNote.classList.toggle('is-hidden', subActive);

      // A confirmed VIP sees the price they will actually pay on the button.
      var ctaCents = (vipIsMember && vipLive) ? vipTotalCents : totalCents;
      if (ctaText){
        ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(ctaCents);
      }
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = days + '-day supply · Auto-Ship selected';
        } else {
          ctaSub.textContent = days + '-day supply · One-time purchase, no Auto-Ship';
        }
      }

      if (vipLive){
        // Savings = the whole stack, compare-at price down to the VIP price —
        // not just the VIP slice. Falls back to the selected price if the
        // product carries no compare-at value.
        var baseCents = (vipCompare > 0 ? vipCompare : unit) * qty;
        if (baseCents < totalCents) baseCents = totalCents;
        if (vipUnitEl)  vipUnitEl.textContent  = fmt(vipUnitCents);
        if (vipWasEl)   vipWasEl.textContent   = fmt(unit);
        if (vipTotalEl) vipTotalEl.textContent = fmt(vipTotalCents);
        if (vipSaveEl)  vipSaveEl.textContent  = vipSavePrefix + ' ' + fmt(baseCents - vipTotalCents);
      }

      fitCta();
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var chip = root.querySelector('.bbx__chip');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (chip) chip.style.display = (idx === 0) ? '' : 'none';
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();

    // Re-fit CTA once real fonts finish loading (metrics shift) and on any resize/rotation
    if (document.fonts && document.fonts.ready && document.fonts.ready.then){
      document.fonts.ready.then(function(){ fitCta(); });
    }
    window.addEventListener('resize', function(){
      if (window.requestAnimationFrame){
        if (fitRaf) cancelAnimationFrame(fitRaf);
        fitRaf = requestAnimationFrame(fitCta);
      } else {
        fitCta();
      }
    });
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buybox-warmachine"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;
    var wasPrefix = root.dataset.wasPrefix || 'was';

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var idInput   = root.querySelector('input[name="id"]');
    var ctaBtn    = root.querySelector('.bbx__cta');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    // ---- Variant data island ----
    var vmap = {};
    var vscript = root.querySelector('[id^="bbx-vdata-"]');
    if (vscript){ try { vmap = JSON.parse(vscript.textContent); } catch(e){ vmap = {}; } }
    var variantBtns = root.querySelectorAll('.bbx__variant');
    var curAvail = true;

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    // Push a variant's numbers into the qty rows + hidden id + gallery + "was" prices
    function applyVariant(id){
      var d = vmap[id];
      if (!d) return;
      if (idInput) idInput.value = id;
      curAvail = d.avail !== false;
      for (var r = 0; r < qtyRows.length; r++){
        var row = qtyRows[r];
        var n = parseInt(row.dataset.qty, 10);
        var k = n - 1;
        if (k < 0 || k > 2) continue;
        row.dataset.oncePrice = d.once[k];
        row.dataset.onceDisc  = d.oncedisc[k];
        row.dataset.subPrice  = d.sub[k];
        row.dataset.subDisc   = d.subdisc[k];
        row.dataset.subPlan   = d.plan[k] || '';
        var wasEl = row.querySelector('.bbx__qty-was');
        if (wasEl && d.base){ wasEl.textContent = wasPrefix + ' ' + fmt(d.base); }
      }
      // Filter the gallery to this variant's images by alt text
      // (Adults -> alt "1", Kids -> alt "2"); falls back to the variant image.
      filterGallery(d.alt || '', d.img || '');
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (activeRow){
        var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
        var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
        var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
        var totalCents = unit * qty;
        var days = qty * 30;
        var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
        var subLabel  = root.dataset.ctaSub  || 'Start Now';
        if (ctaText){
          ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
        }
        if (ctaSub){
          if (plan === 'sub'){
            ctaSub.textContent = days + '-day supply · Auto-Ship selected';
          } else {
            ctaSub.textContent = days + '-day supply · One-time purchase, no Auto-Ship';
          }
        }
      }

      // Sold-out state wins over everything
      if (ctaBtn){
        if (curAvail === false){
          ctaBtn.disabled = true;
          ctaBtn.style.opacity = '0.55';
          ctaBtn.style.cursor = 'not-allowed';
          if (ctaText) ctaText.textContent = 'Sold Out';
          if (ctaSub)  ctaSub.textContent  = 'This option is currently out of stock';
        } else {
          ctaBtn.disabled = false;
          ctaBtn.style.opacity = '';
          ctaBtn.style.cursor = '';
        }
      }
    }

    // Variant button bindings
    for (var vb2 = 0; vb2 < variantBtns.length; vb2++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          for (var x = 0; x < variantBtns.length; x++){
            var on = variantBtns[x] === btn;
            variantBtns[x].classList.toggle('is-on', on);
            variantBtns[x].setAttribute('aria-checked', on ? 'true' : 'false');
          }
          applyVariant(btn.dataset.variantId);
          render();
        });
      })(variantBtns[vb2]);
    }

    // Plan card bindings
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    // Qty row bindings
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var allThumbs = Array.prototype.slice.call(thumbs);
    var activeThumbs = allThumbs;   // current visible subset (after alt-text filter)
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!activeThumbs.length) return;
      var len = activeThumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < allThumbs.length; t++) allThumbs[t].classList.remove('is-on');
      var cur = activeThumbs[idx];
      cur.classList.add('is-on');
      var src = cur.dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + activeThumbs.length;
      if (cur && cur.scrollIntoView){
        try {
          cur.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          if (thumbsContainer){
            var offset = cur.offsetLeft - (thumbsContainer.clientWidth - cur.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }

    // Show only thumbs whose data-alt matches `alt`. Blank alt (or no match) = show all.
    function filterGallery(alt, fallbackImg){
      var subset = allThumbs;
      if (alt){
        var target = String(alt).trim();
        var matched = allThumbs.filter(function(t){ return (t.dataset.alt || '').trim() === target; });
        if (matched.length) subset = matched;
      }
      activeThumbs = subset;
      for (var i = 0; i < allThumbs.length; i++){
        allThumbs[i].style.display = (subset.indexOf(allThumbs[i]) === -1) ? 'none' : '';
      }
      idx = 0;
      if (activeThumbs.length){
        setSlide(0);
      } else if (fallbackImg && main){
        main.src = fallbackImg;
      }
    }

    for (var k = 0; k < allThumbs.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          var pos = activeThumbs.indexOf(btn);
          if (pos !== -1) setSlide(pos);
        });
      })(allThumbs[k]);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    // Sync qty rows to the initially-selected variant, then paint.
    if (idInput && vmap[idInput.value]) applyVariant(idInput.value);
    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gum-buy-box"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;
    var wasPrefix = root.dataset.wasPrefix || 'was';

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var idInput   = root.querySelector('input[name="id"]');
    var ctaBtn    = root.querySelector('.bbx__cta');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    // ---- Variant data island ----
    var vmap = {};
    var vscript = root.querySelector('[id^="bbx-vdata-"]');
    if (vscript){ try { vmap = JSON.parse(vscript.textContent); } catch(e){ vmap = {}; } }
    var variantBtns = root.querySelectorAll('.bbx__variant');
    var curAvail = true;

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    // Push a variant's numbers into the qty rows + hidden id + gallery + "was" prices
    function applyVariant(id){
      var d = vmap[id];
      if (!d) return;
      if (idInput) idInput.value = id;
      curAvail = d.avail !== false;
      for (var r = 0; r < qtyRows.length; r++){
        var row = qtyRows[r];
        var n = parseInt(row.dataset.qty, 10);
        var k = n - 1;
        if (k < 0 || k > 2) continue;
        row.dataset.oncePrice = d.once[k];
        row.dataset.onceDisc  = d.oncedisc[k];
        row.dataset.subPrice  = d.sub[k];
        row.dataset.subDisc   = d.subdisc[k];
        row.dataset.subPlan   = d.plan[k] || '';
        var wasEl = row.querySelector('.bbx__qty-was');
        if (wasEl && d.base){ wasEl.textContent = wasPrefix + ' ' + fmt(d.base); }
      }
      // Filter the gallery to this variant's images by alt text
      // (Adults -> alt "1", Kids -> alt "2"); falls back to the variant image.
      filterGallery(d.alt || '', d.img || '');
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (activeRow){
        var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
        var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
        var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
        var totalCents = unit * qty;
        var days = qty * 30;
        var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
        var subLabel  = root.dataset.ctaSub  || 'Start Now';
        if (ctaText){
          ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
        }
        if (ctaSub){
          if (plan === 'sub'){
            ctaSub.textContent = days + '-day supply · Auto-Ship selected';
          } else {
            ctaSub.textContent = days + '-day supply · One-time purchase, no Auto-Ship';
          }
        }
      }

      // Sold-out state wins over everything
      if (ctaBtn){
        if (curAvail === false){
          ctaBtn.disabled = true;
          ctaBtn.style.opacity = '0.55';
          ctaBtn.style.cursor = 'not-allowed';
          if (ctaText) ctaText.textContent = 'Sold Out';
          if (ctaSub)  ctaSub.textContent  = 'This option is currently out of stock';
        } else {
          ctaBtn.disabled = false;
          ctaBtn.style.opacity = '';
          ctaBtn.style.cursor = '';
        }
      }
    }

    // Variant button bindings
    for (var vb2 = 0; vb2 < variantBtns.length; vb2++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          for (var x = 0; x < variantBtns.length; x++){
            var on = variantBtns[x] === btn;
            variantBtns[x].classList.toggle('is-on', on);
            variantBtns[x].setAttribute('aria-checked', on ? 'true' : 'false');
          }
          applyVariant(btn.dataset.variantId);
          render();
        });
      })(variantBtns[vb2]);
    }

    // Plan card bindings
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    // Qty row bindings
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var allThumbs = Array.prototype.slice.call(thumbs);
    var activeThumbs = allThumbs;   // current visible subset (after alt-text filter)
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!activeThumbs.length) return;
      var len = activeThumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < allThumbs.length; t++) allThumbs[t].classList.remove('is-on');
      var cur = activeThumbs[idx];
      cur.classList.add('is-on');
      var src = cur.dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + activeThumbs.length;
      if (cur && cur.scrollIntoView){
        try {
          cur.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          if (thumbsContainer){
            var offset = cur.offsetLeft - (thumbsContainer.clientWidth - cur.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }

    // Show only thumbs whose data-alt matches `alt`. Blank alt (or no match) = show all.
    function filterGallery(alt, fallbackImg){
      var subset = allThumbs;
      if (alt){
        var target = String(alt).trim();
        var matched = allThumbs.filter(function(t){ return (t.dataset.alt || '').trim() === target; });
        if (matched.length) subset = matched;
      }
      activeThumbs = subset;
      for (var i = 0; i < allThumbs.length; i++){
        allThumbs[i].style.display = (subset.indexOf(allThumbs[i]) === -1) ? 'none' : '';
      }
      idx = 0;
      if (activeThumbs.length){
        setSlide(0);
      } else if (fallbackImg && main){
        main.src = fallbackImg;
      }
    }

    for (var k = 0; k < allThumbs.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          var pos = activeThumbs.indexOf(btn);
          if (pos !== -1) setSlide(pos);
        });
      })(allThumbs[k]);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    // Sync qty rows to the initially-selected variant, then paint.
    if (idInput && vmap[idInput.value]) applyVariant(idInput.value);
    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ivermectin-mebendazole-official"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ===== Scoped to ONLY ivermectin-official sections via unique class + init flag =====
  // Critical: do NOT use the generic .bbx selector — that would conflict with
  // buybox-v4.liquid (supps) which uses the same base class.

  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx-imb');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxImbInit === '1') continue;
      el.dataset.bbxImbInit = '1';
      try { initSection(el); } catch (e) { if (window.console) console.warn('[bbx-imb]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var slot = parseInt(root.dataset.activeSlot || '1', 10);
    if (isNaN(slot)) slot = 1;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows = root.querySelectorAll('.bbx__qty-row');
    var variantIdInput = root.querySelector('input[name="id"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText = root.querySelector('[data-bbx-cta-text]');
    var ctaBtn = root.querySelector('[data-bbx-cta]');
    var ctaSub = root.querySelector('[id^="bbx-cta-sub-"]');
    var subPerks = root.querySelector('[id^="bbx-sub-perks-"]');
    var perkSaveEl = root.querySelector('[data-bbx-perk-save]');
    var main = root.querySelector('.bbx__main img');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var mainBox = root.querySelector('.bbx__main');

    // Pure visual toggle — pull it out of render() so click ALWAYS updates UI
    // even if any math/render logic throws.
    function applyPlanVisual(){
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var on = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', on);
        pb.setAttribute('aria-checked', on ? 'true' : 'false');
      }
    }
    function applySlotVisual(){
      for (var i = 0; i < qtyRows.length; i++){
        var rb = qtyRows[i];
        var on = parseInt(rb.dataset.slot, 10) === slot;
        rb.classList.toggle('is-on', on);
        rb.setAttribute('aria-checked', on ? 'true' : 'false');
      }
    }

    // ===== Bind direct click handlers on each button =====
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan || 'once';
          applyPlanVisual();
          try { render(); } catch(e){ if (window.console) console.warn('[bbx-imb]', e); }
        });
      })(planCards[p]);
    }

    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var ns = parseInt(btn.dataset.slot, 10);
          if (!isNaN(ns)) slot = ns;
          applySlotVisual();
          if (window.history && window.history.replaceState){
            try {
              var u = new URL(window.location);
              if (btn.dataset.variantId) u.searchParams.set('variant', btn.dataset.variantId);
              window.history.replaceState(null, '', u);
            } catch(e){}
          }
          try { render(); } catch(e){ if (window.console) console.warn('[bbx-imb]', e); }
        });
      })(qtyRows[q]);
    }

    // ===== Backup: event delegation on section root =====
    // If something stops the direct handlers (theme JS, weird DOM mutation),
    // this still catches the bubbled click and fires the same logic.
    root.addEventListener('click', function(ev){
      var target = ev.target;
      while (target && target !== root){
        if (target.classList){
          if (target.classList.contains('bbx__plan-card')){
            ev.preventDefault();
            ev.stopPropagation();
            var newPlan = target.dataset.plan || 'once';
            if (newPlan !== plan){
              plan = newPlan;
              applyPlanVisual();
              try { render(); } catch(e){}
            }
            return;
          }
          if (target.classList.contains('bbx__qty-row')){
            ev.preventDefault();
            ev.stopPropagation();
            var ns = parseInt(target.dataset.slot, 10);
            if (!isNaN(ns) && ns !== slot){
              slot = ns;
              applySlotVisual();
              try { render(); } catch(e){}
            }
            return;
          }
        }
        target = target.parentNode;
      }
    });

    function getActiveRow(){
      for (var i = 0; i < qtyRows.length; i++){
        if (parseInt(qtyRows[i].dataset.slot, 10) === slot) return qtyRows[i];
      }
      return qtyRows[0];
    }

    function render(){
      // 1. Plan card visuals
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }

      // 2. Variant row visuals + per-row price + save chip
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var rOn = parseInt(b.dataset.slot, 10) === slot;
        b.classList.toggle('is-on', rOn);
        b.setAttribute('aria-checked', rOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var priceEl = b.querySelector('[data-bbx-price]');
        var wasEl   = b.querySelector('[data-bbx-was]');
        var saveEl  = b.querySelector('[data-bbx-save]');

        if (plan === 'sub' && subPrice > 0){
          if (priceEl) priceEl.textContent = fmt(subPrice);
          if (wasEl) wasEl.textContent = oncePrice > subPrice ? fmt(oncePrice) : '';
          if (saveEl) saveEl.textContent = subDisc > 0 ? 'SAVE ' + subDisc + '%' : '';
        } else {
          if (priceEl) priceEl.textContent = fmt(oncePrice);
          if (wasEl) wasEl.textContent = '';
          if (saveEl) saveEl.textContent = '';
        }
      }

      // 3. Active variant lookup
      var activeRow = getActiveRow();
      if (!activeRow) return;

      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var aDisc = parseInt(activeRow.dataset.subDisc, 10)   || 0;
      var supplyDays = parseInt(activeRow.dataset.supplyDays, 10) || 0;

      // 4. Sync form inputs (this is what actually gets POSTed to cart)
      if (variantIdInput) variantIdInput.value = activeRow.dataset.variantId || '';
      if (planInput){
        planInput.value = (plan === 'sub') ? (activeRow.dataset.subPlan || '') : '';
      }

      // 5. CTA label
      var unit = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var ctaLabel = root.dataset.ctaSub || root.dataset.ctaOnce || 'Get Started Now';
      if (ctaText) ctaText.textContent = ctaLabel + ' · ' + fmt(unit);
      // Never mark as sold-out from JS — only the cart endpoint can know
      if (ctaBtn){
        ctaBtn.classList.remove('is-soldout');
        ctaBtn.disabled = false;
      }

      // 6. CTA sub-line
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = supplyDays + '-day supply · Auto-Ship selected · Cancel anytime';
        } else {
          ctaSub.textContent = supplyDays + '-day supply · One-time purchase, no Auto-Ship';
        }
      }

      // 7. Sub perks block visibility + dynamic "Save X% on every shipment"
      if (subPerks){
        subPerks.style.display = (plan === 'sub') ? '' : 'none';
      }
      if (perkSaveEl){
        if (!perkSaveEl.dataset.bbxPerkTpl){
          perkSaveEl.dataset.bbxPerkTpl = perkSaveEl.textContent;
        }
        var tpl = perkSaveEl.dataset.bbxPerkTpl;
        perkSaveEl.textContent = tpl.replace(/\d+%/, aDisc + '%');
      }
    }

    // Initial render (wrapped so failure doesn't block anything else)
    try { render(); } catch(e){ if (window.console) console.warn('[bbx]', e); }

    // Form submit safety (only block if explicitly marked sold-out)
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form){
      form.addEventListener('submit', function(ev){
        if (ctaBtn && ctaBtn.classList.contains('is-soldout')){ ev.preventDefault(); }
      });
    }

    // ===== Gallery =====
    var idx = 0;
    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      var prevIdx = idx;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      if (mainBox){
        if (prevIdx === 0 && idx !== 0){
          var rxV = mainBox.querySelector('.bbx__rx-verified');
          if (rxV){
            rxV.style.transition = 'opacity .5s ease 0s';
            setTimeout(function(){ rxV.style.transition = ''; }, 600);
          }
        }
        mainBox.classList.toggle('bbx-not-first', idx !== 0);
      }
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try { active.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); } catch(e){
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on thumb strip
    if (thumbsContainer && thumbs.length > 1){
      var tDown=false, tStartX=0, tStartScroll=0, tMoved=false;
      var endDrag = function(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      };
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true; tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){ tDown = false; thumbsContainer._bbxDragged = false; }
      });
    }

    // Main image swipe (touch + mouse)
    if (mainBox && thumbs.length > 1){
      var sx=0, sy=0, swiping=false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, {passive:true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive:true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive:true});

      var mx=0, my=0, mdown=false, mmoved=false;
      mainBox.addEventListener('mousedown', function(e){ mdown=true; mmoved=false; mx=e.clientX; my=e.clientY; });
      mainBox.addEventListener('mousemove', function(e){ if (!mdown) return; if (Math.abs(e.clientX - mx) > 5) mmoved = true; });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ivermectin-official"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ===== Scoped to ONLY ivermectin-official sections via unique class + init flag =====
  // Critical: do NOT use the generic .bbx selector — that would conflict with
  // buybox-v4.liquid (supps) which uses the same base class.

  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx-iverm');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxIvermInit === '1') continue;
      el.dataset.bbxIvermInit = '1';
      try { initSection(el); } catch (e) { if (window.console) console.warn('[bbx-iverm]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var slot = parseInt(root.dataset.activeSlot || '1', 10);
    if (isNaN(slot)) slot = 1;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows = root.querySelectorAll('.bbx__qty-row');
    var variantIdInput = root.querySelector('input[name="id"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText = root.querySelector('[data-bbx-cta-text]');
    var ctaBtn = root.querySelector('[data-bbx-cta]');
    var ctaSub = root.querySelector('[id^="bbx-cta-sub-"]');
    var subPerks = root.querySelector('[id^="bbx-sub-perks-"]');
    var perkSaveEl = root.querySelector('[data-bbx-perk-save]');
    var main = root.querySelector('.bbx__main img');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var mainBox = root.querySelector('.bbx__main');

    // Pure visual toggle — pull it out of render() so click ALWAYS updates UI
    // even if any math/render logic throws.
    function applyPlanVisual(){
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var on = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', on);
        pb.setAttribute('aria-checked', on ? 'true' : 'false');
      }
    }
    function applySlotVisual(){
      for (var i = 0; i < qtyRows.length; i++){
        var rb = qtyRows[i];
        var on = parseInt(rb.dataset.slot, 10) === slot;
        rb.classList.toggle('is-on', on);
        rb.setAttribute('aria-checked', on ? 'true' : 'false');
      }
    }

    // ===== Bind direct click handlers on each button =====
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan || 'once';
          applyPlanVisual();
          try { render(); } catch(e){ if (window.console) console.warn('[bbx-iverm]', e); }
        });
      })(planCards[p]);
    }

    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var ns = parseInt(btn.dataset.slot, 10);
          if (!isNaN(ns)) slot = ns;
          applySlotVisual();
          if (window.history && window.history.replaceState){
            try {
              var u = new URL(window.location);
              if (btn.dataset.variantId) u.searchParams.set('variant', btn.dataset.variantId);
              window.history.replaceState(null, '', u);
            } catch(e){}
          }
          try { render(); } catch(e){ if (window.console) console.warn('[bbx-iverm]', e); }
        });
      })(qtyRows[q]);
    }

    // ===== Backup: event delegation on section root =====
    // If something stops the direct handlers (theme JS, weird DOM mutation),
    // this still catches the bubbled click and fires the same logic.
    root.addEventListener('click', function(ev){
      var target = ev.target;
      while (target && target !== root){
        if (target.classList){
          if (target.classList.contains('bbx__plan-card')){
            ev.preventDefault();
            ev.stopPropagation();
            var newPlan = target.dataset.plan || 'once';
            if (newPlan !== plan){
              plan = newPlan;
              applyPlanVisual();
              try { render(); } catch(e){}
            }
            return;
          }
          if (target.classList.contains('bbx__qty-row')){
            ev.preventDefault();
            ev.stopPropagation();
            var ns = parseInt(target.dataset.slot, 10);
            if (!isNaN(ns) && ns !== slot){
              slot = ns;
              applySlotVisual();
              try { render(); } catch(e){}
            }
            return;
          }
        }
        target = target.parentNode;
      }
    });

    function getActiveRow(){
      for (var i = 0; i < qtyRows.length; i++){
        if (parseInt(qtyRows[i].dataset.slot, 10) === slot) return qtyRows[i];
      }
      return qtyRows[0];
    }

    function render(){
      // 1. Plan card visuals
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }

      // 2. Variant row visuals + per-row price + save chip
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var rOn = parseInt(b.dataset.slot, 10) === slot;
        b.classList.toggle('is-on', rOn);
        b.setAttribute('aria-checked', rOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var priceEl = b.querySelector('[data-bbx-price]');
        var wasEl   = b.querySelector('[data-bbx-was]');
        var saveEl  = b.querySelector('[data-bbx-save]');

        if (plan === 'sub' && subPrice > 0){
          if (priceEl) priceEl.textContent = fmt(subPrice);
          if (wasEl) wasEl.textContent = oncePrice > subPrice ? fmt(oncePrice) : '';
          if (saveEl) saveEl.textContent = subDisc > 0 ? 'SAVE ' + subDisc + '%' : '';
        } else {
          if (priceEl) priceEl.textContent = fmt(oncePrice);
          if (wasEl) wasEl.textContent = '';
          if (saveEl) saveEl.textContent = '';
        }
      }

      // 3. Active variant lookup
      var activeRow = getActiveRow();
      if (!activeRow) return;

      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var aDisc = parseInt(activeRow.dataset.subDisc, 10)   || 0;
      var supplyDays = parseInt(activeRow.dataset.supplyDays, 10) || 0;

      // 4. Sync form inputs (this is what actually gets POSTed to cart)
      if (variantIdInput) variantIdInput.value = activeRow.dataset.variantId || '';
      if (planInput){
        planInput.value = (plan === 'sub') ? (activeRow.dataset.subPlan || '') : '';
      }

      // 5. CTA label
      var unit = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var ctaLabel = root.dataset.ctaSub || root.dataset.ctaOnce || 'Get Started Now';
      if (ctaText) ctaText.textContent = ctaLabel + ' · ' + fmt(unit);
      // Never mark as sold-out from JS — only the cart endpoint can know
      if (ctaBtn){
        ctaBtn.classList.remove('is-soldout');
        ctaBtn.disabled = false;
      }

      // 6. CTA sub-line
      if (ctaSub){
        if (plan === 'sub'){
          ctaSub.textContent = supplyDays + '-day supply · Auto-Ship selected · Cancel anytime';
        } else {
          ctaSub.textContent = supplyDays + '-day supply · One-time purchase, no Auto-Ship';
        }
      }

      // 7. Sub perks block visibility + dynamic "Save X% on every shipment"
      if (subPerks){
        subPerks.style.display = (plan === 'sub') ? '' : 'none';
      }
      if (perkSaveEl){
        if (!perkSaveEl.dataset.bbxPerkTpl){
          perkSaveEl.dataset.bbxPerkTpl = perkSaveEl.textContent;
        }
        var tpl = perkSaveEl.dataset.bbxPerkTpl;
        perkSaveEl.textContent = tpl.replace(/\d+%/, aDisc + '%');
      }
    }

    // Initial render (wrapped so failure doesn't block anything else)
    try { render(); } catch(e){ if (window.console) console.warn('[bbx]', e); }

    // Form submit safety (only block if explicitly marked sold-out)
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form){
      form.addEventListener('submit', function(ev){
        if (ctaBtn && ctaBtn.classList.contains('is-soldout')){ ev.preventDefault(); }
      });
    }

    // ===== Gallery =====
    var idx = 0;
    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try { active.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); } catch(e){
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on thumb strip
    if (thumbsContainer && thumbs.length > 1){
      var tDown=false, tStartX=0, tStartScroll=0, tMoved=false;
      var endDrag = function(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      };
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true; tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){ tDown = false; thumbsContainer._bbxDragged = false; }
      });
    }

    // Main image swipe (touch + mouse)
    if (mainBox && thumbs.length > 1){
      var sx=0, sy=0, swiping=false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, {passive:true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive:true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive:true});

      var mx=0, my=0, mdown=false, mmoved=false;
      mainBox.addEventListener('mousedown', function(e){ mdown=true; mmoved=false; mx=e.clientX; my=e.clientY; });
      mainBox.addEventListener('mousemove', function(e){ if (!mdown) return; if (Math.abs(e.clientX - mx) > 5) mmoved = true; });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mints-buy-box"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;
    var wasPrefix = root.dataset.wasPrefix || 'was';

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var idInput   = root.querySelector('input[name="id"]');
    var ctaBtn    = root.querySelector('.bbx__cta');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    // ---- Variant data island ----
    var vmap = {};
    var vscript = root.querySelector('[id^="bbx-vdata-"]');
    if (vscript){ try { vmap = JSON.parse(vscript.textContent); } catch(e){ vmap = {}; } }
    var variantBtns = root.querySelectorAll('.bbx__variant');
    var curAvail = true;

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    // Push a variant's numbers into the qty rows + hidden id + gallery + "was" prices
    function applyVariant(id){
      var d = vmap[id];
      if (!d) return;
      if (idInput) idInput.value = id;
      curAvail = d.avail !== false;
      for (var r = 0; r < qtyRows.length; r++){
        var row = qtyRows[r];
        var n = parseInt(row.dataset.qty, 10);
        var k = n - 1;
        if (k < 0 || k > 2) continue;
        row.dataset.oncePrice = d.once[k];
        row.dataset.onceDisc  = d.oncedisc[k];
        row.dataset.subPrice  = d.sub[k];
        row.dataset.subDisc   = d.subdisc[k];
        row.dataset.subPlan   = d.plan[k] || '';
        var wasEl = row.querySelector('.bbx__qty-was');
        if (wasEl && d.base){ wasEl.textContent = wasPrefix + ' ' + fmt(d.base); }
      }
      // Filter the gallery to this variant's images by alt text
      // (Adults -> alt "1", Kids -> alt "2"); falls back to the variant image.
      filterGallery(d.alt || '', d.img || '');
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (activeRow){
        var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
        var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
        var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
        var totalCents = unit * qty;
        var days = qty * 30;
        var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
        var subLabel  = root.dataset.ctaSub  || 'Start Now';
        if (ctaText){
          ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
        }
        if (ctaSub){
          if (plan === 'sub'){
            ctaSub.textContent = days + '-day supply · Auto-Ship selected';
          } else {
            ctaSub.textContent = days + '-day supply · One-time purchase, no Auto-Ship';
          }
        }
      }

      // Sold-out state wins over everything
      if (ctaBtn){
        if (curAvail === false){
          ctaBtn.disabled = true;
          ctaBtn.style.opacity = '0.55';
          ctaBtn.style.cursor = 'not-allowed';
          if (ctaText) ctaText.textContent = 'Sold Out';
          if (ctaSub)  ctaSub.textContent  = 'This option is currently out of stock';
        } else {
          ctaBtn.disabled = false;
          ctaBtn.style.opacity = '';
          ctaBtn.style.cursor = '';
        }
      }
    }

    // Variant button bindings
    for (var vb2 = 0; vb2 < variantBtns.length; vb2++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          for (var x = 0; x < variantBtns.length; x++){
            var on = variantBtns[x] === btn;
            variantBtns[x].classList.toggle('is-on', on);
            variantBtns[x].setAttribute('aria-checked', on ? 'true' : 'false');
          }
          applyVariant(btn.dataset.variantId);
          render();
        });
      })(variantBtns[vb2]);
    }

    // Plan card bindings
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    // Qty row bindings
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var allThumbs = Array.prototype.slice.call(thumbs);
    var activeThumbs = allThumbs;   // current visible subset (after alt-text filter)
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!activeThumbs.length) return;
      var len = activeThumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < allThumbs.length; t++) allThumbs[t].classList.remove('is-on');
      var cur = activeThumbs[idx];
      cur.classList.add('is-on');
      var src = cur.dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + activeThumbs.length;
      if (cur && cur.scrollIntoView){
        try {
          cur.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          if (thumbsContainer){
            var offset = cur.offsetLeft - (thumbsContainer.clientWidth - cur.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }

    // Show only thumbs whose data-alt matches `alt`. Blank alt (or no match) = show all.
    function filterGallery(alt, fallbackImg){
      var subset = allThumbs;
      if (alt){
        var target = String(alt).trim();
        var matched = allThumbs.filter(function(t){ return (t.dataset.alt || '').trim() === target; });
        if (matched.length) subset = matched;
      }
      activeThumbs = subset;
      for (var i = 0; i < allThumbs.length; i++){
        allThumbs[i].style.display = (subset.indexOf(allThumbs[i]) === -1) ? 'none' : '';
      }
      idx = 0;
      if (activeThumbs.length){
        setSlide(0);
      } else if (fallbackImg && main){
        main.src = fallbackImg;
      }
    }

    for (var k = 0; k < allThumbs.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          var pos = activeThumbs.indexOf(btn);
          if (pos !== -1) setSlide(pos);
        });
      })(allThumbs[k]);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    // Sync qty rows to the initially-selected variant, then paint.
    if (idInput && vmap[idInput.value]) applyVariant(idInput.value);
    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["showerhead-buybox"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaBtn    = root.querySelector('.bbx__cta');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var available = root.dataset.available !== '0';
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');
    var qtyMetas  = root.querySelectorAll('.bbx__qty-meta');
    var vipChip   = root.querySelector('.bbx__vip-chip');
    var vipUnitEl = root.querySelector('[id^="bbx-vip-unit-"]');
    var vipTotalEl= root.querySelector('[id^="bbx-vip-total-"]');

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Sub-only meta line under each qty name
      for (var m = 0; m < qtyMetas.length; m++){
        qtyMetas[m].style.display = (plan === 'sub') ? '' : 'none';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      var soldoutLabel = root.dataset.ctaSoldout || 'Sold Out';
      if (ctaBtn){
        ctaBtn.classList.toggle('is-soldout', !available);
        ctaBtn.disabled = !available;
      }
      if (ctaText){
        if (!available){
          ctaText.textContent = soldoutLabel;
        } else {
          ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
        }
      }
      if (ctaSub){
        var onceSubText = root.dataset.ctasubOnce || 'One-time purchase — no Auto-Ship';
        var subSubText  = root.dataset.ctasubSub  || 'Auto-Ship: filter refills every 90 days · Cancel anytime';
        ctaSub.textContent = (plan === 'sub') ? subSubText : onceSubText;
      }

      // VIP chip — % off the currently selected unit price
      if (vipChip && vipUnitEl && vipTotalEl){
        var vipPct  = parseFloat(vipChip.dataset.vipPct) || 20;
        var vipUnit = Math.round(unit * (100 - vipPct) / 100);
        vipUnitEl.textContent  = fmt(vipUnit);
        vipTotalEl.textContent = fmt(vipUnit * qty);
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

/* ===== $67 explainer tab — self-initializing, independent of which .bbx bundle owns initSection ===== */
(function(){
  function initDeal(tab){
    if (tab.dataset.deal67Init === '1') return;
    tab.dataset.deal67Init = '1';
    var section = tab.closest('.bbx');
    if (!section) return;
    var planSub  = section.querySelector('.bbx__plan-card[data-plan="sub"]');
    var planOnce = section.querySelector('.bbx__plan-card[data-plan="once"]');
    var qty3     = section.querySelector('.bbx__qty-row[data-qty="3"]');
    var setBtn   = tab.querySelector('.bbx__deal67-set');
    var vipChip  = section.querySelector('.bbx__vip-chip');
    var ctaSub   = section.querySelector('[id^="bbx-cta-sub-"]');
    var onceTxt  = section.dataset.ctasubOnce || 'One-time purchase — no Auto-Ship';
    var subTxt   = section.dataset.ctasubSub  || 'Auto-Ship: filter refills every 90 days · Cancel anytime';

    function sync(){
      var subOn = planSub ? planSub.classList.contains('is-on') : false;
      var q3On  = qty3 ? qty3.classList.contains('is-on') : false;
      var all = subOn && q3On;
      tab.classList.toggle('is-selected', all);
      if (setBtn) setBtn.hidden = all;
      if (ctaSub) ctaSub.textContent = subOn ? subTxt : onceTxt;
    }
    function pulseChip(){
      if (!vipChip) return;
      vipChip.classList.remove('bbx__vip-pulse');
      void vipChip.offsetWidth;
      vipChip.classList.add('bbx__vip-pulse');
    }
    if (setBtn){
      setBtn.addEventListener('click', function(ev){
        ev.preventDefault();
        if (planSub && !planSub.classList.contains('is-on')) planSub.click();
        if (qty3 && !qty3.classList.contains('is-on')) qty3.click();
        pulseChip();
      });
    }
    if (window.MutationObserver){
      var mo = new MutationObserver(function(){ sync(); });
      var targets = [planSub, planOnce, qty3];
      for (var i = 0; i < targets.length; i++){
        if (targets[i]) mo.observe(targets[i], {attributes: true, attributeFilter: ['class', 'aria-checked']});
      }
    }
    sync();
  }
  function initAllDeals(scope){
    var root = scope && scope.querySelector ? scope : document;
    var tabs = root.querySelectorAll('.bbx__deal67');
    for (var i = 0; i < tabs.length; i++){
      try { initDeal(tabs[i]); } catch (e) { console && console.warn && console.warn('[bbx-deal67]', e); }
    }
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAllDeals(); });
  } else {
    initAllDeals();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAllDeals(e.target); } else { initAllDeals(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["superfood-buy-box-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      const sections = document.querySelectorAll('[data-bb]');
      sections.forEach(s => {
        if (s.dataset.bbInit === '1') return;
        s.dataset.bbInit = '1';
        try { initSection(s); }
        catch (err) { console.error('[buy-box] init failed:', err, s); }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);

    function initSection(section) {
      const cfgEl = section.querySelector('[data-bb-config]');
      let cfg = {};
      try { cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {}; }
      catch (e) { console.error('[buy-box] config JSON parse failed:', e); cfg = {}; }

      const mainImg  = section.querySelector('[data-bb-main]');
      const topPill  = section.querySelector('[data-bb-pill]');
      const ctaBtn   = section.querySelector('[data-bb-cta]');
      const ctaText  = ctaBtn ? ctaBtn.querySelector('.bb-cta__text')  : null;
      const ctaPrice = ctaBtn ? ctaBtn.querySelector('.bb-cta__price') : null;
      const disc     = section.querySelector('[data-bb-disclaimer]');
      const tabs     = section.querySelectorAll('[data-bb-tab]');
      const tiers    = section.querySelectorAll('[data-bb-tier]');
      const tierBlocks = section.querySelectorAll('[data-bb-tier-block]');

      let mode = 'sub';
      let selectedTier = null;

      // ===== TABS =====
      tabs.forEach(t => {
        t.addEventListener('click', () => {
          tabs.forEach(x => {
            x.classList.remove('is-active');
            x.setAttribute('aria-selected', 'false');
            const chk = x.querySelector('.bb-tab__check');
            if (chk) chk.textContent = '';
          });
          t.classList.add('is-active');
          t.setAttribute('aria-selected', 'true');
          const chk = t.querySelector('.bb-tab__check');
          if (chk) chk.textContent = '✓';
          mode = t.dataset.bbTab;
          section.setAttribute('data-bb-mode', mode);
          document.body.classList.toggle('bb-is-one-mode', mode === 'one');
          applyTierPricing();
          updateCTA();
        });
      });
      section.setAttribute('data-bb-mode', mode);

      // ===== TIERS =====
      tiers.forEach(t => {
        t.addEventListener('click', () => {
          tierBlocks.forEach(b => b.classList.remove('is-selected'));
          t.closest('[data-bb-tier-block]').classList.add('is-selected');
          selectedTier = t;
          updateCTA();
        });
      });
      selectedTier = section.querySelector('.bb-tier-block.is-selected [data-bb-tier]') || tiers[tiers.length - 1];
      if (selectedTier && !selectedTier.closest('.bb-tier-block').classList.contains('is-selected')) {
        selectedTier.closest('.bb-tier-block').classList.add('is-selected');
      }

      function applyTierPricing() {
        tiers.forEach(t => {
          const off = mode === 'one' ? t.dataset.otpOff   : t.dataset.subOff;
          const now = mode === 'one' ? t.dataset.otpPrice : t.dataset.subPrice;
          const was = mode === 'one' ? t.dataset.otpWas   : t.dataset.subWas;
          const pps = mode === 'one' ? t.dataset.otpPps   : t.dataset.subPps;
          const dEl = t.querySelector('[data-bb-discount]');
          const nEl = t.querySelector('[data-bb-now]');
          const wEl = t.querySelector('[data-bb-was]');
          const pEl = t.querySelector('[data-bb-pps]');
          if (dEl) {
            const tpl = t.dataset.badgeTemplate || 'SAVE {percent}%';
            dEl.textContent = tpl.replace(/\{percent\}/g, off || '0');
          }
          if (nEl) nEl.textContent = '$' + (now || '0.00');
          if (wEl) wEl.textContent = '$' + (was || '0.00');
          if (pEl && pps) {
            const label = pEl.dataset.label || pEl.textContent.replace(/^\$[\d.]+\s*/, '').trim();
            pEl.dataset.label = label;
            pEl.textContent = '$' + pps + ' ' + label;
          }
        });
      }

      function updateCTA() {
        if (!selectedTier) return;
        const days = selectedTier.dataset.days || '';
        const price = mode === 'one' ? selectedTier.dataset.otpPrice : selectedTier.dataset.subPrice;
        if (ctaText)  ctaText.textContent  = mode === 'one' ? (cfg.ctaOtp || 'Buy Now') : (cfg.ctaSub || 'Subscribe');
        if (ctaPrice) ctaPrice.textContent = '$' + (price || '0.00');
        const template = mode === 'one' ? (cfg.discOtp || '') : (cfg.discSub || '');
        if (disc) disc.textContent = template.replace(/\{days\}/g, days);
      }

      applyTierPricing();
      updateCTA();

      // ===== CTA → CART =====
      if (ctaBtn) ctaBtn.addEventListener('click', addToCart);

      function resolveSellingPlan() {
        if (mode !== 'sub' || !selectedTier) return null;
        let id = selectedTier.dataset.sellingPlan;
        if (!id || id === '0' || id === '') id = cfg.fallbackSellingPlan ? String(cfg.fallbackSellingPlan) : '';
        if (!id || id === '0' || id === '') {
          console.error('[buy-box] Sub mode is active but no Skio selling plan is configured. Item will add as one-time. Fill the tier "Skio selling plan ID" setting OR make sure the product has a Skio plan attached.');
          return null;
        }
        return id;
      }

      function buildItems(includeGifts) {
        const qty = parseInt(selectedTier.dataset.qty || '1', 10);
        const sellingPlanId = resolveSellingPlan();
        const props = { _tier_days: selectedTier.dataset.days };
        const mainItem = { id: cfg.variantId, quantity: qty, properties: props };
        if (sellingPlanId) mainItem.selling_plan = Number(sellingPlanId);
        const list = [mainItem];
        if (includeGifts && mode === 'sub' && cfg.gifts && cfg.gifts.length) {
          cfg.gifts.forEach(g => {
            list.push({ id: g.variantId, quantity: 1, properties: { _promo_gift: '1', _gift_for: cfg.productId.toString() } });
          });
        }
        return list;
      }

      // Opens the cart drawer SYNCHRONOUSLY using whatever app is installed.
      // SlideCart HQ / AMP Cart: window.SLIDECART_OPEN() — confirmed live as 6–17ms.
      // UpCart, Dawn, generic: API fallbacks + event dispatch.
      function openDrawer() {
        // SlideCart HQ / AMP Cart — REAL globals (uppercase), confirmed via live profiling
        try { if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN(); } catch (_) {}
        try { if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE(); } catch (_) {}
        // Other potential cart-drawer APIs (defensive — these may not exist)
        const apis = [
          () => window.SlideCart && window.SlideCart.open && window.SlideCart.open(),
          () => window.ampCart && window.ampCart.openCart && window.ampCart.openCart(),
          () => window.ampCart && window.ampCart.open && window.ampCart.open(),
          () => window.ssc && window.ssc.open && window.ssc.open(),
          () => window.theme && window.theme.openCartDrawer && window.theme.openCartDrawer()
        ];
        for (let i = 0; i < apis.length; i++) { try { apis[i](); } catch (_) {} }
        // Event dispatch for anything still listening
        const evts = ['cart:refresh','cart:open','cart:updated','cart:added','slidecart:open','slidecart:refresh'];
        for (let i = 0; i < evts.length; i++) {
          document.dispatchEvent(new CustomEvent(evts[i], { bubbles: true }));
        }
      }

      function attemptAdd(includeGifts) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: buildItems(includeGifts) })
        });
      }

      async function addToCart() {
        if (!selectedTier || !ctaBtn) return;
        ctaBtn.disabled = true;
        ctaBtn.classList.add('is-loading');

        // ===== OPTIMISTIC OPEN =====
        // Fire the drawer open INSTANTLY (before /cart/add.js even starts).
        // SlideCart shows the current cart state, then auto-refreshes when fetch resolves.
        // Perceived ATC speed: 6–17ms. Server work happens silently behind the visible drawer.
        if (cfg.checkoutMode === 'drawer') {
          openDrawer();
        }

        try {
          let r = await attemptAdd(true);

          // Error path: read response, retry without gifts if a gift item is the blocker.
          if (!r.ok) {
            const errData = await r.json().catch(() => null);
            const desc = (errData && (errData.description || errData.message)) || '';
            console.error('[buy-box] /cart/add.js error', r.status, desc, errData);
            const giftBlocked = /quantity|sold out|unavailable|not available|inventory|stock/i.test(desc);
            if (giftBlocked && mode === 'sub' && cfg.gifts && cfg.gifts.length) {
              console.warn('[buy-box] Retrying /cart/add.js without free gifts.');
              r = await attemptAdd(false);
            }
            if (!r.ok) throw new Error('cart add failed: ' + (desc || r.status));
          }

          if (cfg.checkoutMode === 'drawer') {
            // Force a refresh so SlideCart pulls the freshly-added line server-side.
            try { if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE(); } catch (_) {}
            // Re-fire open in case the optimistic call was suppressed before SlideCart booted.
            openDrawer();
            ctaBtn.classList.remove('is-loading');
            ctaBtn.disabled = false;
            // Background diagnostic — never blocks UI.
            if (mode === 'sub') {
              r.json().then(data => {
                if (data && data.items) {
                  const subLine = data.items.find(it => Number(it.id) === Number(cfg.variantId) && (it.selling_plan_allocation || it.selling_plan));
                  if (!subLine) console.error('[buy-box] /cart/add returned 200 but main item is NOT a subscription.', data);
                }
              }).catch(() => {});
            }
            return;
          }

          // Redirect modes — leave loading state on; page is navigating away
          if (cfg.discountCode) {
            window.location.href = '/discount/' + encodeURIComponent(cfg.discountCode) + '?redirect=/checkout';
          } else {
            window.location.href = cfg.checkoutMode === 'cart' ? '/cart' : '/checkout';
          }
        } catch (e) {
          console.error('[buy-box] addToCart failed:', e);
          ctaBtn.classList.remove('is-loading');
          ctaBtn.disabled = false;
        }
      }

      // ===== GALLERY =====
      const thumbsViewport = section.querySelector('[data-bb-thumbs]');
      if (thumbsViewport) initGallery();

      function initGallery() {
        const originalThumbs = [...thumbsViewport.querySelectorAll('[data-bb-thumb]')];
        const N = originalThumbs.length;
        if (N === 0) return;
        const track = document.createElement('div');
        track.className = 'bb-thumb-track';
        originalThumbs.forEach(t => track.appendChild(t));
        for (let copy = 0; copy < 2; copy++) originalThumbs.forEach(t => track.appendChild(t.cloneNode(true)));
        thumbsViewport.appendChild(track);

        let translateX = 0, oneSetWidth = 0, oneStepWidth = 0;
        let activeIdx = 0;
        let activeSrc = originalThumbs[0]?.dataset.src || '';
        const SPEED = 0.022;
        let lastFrame = 0, autoplayPaused = false, isDragging = false, smoothShiftActive = false;
        let resumeTimer = null;
        let dragStartX = 0, pointerDownX = 0, dragStartTranslate = 0, dragMoved = false;
        let activePointerId = null;
        const DRAG_THRESHOLD = 10;

        function measure() {
          const total = track.scrollWidth + 8;
          oneSetWidth = total / 3;
          const first = track.querySelector('.bb-thumb');
          if (first) oneStepWidth = first.getBoundingClientRect().width + 8;
        }
        function applyTranslate() { track.style.transform = 'translate3d(' + translateX + 'px,0,0)'; }
        function wrapX() {
          if (!oneSetWidth) return;
          while (translateX <= -oneSetWidth) translateX += oneSetWidth;
          while (translateX > 0) translateX -= oneSetWidth;
        }
        function paintActive() {
          track.querySelectorAll('.bb-thumb').forEach(t => t.classList.toggle('is-active', t.dataset.src === activeSrc));
        }
        paintActive();

        function tick(now) {
          if (!lastFrame) lastFrame = now;
          const dt = Math.min(now - lastFrame, 64);
          lastFrame = now;
          if (!isDragging && !autoplayPaused && !smoothShiftActive && oneSetWidth) {
            translateX -= SPEED * dt;
            wrapX();
            applyTranslate();
          }
          requestAnimationFrame(tick);
        }
        function pauseAutoplay(ms = 2000) {
          autoplayPaused = true;
          clearTimeout(resumeTimer);
          resumeTimer = setTimeout(() => { autoplayPaused = false; }, ms);
        }

        track.addEventListener('pointerdown', e => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          isDragging = true;
          dragStartX = e.clientX;
          pointerDownX = e.clientX;
          dragStartTranslate = translateX;
          dragMoved = false;
          activePointerId = e.pointerId;
          try { track.setPointerCapture(e.pointerId); } catch (_) {}
          thumbsViewport.classList.add('is-dragging');
          clearTimeout(resumeTimer);
          autoplayPaused = true;
        });
        track.addEventListener('pointermove', e => {
          if (!isDragging || e.pointerId !== activePointerId) return;
          const delta = e.clientX - dragStartX;
          if (Math.abs(delta) > DRAG_THRESHOLD) dragMoved = true;
          translateX = dragStartTranslate + delta;
          wrapX();
          applyTranslate();
        });
        function endDrag(e) {
          if (e.pointerId !== activePointerId) return;
          const totalDelta = Math.abs(e.clientX - pointerDownX);
          if (totalDelta <= DRAG_THRESHOLD) dragMoved = false;
          isDragging = false;
          activePointerId = null;
          thumbsViewport.classList.remove('is-dragging');
          pauseAutoplay(1800);
        }
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
        track.addEventListener('lostpointercapture', endDrag);

        track.addEventListener('click', e => {
          // Block click only when it was a real drag (significant movement during this gesture)
          if (dragMoved) {
            dragMoved = false;
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          // Find the thumb — check e.target, then walk up, then fall back to point lookup
          let thumb = e.target && e.target.closest ? e.target.closest('.bb-thumb') : null;
          if (!thumb && e.clientX != null) {
            const el = document.elementFromPoint(e.clientX, e.clientY);
            if (el && el.closest) thumb = el.closest('.bb-thumb');
          }
          if (!thumb || !thumb.dataset.src) return;
          selectThumb(thumb.dataset.src);
        });
        // Belt-and-suspenders: also attach direct click listeners to each thumb (original + clones)
        track.querySelectorAll('.bb-thumb').forEach(t => {
          t.addEventListener('click', e => {
            if (dragMoved) { dragMoved = false; e.preventDefault(); return; }
            if (t.dataset.src) selectThumb(t.dataset.src);
          });
        });
        function selectThumb(src) {
          if (!src) return;
          activeSrc = src;
          paintActive();
          if (mainImg) {
            mainImg.classList.add('is-hidden');
            setTimeout(() => { mainImg.src = src; mainImg.classList.remove('is-hidden'); }, 80);
          }
          const idx = originalThumbs.findIndex(t => t.dataset.src === src);
          if (topPill && topPill.hasAttribute('data-pill-first-only')) topPill.style.display = idx === 0 ? '' : 'none';
          pauseAutoplay(2500);
        }

        // ===== MAIN HERO SWIPE — cycle through images endlessly =====
        const hero = section.querySelector('.bb-hero');
        if (hero && originalThumbs.length > 1) {
          let sX = 0, sY = 0, sId = null, swiped = false;
          hero.addEventListener('pointerdown', e => {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            sX = e.clientX; sY = e.clientY; sId = e.pointerId; swiped = false;
            hero.classList.add('is-swiping');
          });
          hero.addEventListener('pointermove', e => {
            if (e.pointerId !== sId) return;
            const dx = e.clientX - sX;
            const dy = e.clientY - sY;
            if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy) * 1.2) swiped = true;
          });
          function endHeroSwipe(e) {
            if (e.pointerId !== sId) return;
            sId = null;
            hero.classList.remove('is-swiping');
            const dx = e.clientX - sX;
            const dy = e.clientY - sY;
            if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;
            const direction = dx < 0 ? 1 : -1; // left swipe → next, right swipe → previous
            const currentIdx = originalThumbs.findIndex(t => t.dataset.src === activeSrc);
            const N = originalThumbs.length;
            const startIdx = currentIdx === -1 ? 0 : currentIdx;
            const nextIdx = (startIdx + direction + N) % N;
            selectThumb(originalThumbs[nextIdx].dataset.src);
          }
          hero.addEventListener('pointerup', endHeroSwipe);
          hero.addEventListener('pointercancel', endHeroSwipe);
          // Prevent default image drag behavior so swipe feels smooth
          hero.addEventListener('dragstart', e => e.preventDefault());
        }

        function smoothShift(delta, dur = 360) {
          smoothShiftActive = true;
          pauseAutoplay(2000);
          const start = translateX;
          const startTime = performance.now();
          function step(now) {
            const t = Math.min((now - startTime) / dur, 1);
            const eased = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
            translateX = start + delta * eased;
            wrapX();
            applyTranslate();
            if (t < 1) requestAnimationFrame(step);
            else smoothShiftActive = false;
          }
          requestAnimationFrame(step);
        }
        section.querySelector('[data-bb-prev]')?.addEventListener('click', () => { measure(); smoothShift(oneStepWidth); });
        section.querySelector('[data-bb-next]')?.addEventListener('click', () => { measure(); smoothShift(-oneStepWidth); });

        requestAnimationFrame(() => requestAnimationFrame(() => { measure(); requestAnimationFrame(tick); }));
        window.addEventListener('load', () => { measure(); }, { once: true });
        let resizeRaf;
        window.addEventListener('resize', () => {
          cancelAnimationFrame(resizeRaf);
          resizeRaf = requestAnimationFrame(() => { measure(); wrapX(); applyTranslate(); });
        });
        thumbsViewport.addEventListener('mouseenter', () => { if (!isDragging) autoplayPaused = true; });
        thumbsViewport.addEventListener('mouseleave', () => { clearTimeout(resumeTimer); if (!isDragging) autoplayPaused = false; });
      }

      // ===== FAQ accordion =====
      section.querySelectorAll('[data-bb-faq-q]').forEach(btn => {
        btn.addEventListener('click', () => btn.closest('.bb-faq__item').classList.toggle('is-open'));
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["t26-greens-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;
    var wasPrefix = root.dataset.wasPrefix || 'was';

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows   = root.querySelectorAll('.bbx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var idInput   = root.querySelector('input[name="id"]');
    var ctaBtn    = root.querySelector('.bbx__cta');
    var ctaText   = root.querySelector('[id^="bbx-cta-text-"]');
    var ctaSub    = root.querySelector('[id^="bbx-cta-sub-"]');
    var qtyExtra2 = root.querySelector('.bbx__qty-row[data-qty="2"] .bbx__qty-extra');

    // ---- Variant data island ----
    var vmap = {};
    var vscript = root.querySelector('[id^="bbx-vdata-"]');
    if (vscript){ try { vmap = JSON.parse(vscript.textContent); } catch(e){ vmap = {}; } }
    var variantBtns = root.querySelectorAll('.bbx__variant');
    var curAvail = true;

    function getActiveQtyRow(){
      return root.querySelector('.bbx__qty-row.is-on') || qtyRows[0];
    }

    // Push a variant's numbers into the qty rows + hidden id + gallery + "was" prices
    function applyVariant(id){
      var d = vmap[id];
      if (!d) return;
      if (idInput) idInput.value = id;
      curAvail = d.avail !== false;
      for (var r = 0; r < qtyRows.length; r++){
        var row = qtyRows[r];
        var n = parseInt(row.dataset.qty, 10);
        var k = n - 1;
        if (k < 0 || k > 2) continue;
        row.dataset.oncePrice = d.once[k];
        row.dataset.onceDisc  = d.oncedisc[k];
        row.dataset.subPrice  = d.sub[k];
        row.dataset.subDisc   = d.subdisc[k];
        row.dataset.subPlan   = d.plan[k] || '';
        var wasEl = row.querySelector('.bbx__qty-was');
        if (wasEl && d.base){ wasEl.textContent = wasPrefix + ' ' + fmt(d.base); }
      }
      // Filter the gallery to this variant's images by alt text
      // (Adults -> alt "1", Kids -> alt "2"); falls back to the variant image.
      filterGallery(d.alt || '', d.img || '');
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.bbx__qty-now');
        var saveEl  = b.querySelector('.bbx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (activeRow){
        var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
        var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
        var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
        var totalCents = unit * qty;
        var days = qty * 30;
        var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
        var subLabel  = root.dataset.ctaSub  || 'Start Now';
        if (ctaText){
          ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
        }
        if (ctaSub){
          if (plan === 'sub'){
            ctaSub.textContent = days + '-day supply · Subscription selected';
          } else {
            ctaSub.textContent = days + '-day supply · One-time purchase, no subscription';
          }
        }
      }

      // Sold-out state wins over everything
      if (ctaBtn){
        if (curAvail === false){
          ctaBtn.disabled = true;
          ctaBtn.style.opacity = '0.55';
          ctaBtn.style.cursor = 'not-allowed';
          if (ctaText) ctaText.textContent = 'Sold Out';
          if (ctaSub)  ctaSub.textContent  = 'This option is currently out of stock';
        } else {
          ctaBtn.disabled = false;
          ctaBtn.style.opacity = '';
          ctaBtn.style.cursor = '';
        }
      }
    }

    // Variant button bindings
    for (var vb2 = 0; vb2 < variantBtns.length; vb2++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          for (var x = 0; x < variantBtns.length; x++){
            var on = variantBtns[x] === btn;
            variantBtns[x].classList.toggle('is-on', on);
            variantBtns[x].setAttribute('aria-checked', on ? 'true' : 'false');
          }
          applyVariant(btn.dataset.variantId);
          render();
        });
      })(variantBtns[vb2]);
    }

    // Plan card bindings
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    // Qty row bindings
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.bbx__main');
    var main = root.querySelector('.bbx__main img');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var allThumbs = Array.prototype.slice.call(thumbs);
    var activeThumbs = allThumbs;   // current visible subset (after alt-text filter)
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!activeThumbs.length) return;
      var len = activeThumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < allThumbs.length; t++) allThumbs[t].classList.remove('is-on');
      var cur = activeThumbs[idx];
      cur.classList.add('is-on');
      var src = cur.dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + activeThumbs.length;
      if (cur && cur.scrollIntoView){
        try {
          cur.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          if (thumbsContainer){
            var offset = cur.offsetLeft - (thumbsContainer.clientWidth - cur.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }

    // Show only thumbs whose data-alt matches `alt`. Blank alt (or no match) = show all.
    function filterGallery(alt, fallbackImg){
      var subset = allThumbs;
      if (alt){
        var target = String(alt).trim();
        var matched = allThumbs.filter(function(t){ return (t.dataset.alt || '').trim() === target; });
        if (matched.length) subset = matched;
      }
      activeThumbs = subset;
      for (var i = 0; i < allThumbs.length; i++){
        allThumbs[i].style.display = (subset.indexOf(allThumbs[i]) === -1) ? 'none' : '';
      }
      idx = 0;
      if (activeThumbs.length){
        setSlide(0);
      } else if (fallbackImg && main){
        main.src = fallbackImg;
      }
    }

    for (var k = 0; k < allThumbs.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          var pos = activeThumbs.indexOf(btn);
          if (pos !== -1) setSlide(pos);
        });
      })(allThumbs[k]);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          tDown = false;
          thumbsContainer._bbxDragged = false;
        }
      });
    }

    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    // Sync qty rows to the initially-selected variant, then paint.
    if (idInput && vmap[idInput.value]) applyVariant(idInput.value);
    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tadalafil-official"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ===== Scoped to ONLY tadalafil-official sections via unique class + init flag =====
  // Critical: never use the generic .bbx selector — that would conflict with the
  // supps buybox-v4, universal merch buy box, and ivermectin-official sections.

  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx-tad');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxTadInit === '1') continue;
      el.dataset.bbxTadInit = '1';
      try { initSection(el); } catch (e) { if (window.console) console.warn('[bbx-tad]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var slot = parseInt(root.dataset.activeSlot || '1', 10);
    if (isNaN(slot)) slot = 1;

    var planCards = root.querySelectorAll('.bbx__plan-card');
    var qtyRows = root.querySelectorAll('.bbx__qty-row');
    var variantIdInput = root.querySelector('input[name="id"]');
    var qtyInput = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText = root.querySelector('[data-bbx-cta-text]');
    var ctaBtn = root.querySelector('[data-bbx-cta]');
    var ctaSub = root.querySelector('[id^="bbx-cta-sub-"]');
    var subPerks = root.querySelector('[id^="bbx-sub-perks-"]');
    var perkSaveEl = root.querySelector('[data-bbx-perk-save]');
    var main = root.querySelector('.bbx__main img');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var mainBox = root.querySelector('.bbx__main');

    // Pure visual toggle — pull out of render() so clicks ALWAYS update UI
    function applyPlanVisual(){
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var on = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', on);
        pb.setAttribute('aria-checked', on ? 'true' : 'false');
      }
    }
    function applySlotVisual(){
      for (var i = 0; i < qtyRows.length; i++){
        var rb = qtyRows[i];
        var on = parseInt(rb.dataset.slot, 10) === slot;
        rb.classList.toggle('is-on', on);
        rb.setAttribute('aria-checked', on ? 'true' : 'false');
      }
    }

    // ===== Plan card click bindings (direct) =====
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan || 'once';
          applyPlanVisual();
          try { render(); } catch(e){ if (window.console) console.warn('[bbx-tad]', e); }
        });
      })(planCards[p]);
    }

    // ===== Quantity row click bindings (direct) =====
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var ns = parseInt(btn.dataset.slot, 10);
          if (!isNaN(ns)) slot = ns;
          applySlotVisual();
          try { render(); } catch(e){ if (window.console) console.warn('[bbx-tad]', e); }
        });
      })(qtyRows[q]);
    }

    // ===== Event delegation backup (covers plan + qty) =====
    root.addEventListener('click', function(ev){
      var target = ev.target;
      while (target && target !== root){
        if (target.classList){
          if (target.classList.contains('bbx__plan-card')){
            ev.preventDefault();
            ev.stopPropagation();
            var newPlan = target.dataset.plan || 'once';
            if (newPlan !== plan){
              plan = newPlan;
              applyPlanVisual();
              try { render(); } catch(e){}
            }
            return;
          }
          if (target.classList.contains('bbx__qty-row')){
            ev.preventDefault();
            ev.stopPropagation();
            var ns = parseInt(target.dataset.slot, 10);
            if (!isNaN(ns) && ns !== slot){
              slot = ns;
              applySlotVisual();
              try { render(); } catch(e){}
            }
            return;
          }
        }
        target = target.parentNode;
      }
    });

    function getActiveRow(){
      for (var i = 0; i < qtyRows.length; i++){
        if (parseInt(qtyRows[i].dataset.slot, 10) === slot) return qtyRows[i];
      }
      return qtyRows[0];
    }

    function render(){
      // 1. Plan card visuals
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }

      // 2. Variant row visuals + per-row price + save chip
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var rOn = parseInt(b.dataset.slot, 10) === slot;
        b.classList.toggle('is-on', rOn);
        b.setAttribute('aria-checked', rOn ? 'true' : 'false');

        var rOnce = parseInt(b.dataset.oncePrice, 10) || 0;
        var rSub  = parseInt(b.dataset.subPrice, 10)  || 0;
        var rDisc = parseInt(b.dataset.subDisc, 10)   || 0;

        var priceEl = b.querySelector('[data-bbx-price]');
        var wasEl   = b.querySelector('[data-bbx-was]');
        var saveEl  = b.querySelector('[data-bbx-save]');

        if (plan === 'sub' && rSub > 0){
          if (priceEl) priceEl.textContent = fmt(rSub);
          if (wasEl) wasEl.textContent = rOnce > rSub ? fmt(rOnce) : '';
          if (saveEl) saveEl.textContent = rDisc > 0 ? 'SAVE ' + rDisc + '%' : '';
        } else {
          if (priceEl) priceEl.textContent = fmt(rOnce);
          if (wasEl) wasEl.textContent = '';
          if (saveEl) saveEl.textContent = '';
        }
      }

      // 3. Active variant lookup
      var activeRow = getActiveRow();
      if (!activeRow) return;

      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var aDisc = parseInt(activeRow.dataset.subDisc, 10)   || 0;
      var supplyDays = parseInt(activeRow.dataset.supplyDays, 10) || 0;

      // 4. Sync form inputs (this is what actually gets POSTed to cart)
      //    variantId is always the same single variant; qtyInput is the slot's
      //    quantity (1 for 30-day, 2 for 60-day) — that's how "60 day" works
      //    without a second Shopify variant.
      if (variantIdInput) variantIdInput.value = activeRow.dataset.variantId || '';
      if (qtyInput) qtyInput.value = activeRow.dataset.qty || '1';
      if (planInput){
        planInput.value = (plan === 'sub') ? (activeRow.dataset.subPlan || '') : '';
      }

      // 5. CTA label
      var unit = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var ctaLabel = root.dataset.ctaText || 'Get Started Now';
      if (ctaText) ctaText.textContent = ctaLabel + ' · ' + fmt(unit);
      if (ctaBtn){
        ctaBtn.classList.remove('is-soldout');
        ctaBtn.disabled = false;
      }

      // 6. CTA sub-line — schema templates with optional supply-day prefix
      if (ctaSub){
        var subOnceTpl = root.dataset.ctaSubOnce || 'Single fill · No Auto-Ship';
        var subSubTpl = root.dataset.ctaSubSub || 'Monthly delivery · Cancel anytime';
        var prefix = supplyDays > 0 ? (supplyDays + '-day supply · ') : '';
        ctaSub.textContent = prefix + ((plan === 'sub') ? subSubTpl : subOnceTpl);
      }

      // 7. Sub perks block visibility + dynamic "Save X% on every shipment"
      if (subPerks){
        subPerks.style.display = (plan === 'sub') ? '' : 'none';
      }
      if (perkSaveEl){
        if (!perkSaveEl.dataset.bbxPerkTpl){
          perkSaveEl.dataset.bbxPerkTpl = perkSaveEl.textContent;
        }
        var tpl = perkSaveEl.dataset.bbxPerkTpl;
        perkSaveEl.textContent = tpl.replace(/\d+%/, aDisc + '%');
      }
    }

    // Initial render (wrapped so failure doesn't block anything else)
    try { render(); } catch(e){ if (window.console) console.warn('[bbx]', e); }

    // Form submit safety (only block if explicitly marked sold-out)
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form){
      form.addEventListener('submit', function(ev){
        if (ctaBtn && ctaBtn.classList.contains('is-soldout')){ ev.preventDefault(); }
      });
    }

    // ===== Gallery =====
    var idx = 0;
    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      var prevIdx = idx;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      if (mainBox){
        if (prevIdx === 0 && idx !== 0){
          var rxV = mainBox.querySelector('.bbx__rx-verified');
          if (rxV){
            rxV.style.transition = 'opacity .5s ease 0s';
            setTimeout(function(){ rxV.style.transition = ''; }, 600);
          }
        }
        mainBox.classList.toggle('bbx-not-first', idx !== 0);
      }
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try { active.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); } catch(e){
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on thumb strip
    if (thumbsContainer && thumbs.length > 1){
      var tDown=false, tStartX=0, tStartScroll=0, tMoved=false;
      var endDrag = function(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      };
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true; tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){ tDown = false; thumbsContainer._bbxDragged = false; }
      });
    }

    // Main image swipe (touch + mouse)
    if (mainBox && thumbs.length > 1){
      var sx=0, sy=0, swiping=false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, {passive:true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive:true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive:true});

      var mx=0, my=0, mdown=false, mmoved=false;
      mainBox.addEventListener('mousedown', function(e){ mdown=true; mmoved=false; mx=e.clientX; my=e.clientY; });
      mainBox.addEventListener('mousemove', function(e){ if (!mdown) return; if (Math.abs(e.clientX - mx) > 5) mmoved = true; });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-26-buybox-universal"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.bbx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.bbxInit === '1') continue;
      el.dataset.bbxInit = '1';
      try { initSection(el); } catch (e) { console && console.warn && console.warn('[bbx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    // ===== Variants data =====
    var variants = [];
    var variantsScript = document.querySelector('script[data-bbx-variants="' + (root.id || '').replace('bbx-', '') + '"]');
    if (!variantsScript){
      // Fallback: find first variants script (single-section pages)
      variantsScript = document.querySelector('script[data-bbx-variants]');
    }
    if (variantsScript){
      try { variants = JSON.parse(variantsScript.textContent); } catch(e){}
    }

    // ===== Refs =====
    var optionGroups = root.querySelectorAll('.bbx__variant-group');
    var variantIdInput = root.querySelector('input[name="id"]');
    var qtyHiddenInput = root.querySelector('input[name="quantity"]');
    var qtyDisplay = root.querySelector('[data-qty-input]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var priceNowEl = root.querySelector('[data-bbx-price-now]');
    var priceWasEl = root.querySelector('[data-bbx-price-was]');
    var priceSaveEl = root.querySelector('[data-bbx-price-save]');
    var ctaBtn = root.querySelector('[data-bbx-cta]');
    var ctaText = root.querySelector('[data-bbx-cta-text]');
    var main = root.querySelector('.bbx__main img');
    var thumbsContainer = root.querySelector('.bbx__thumbs');
    var thumbs = root.querySelectorAll('.bbx__thumb');
    var countEl = root.querySelector('[id^="bbx-count-"]');
    var prev = root.querySelector('[id^="bbx-prev-"]');
    var next = root.querySelector('[id^="bbx-next-"]');
    var mainBox = root.querySelector('.bbx__main');

    var qty = 1;
    var idx = 0;

    // ===== Initial selection state (from server-rendered .is-on classes) =====
    var selectedValues = [];
    for (var g = 0; g < optionGroups.length; g++){
      var group = optionGroups[g];
      var oIdx = parseInt(group.dataset.optionIdx, 10);
      var selectedBtn = group.querySelector('[data-value].is-on');
      selectedValues[oIdx] = selectedBtn ? selectedBtn.dataset.value : null;
    }

    function findVariant(sel){
      if (!variants.length) return null;
      // If no options at all (selectedValues empty), return first variant
      if (sel.length === 0) return variants[0];
      for (var i = 0; i < variants.length; i++){
        var v = variants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++){
          if (v.options[j] !== sel[j]){ match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function render(){
      var v = findVariant(selectedValues);

      // Update form variant ID
      if (v && variantIdInput) variantIdInput.value = String(v.id);

      // Update URL ?variant=ID
      if (v && window.history && window.history.replaceState){
        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(null, '', url);
        } catch(e){}
      }

      // Swap main image to variant's featured_image
      if (v && v.featured_image && main && main.src !== v.featured_image){
        main.src = v.featured_image;
        // Sync gallery idx to that image if it's in the thumb list
        for (var t = 0; t < thumbs.length; t++){
          if (thumbs[t].dataset.src === v.featured_image){
            idx = t;
            for (var tt = 0; tt < thumbs.length; tt++) thumbs[tt].classList.remove('is-on');
            thumbs[t].classList.add('is-on');
            if (countEl) countEl.textContent = (t+1) + ' / ' + thumbs.length;
            break;
          }
        }
      }

      // Update price + savings (multiply by qty)
      var price = v ? v.price : 0;
      var compare = v ? v.compare_at_price : 0;
      var total = price * qty;
      var totalCompare = compare * qty;

      if (priceNowEl) priceNowEl.textContent = fmt(total);

      if (priceWasEl){
        if (compare > price){
          priceWasEl.textContent = fmt(totalCompare);
          priceWasEl.style.display = '';
        } else {
          priceWasEl.textContent = '';
          priceWasEl.style.display = 'none';
        }
      }

      if (priceSaveEl){
        if (compare > price){
          var savings = Math.round((compare - price) / compare * 100);
          priceSaveEl.textContent = 'SAVE ' + savings + '%';
          priceSaveEl.style.display = '';
        } else {
          priceSaveEl.textContent = '';
          priceSaveEl.style.display = 'none';
        }
      }

      // Update CTA (state + label)
      var addLabel = root.dataset.ctaAdd || 'Add to Cart';
      var soldoutLabel = root.dataset.ctaSoldout || 'Sold Out';
      var unavailLabel = root.dataset.ctaUnavailable || 'Unavailable';

      var available = v && v.available;
      if (ctaBtn){
        if (!available){
          ctaBtn.classList.add('is-soldout');
          ctaBtn.disabled = true;
        } else {
          ctaBtn.classList.remove('is-soldout');
          ctaBtn.disabled = false;
        }
      }
      if (ctaText){
        if (!v){
          ctaText.textContent = unavailLabel;
        } else if (!v.available){
          ctaText.textContent = soldoutLabel;
        } else {
          ctaText.textContent = addLabel + ' · ' + fmt(total);
        }
      }

      // Update inline "selected value" display in each variant group label.
      // Prefer the button's friendly data-label (e.g. "2 Pouches"); fall back to the raw value.
      for (var i = 0; i < optionGroups.length; i++){
        var group = optionGroups[i];
        var dispEl = group.querySelector('[data-option-value-display]');
        var oIdx = parseInt(group.dataset.optionIdx, 10);
        if (dispEl){
          var selVal = selectedValues[oIdx];
          var lbl = selVal || '';
          if (selVal){
            var gBtns = group.querySelectorAll('[data-value]');
            for (var gb = 0; gb < gBtns.length; gb++){
              if (gBtns[gb].dataset.value === selVal){
                lbl = gBtns[gb].dataset.label || selVal;
                break;
              }
            }
          }
          dispEl.textContent = lbl;
        }
      }
    }

    // ===== Bind variant option clicks (swatches + pills) =====
    var optionBtns = root.querySelectorAll('[data-option-idx][data-value]');
    for (var k = 0; k < optionBtns.length; k++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (btn.classList.contains('is-unavailable')) return;
          var oIdx = parseInt(btn.dataset.optionIdx, 10);
          var value = btn.dataset.value;
          selectedValues[oIdx] = value;
          // Toggle is-on among siblings of the same option group
          var siblings = root.querySelectorAll('[data-option-idx="' + oIdx + '"][data-value]');
          for (var s = 0; s < siblings.length; s++) siblings[s].classList.remove('is-on');
          btn.classList.add('is-on');
          render();
        });
      })(optionBtns[k]);
    }

    // ===== Quantity stepper =====
    function setQty(n){
      n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      qty = n;
      if (qtyDisplay) qtyDisplay.value = String(n);
      if (qtyHiddenInput) qtyHiddenInput.value = String(n);
      if (qtyMinus) qtyMinus.disabled = n <= 1;
      render();
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function(ev){ ev.preventDefault(); setQty(qty + 1); });
    if (qtyDisplay){
      qtyDisplay.addEventListener('change', function(){ setQty(qtyDisplay.value); });
      qtyDisplay.addEventListener('input', function(){
        var v = parseInt(qtyDisplay.value, 10);
        if (!isNaN(v)){ qty = Math.max(1, Math.min(99, v)); if (qtyHiddenInput) qtyHiddenInput.value = String(qty); render(); }
      });
    }

    // ===== Form submit guard =====
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form){
      form.addEventListener('submit', function(ev){
        if (ctaBtn && ctaBtn.disabled){ ev.preventDefault(); }
      });
    }

    // ===== Gallery =====
    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try { active.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); } catch(e){
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    for (var k2 = 0; k2 < thumbs.length; k2++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._bbxDragged) return;
          setSlide(i);
        });
      })(k2);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // ===== Drag-to-scroll on thumb strip (desktop) =====
    if (thumbsContainer && thumbs.length > 1){
      var tDown=false, tStartX=0, tStartScroll=0, tMoved=false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        tDown = true; tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._bbxDragged = false;
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          tMoved = true;
          thumbsContainer._bbxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          setTimeout(function(){ thumbsContainer._bbxDragged = false; }, 100);
        } else {
          thumbsContainer._bbxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){ tDown = false; thumbsContainer._bbxDragged = false; }
      });
    }

    // ===== Main image swipe (touch + mouse drag) =====
    if (mainBox && thumbs.length > 1){
      var sx=0, sy=0, swiping=false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, {passive:true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive:true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive:true});

      var mx=0, my=0, mdown=false, mmoved=false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true; mmoved = false; mx = e.clientX; my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    setQty(1);
    render();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waterfilter-buybox"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAll(scope){
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.querySelectorAll('.wfx');
    for (var i = 0; i < sections.length; i++){
      var el = sections[i];
      if (el.dataset.wfxInit === '1') continue;
      el.dataset.wfxInit = '1';
      try { initSection(el); } catch (e) { /* swallow — never break page */ console && console.warn && console.warn('[wfx]', e); }
    }
  }

  function initSection(root){
    var fmt = function(n){ return '$' + (n/100).toFixed(2); };

    var plan = root.dataset.defaultPlan || 'once';
    var qty  = parseInt(root.dataset.defaultQty || '2', 10);
    if (isNaN(qty)) qty = 2;

    var planCards = root.querySelectorAll('.wfx__plan-card');
    var qtyRows   = root.querySelectorAll('.wfx__qty-row');
    var qtyInput  = root.querySelector('input[name="quantity"]');
    var planInput = root.querySelector('input[name="selling_plan"]');
    var ctaText   = root.querySelector('[id^="wfx-cta-text-"]');
    var ctaBtn    = root.querySelector('.wfx__cta');
    var ctaSub    = root.querySelector('[id^="wfx-cta-sub-"]');
    var available = root.dataset.available !== '0';
    var qtyExtra2 = root.querySelector('.wfx__qty-row[data-qty="2"] .wfx__qty-extra');
    var qtyMetas  = root.querySelectorAll('.wfx__qty-meta');
    var vipChip   = root.querySelector('.wfx__vip-chip');
    var vipUnitEl = root.querySelector('[id^="wfx-vip-unit-"]');
    var vipTotalEl= root.querySelector('[id^="wfx-vip-total-"]');

    function getActiveQtyRow(){
      return root.querySelector('.wfx__qty-row.is-on') || qtyRows[0];
    }

    function render(){
      // Plan cards
      for (var i = 0; i < planCards.length; i++){
        var pb = planCards[i];
        var pOn = pb.dataset.plan === plan;
        pb.classList.toggle('is-on', pOn);
        pb.setAttribute('aria-checked', pOn ? 'true' : 'false');
      }
      // Qty rows + dynamic prices
      for (var j = 0; j < qtyRows.length; j++){
        var b = qtyRows[j];
        var qOn = parseInt(b.dataset.qty, 10) === qty;
        b.classList.toggle('is-on', qOn);
        b.setAttribute('aria-checked', qOn ? 'true' : 'false');

        var oncePrice = parseInt(b.dataset.oncePrice, 10) || 0;
        var onceDisc  = parseInt(b.dataset.onceDisc, 10)  || 0;
        var subPrice  = parseInt(b.dataset.subPrice, 10)  || 0;
        var subDisc   = parseInt(b.dataset.subDisc, 10)   || 0;

        var price = (plan === 'sub' && subPrice > 0) ? subPrice : oncePrice;
        var disc  = (plan === 'sub' && subPrice > 0) ? subDisc  : onceDisc;

        var priceEl = b.querySelector('.wfx__qty-now');
        var saveEl  = b.querySelector('.wfx__qty-save');
        if (priceEl) priceEl.textContent = fmt(price);
        if (saveEl)  saveEl.textContent  = disc + '% OFF';
      }

      // Sub-only meta line under each qty name
      for (var m = 0; m < qtyMetas.length; m++){
        qtyMetas[m].style.display = (plan === 'sub') ? '' : 'none';
      }

      // Qty 2 extra-line text swap
      if (qtyExtra2){
        var subText  = qtyExtra2.getAttribute('data-extra-sub')  || 'Best balance of value + commitment';
        var onceText = qtyExtra2.getAttribute('data-extra-once') || 'Best value, no commitment';
        qtyExtra2.textContent = plan === 'sub' ? subText : onceText;
      }

      // Form inputs (this is what actually goes to cart)
      var activeRow = getActiveQtyRow();
      if (qtyInput) qtyInput.value = String(qty);
      if (planInput){
        if (plan === 'sub' && activeRow){
          planInput.value = activeRow.dataset.subPlan || '';
        } else {
          planInput.value = '';
        }
      }

      // CTA label + subline
      if (!activeRow) return;
      var aOnce = parseInt(activeRow.dataset.oncePrice, 10) || 0;
      var aSub  = parseInt(activeRow.dataset.subPrice, 10)  || 0;
      var unit  = (plan === 'sub' && aSub > 0) ? aSub : aOnce;
      var totalCents = unit * qty;
      var onceLabel = root.dataset.ctaOnce || 'Add to Cart';
      var subLabel  = root.dataset.ctaSub  || 'Start Now';
      var soldoutLabel = root.dataset.ctaSoldout || 'Sold Out';
      if (ctaBtn){
        ctaBtn.classList.toggle('is-soldout', !available);
        ctaBtn.disabled = !available;
      }
      if (ctaText){
        if (!available){
          ctaText.textContent = soldoutLabel;
        } else {
          ctaText.textContent = (plan === 'sub' ? subLabel : onceLabel) + ' · ' + fmt(totalCents);
        }
      }
      if (ctaSub){
        var onceSubText = root.dataset.ctasubOnce || 'One-time purchase — no Auto-Ship';
        var subSubText  = root.dataset.ctasubSub  || 'Auto-Ship: filter refills every 12 months · Cancel anytime';
        ctaSub.textContent = (plan === 'sub') ? subSubText : onceSubText;
      }

      // VIP chip — % off the currently selected unit price
      if (vipChip && vipUnitEl && vipTotalEl){
        var vipPct  = parseFloat(vipChip.dataset.vipPct) || 20;
        var vipUnit = Math.round(unit * (100 - vipPct) / 100);
        vipUnitEl.textContent  = fmt(vipUnit);
        vipTotalEl.textContent = fmt(vipUnit * qty);
        /* at qty 1 the total equals the unit price — saying it twice reads as a bug */
        var vipTotalPart = vipChip.querySelector('.wfx__vip-total-part');
        if (vipTotalPart) vipTotalPart.hidden = (qty === 1);
      }
    }

    // Click bindings — capture closure on each button
    for (var p = 0; p < planCards.length; p++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          plan = btn.dataset.plan;
          render();
        });
      })(planCards[p]);
    }
    for (var q = 0; q < qtyRows.length; q++){
      (function(btn){
        btn.addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var nq = parseInt(btn.dataset.qty, 10);
          if (!isNaN(nq)) qty = nq;
          render();
        });
      })(qtyRows[q]);
    }

    // Gallery
    var mainBox = root.querySelector('.wfx__main');
    var main = root.querySelector('.wfx__main img');
    var countEl = root.querySelector('[id^="wfx-count-"]');
    var thumbsContainer = root.querySelector('.wfx__thumbs');
    var thumbs = root.querySelectorAll('.wfx__thumb');
    var prev = root.querySelector('[id^="wfx-prev-"]');
    var next = root.querySelector('[id^="wfx-next-"]');
    var idx = 0;

    function setSlide(n){
      if (!thumbs.length) return;
      var len = thumbs.length;
      // True positive modulo — handles negatives and wraps cleanly in both directions
      idx = ((n % len) + len) % len;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.remove('is-on');
      thumbs[idx].classList.add('is-on');
      var src = thumbs[idx].dataset.src;
      if (main && src) main.src = src;
      if (countEl) countEl.textContent = (idx+1) + ' / ' + thumbs.length;
      // Scroll active thumb into view (smooth animation)
      var active = thumbs[idx];
      if (active && active.scrollIntoView){
        try {
          active.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        } catch (e) {
          // Older Safari fallback
          if (thumbsContainer){
            var offset = active.offsetLeft - (thumbsContainer.clientWidth - active.offsetWidth) / 2;
            thumbsContainer.scrollLeft = Math.max(0, offset);
          }
        }
      }
    }
    // Thumb click — guarded against drag-clicks
    for (var k = 0; k < thumbs.length; k++){
      (function(i){
        thumbs[i].addEventListener('click', function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          if (thumbsContainer && thumbsContainer._wfxDragged) return;
          setSlide(i);
        });
      })(k);
    }
    if (prev) prev.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx-1); });
    if (next) next.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); setSlide(idx+1); });

    // Drag-to-scroll on the thumb strip (mouse on desktop; touch is handled natively by overflow-x:auto)
    // CRITICAL: do NOT call preventDefault or add is-dragging class on mousedown alone — that breaks tap-to-select.
    // Only treat it as a drag once movement actually exceeds the threshold.
    if (thumbsContainer && thumbs.length > 1){
      var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
      thumbsContainer.addEventListener('mousedown', function(e){
        if (e.button !== 0) return; // primary button only
        tDown = true;
        tMoved = false;
        tStartX = e.pageX;
        tStartScroll = thumbsContainer.scrollLeft;
        thumbsContainer._wfxDragged = false;
        // Intentionally NO preventDefault / NO is-dragging class here.
      });
      document.addEventListener('mousemove', function(e){
        if (!tDown) return;
        var dx = e.pageX - tStartX;
        if (!tMoved && Math.abs(dx) > 4){
          // Promote to a real drag — now block selection and disable child pointer events
          tMoved = true;
          thumbsContainer._wfxDragged = true;
          thumbsContainer.classList.add('is-dragging');
        }
        if (tMoved){
          e.preventDefault();
          thumbsContainer.scrollLeft = tStartScroll - dx;
        }
      });
      function endDrag(){
        if (!tDown) return;
        tDown = false;
        var wasDrag = tMoved;
        tMoved = false;
        thumbsContainer.classList.remove('is-dragging');
        if (wasDrag){
          // Swallow the trailing click that fires after a real drag
          setTimeout(function(){ thumbsContainer._wfxDragged = false; }, 100);
        } else {
          thumbsContainer._wfxDragged = false;
        }
      }
      document.addEventListener('mouseup', endDrag);
      thumbsContainer.addEventListener('mouseleave', function(){
        if (tDown && !tMoved){
          // Pointer left container before any drag movement — reset cleanly so taps still work
          tDown = false;
          thumbsContainer._wfxDragged = false;
        }
      });
    }

    // Touch swipe on main image — horizontal swipe navigates with endless loop
    if (mainBox && thumbs.length > 1){
      var sx = 0, sy = 0, swiping = false;
      mainBox.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, {passive: true});
      mainBox.addEventListener('touchend', function(e){
        if (!swiping) return;
        swiping = false;
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        // Only register as a swipe if mostly horizontal and crosses threshold
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      }, {passive: true});
      mainBox.addEventListener('touchcancel', function(){ swiping = false; }, {passive: true});

      // Mouse drag swipe for desktop (pointer events not used to keep iOS Safari happy)
      var mx = 0, my = 0, mdown = false, mmoved = false;
      mainBox.addEventListener('mousedown', function(e){
        mdown = true;
        mmoved = false;
        mx = e.clientX;
        my = e.clientY;
      });
      mainBox.addEventListener('mousemove', function(e){
        if (!mdown) return;
        if (Math.abs(e.clientX - mx) > 5) mmoved = true;
      });
      mainBox.addEventListener('mouseup', function(e){
        if (!mdown) return;
        mdown = false;
        if (!mmoved) return;
        var dx = e.clientX - mx;
        var dy = e.clientY - my;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          setSlide(idx + (dx < 0 ? 1 : -1));
        }
      });
      mainBox.addEventListener('mouseleave', function(){ mdown = false; mmoved = false; });
      // Prevent native image drag from interfering
      mainBox.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }

    render();
  }

  // Boot once DOM is ready (handles both early and late script loads)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAll(e.target); } else { initAll(); }
  });
})();

/* ===== $67 explainer tab — self-initializing, independent of which .wfx bundle owns initSection ===== */
(function(){
  function initDeal(tab){
    if (tab.dataset.deal67Init === '1') return;
    tab.dataset.deal67Init = '1';
    var section = tab.closest('.wfx');
    if (!section) return;
    var planSub  = section.querySelector('.wfx__plan-card[data-plan="sub"]');
    var planOnce = section.querySelector('.wfx__plan-card[data-plan="once"]');
    var qty3     = section.querySelector('.wfx__qty-row[data-qty="3"]');
    var setBtn   = tab.querySelector('.wfx__deal67-set');
    var vipChip  = section.querySelector('.wfx__vip-chip');
    var ctaSub   = section.querySelector('[id^="wfx-cta-sub-"]');
    var onceTxt  = section.dataset.ctasubOnce || 'One-time purchase — no Auto-Ship';
    var subTxt   = section.dataset.ctasubSub  || 'Auto-Ship: filter refills every 12 months · Cancel anytime';

    function sync(){
      var subOn = planSub ? planSub.classList.contains('is-on') : false;
      var q3On  = qty3 ? qty3.classList.contains('is-on') : false;
      var all = subOn && q3On;
      tab.classList.toggle('is-selected', all);
      if (setBtn) setBtn.hidden = all;
      if (ctaSub) ctaSub.textContent = subOn ? subTxt : onceTxt;
    }
    function pulseChip(){
      if (!vipChip) return;
      vipChip.classList.remove('wfx__vip-pulse');
      void vipChip.offsetWidth;
      vipChip.classList.add('wfx__vip-pulse');
    }
    if (setBtn){
      setBtn.addEventListener('click', function(ev){
        ev.preventDefault();
        if (planSub && !planSub.classList.contains('is-on')) planSub.click();
        if (qty3 && !qty3.classList.contains('is-on')) qty3.click();
        pulseChip();
      });
    }
    if (window.MutationObserver){
      var mo = new MutationObserver(function(){ sync(); });
      var targets = [planSub, planOnce, qty3];
      for (var i = 0; i < targets.length; i++){
        if (targets[i]) mo.observe(targets[i], {attributes: true, attributeFilter: ['class', 'aria-checked']});
      }
    }
    sync();
  }
  function initAllDeals(scope){
    var root = scope && scope.querySelector ? scope : document;
    var tabs = root.querySelectorAll('.wfx__deal67');
    for (var i = 0; i < tabs.length; i++){
      try { initDeal(tabs[i]); } catch (e) { console && console.warn && console.warn('[wfx-deal67]', e); }
    }
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAllDeals(); });
  } else {
    initAllDeals();
  }
  document.addEventListener('shopify:section:load', function(e){
    if (e && e.target){ initAllDeals(e.target); } else { initAllDeals(); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
